// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v7.34.1
// source: flows.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { EntityCreate } from "./entities";
import {
  ErrorsUpdate,
  FunctionCreateFunction,
  FunctionCreateLatencyControl,
  FunctionError,
  FunctionLatencyControl,
  FunctionParameter,
  FunctionParameterUpdate,
  FunctionUpdateLatencyControl,
  ParametersUpdate,
} from "./functions";
import { Timestamp } from "./google/protobuf/timestamp";
import { HandoffCreate } from "./handoff";
import { SMSCreateTemplate } from "./sms";
import { VariantCreateAttribute } from "./variant";

export const protobufPackage = "flows";

export interface Flow {
  id: string;
  name: string;
  description: string;
  createdAt: Date | undefined;
  createdBy: string;
  updatedAt: Date | undefined;
  updatedBy: string;
  startStepId: string;
  transitionFunctions: TransitionFunction[];
  /** @deprecated */
  steps: AdvancedStep[];
  /** @deprecated */
  noCodeSteps: DefaultStep[];
  /** TODO: rename this to just steps at some point for clarity */
  flowSteps: Step[];
}

export interface Flows {
  flows: Flow[];
}

export interface AdvancedStep {
  id: string;
  name: string;
  prompt: string;
  createdAt: Date | undefined;
  createdBy: string;
  updatedAt: Date | undefined;
  updatedBy: string;
  position: StepPosition | undefined;
  asrBiasing: StepAsrConfig | undefined;
  dtmfConfig: StepDtmfConfig | undefined;
  references: StepReferences | undefined;
}

export interface DefaultStep {
  id: string;
  name: string;
  prompt: string;
  createdAt: Date | undefined;
  createdBy: string;
  updatedAt: Date | undefined;
  updatedBy: string;
  position: StepPosition | undefined;
  references: NoCodeStepReferences | undefined;
  conditions: Condition[];
}

export interface FunctionStep {
  id: string;
  name: string;
  position: StepPosition | undefined;
  function: FunctionStepDefinition | undefined;
  conditions: Condition[];
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
  updatedBy: string;
  createdBy: string;
}

export interface Step {
  step: { $case: "advancedStep"; value: AdvancedStep } | { $case: "defaultStep"; value: DefaultStep } | {
    $case: "functionStep";
    value: FunctionStep;
  } | undefined;
}

export interface StepReferences {
  sms: { [key: string]: boolean };
  handoff: { [key: string]: boolean };
  attributes: { [key: string]: boolean };
  transitionFunctions: { [key: string]: boolean };
  globalFunctions: { [key: string]: boolean };
  entities: { [key: string]: boolean };
  variables: { [key: string]: boolean };
}

export interface StepReferences_SmsEntry {
  key: string;
  value: boolean;
}

export interface StepReferences_HandoffEntry {
  key: string;
  value: boolean;
}

export interface StepReferences_AttributesEntry {
  key: string;
  value: boolean;
}

export interface StepReferences_TransitionFunctionsEntry {
  key: string;
  value: boolean;
}

export interface StepReferences_GlobalFunctionsEntry {
  key: string;
  value: boolean;
}

export interface StepReferences_EntitiesEntry {
  key: string;
  value: boolean;
}

export interface StepReferences_VariablesEntry {
  key: string;
  value: boolean;
}

export interface NoCodeStepReferences {
  entities: { [key: string]: boolean };
  attributes: { [key: string]: boolean };
  variables: { [key: string]: boolean };
  /** Entities maintained independently in the UI, not directly tied to prompt usage */
  extractedEntities: { [key: string]: boolean };
}

export interface NoCodeStepReferences_EntitiesEntry {
  key: string;
  value: boolean;
}

export interface NoCodeStepReferences_AttributesEntry {
  key: string;
  value: boolean;
}

export interface NoCodeStepReferences_VariablesEntry {
  key: string;
  value: boolean;
}

export interface NoCodeStepReferences_ExtractedEntitiesEntry {
  key: string;
  value: boolean;
}

export interface TransitionFunctionReferences {
  flowSteps: { [key: string]: boolean };
  variables: { [key: string]: boolean };
}

export interface TransitionFunctionReferences_FlowStepsEntry {
  key: string;
  value: boolean;
}

export interface TransitionFunctionReferences_VariablesEntry {
  key: string;
  value: boolean;
}

export interface TransitionFunction {
  id: string;
  name: string;
  description: string;
  parameters: FunctionParameter[];
  code: string;
  errors: FunctionError[];
  latencyControl: FunctionLatencyControl | undefined;
  createdAt: Date | undefined;
  createdBy: string;
  updatedAt: Date | undefined;
  updatedBy: string;
  archived: boolean;
  references: TransitionFunctionReferences | undefined;
}

export interface Condition {
  id: string;
  config:
    | { $case: "exitFlowCondition"; value: ExitFlowCondition }
    | { $case: "stepCondition"; value: AdvancedStepCondition }
    | { $case: "noCodeStepCondition"; value: NoCodeStepCondition }
    | { $case: "functionStepCondition"; value: FunctionStepCondition }
    | undefined;
}

export interface ConditionDetails {
  label: string;
  /** optional since we can create the condition by dragging arrow */
  description?: string | undefined;
  requiredEntities: string[];
  position:
    | StepPosition
    | undefined;
  /** ingress positions can be one of left, right, bottom */
  ingressPosition: string;
}

export interface ExitFlowCondition {
  details: ConditionDetails | undefined;
  exitFlowPosition: StepPosition | undefined;
}

export interface AdvancedStepCondition {
  details: ConditionDetails | undefined;
  childStepId: string;
}

export interface NoCodeStepCondition {
  details: ConditionDetails | undefined;
  childStepId: string;
}

export interface FunctionStepCondition {
  details: ConditionDetails | undefined;
  childStepId: string;
}

export interface StepPosition {
  x: number;
  y: number;
}

export interface StepAsrConfig {
  alphanumeric: boolean;
  nameSpelling: boolean;
  numeric: boolean;
  partySize: boolean;
  preciseDate: boolean;
  relativeDate: boolean;
  singleNumber: boolean;
  time: boolean;
  yesNo: boolean;
  address: boolean;
  customKeywords: string[];
  isEnabled: boolean;
}

export interface StepDtmfConfig {
  isEnabled: boolean;
  interDigitTimeout: number;
  maxDigits: number;
  endKey: string;
  collectWhileAgentSpeaking: boolean;
  isPii: boolean;
}

export interface FlowCreateFlow {
  id: string;
  name: string;
  description: string;
  startStepId: string;
  steps: CreateAdvancedStep[];
  transitionFunctions: TransitionFunctionCreateTransitionFunction[];
  noCodeSteps: CreateNoCodeStep[];
}

export interface FlowUpdateFlow {
  flowId: string;
  name?: string | undefined;
  description?: string | undefined;
  startStepId?: string | undefined;
  oldFlowName?: string | undefined;
}

export interface FlowDeleteFlow {
  flowId: string;
}

export interface FlowImportFlow {
  flowId: string;
  steps: ImportFlowStep[];
  transitionFunctions: TransitionFunctionCreateTransitionFunction[];
  globalFunctions: FunctionCreateFunction[];
  handoffs: HandoffCreate[];
  sms: SMSCreateTemplate[];
  attributes: VariantCreateAttribute[];
  noCodeSteps: ImportNoCodeStep[];
  entities: EntityCreate[];
}

export interface FlowCreateStep {
  flowId: string;
  step: CreateAdvancedStep | undefined;
}

export interface FlowUpdateStep {
  flowId: string;
  step: UpdateAdvancedStep | undefined;
}

export interface FlowDeleteStep {
  flowId: string;
  stepId: string;
}

export interface CreateAdvancedStep {
  id: string;
  name: string;
  prompt: string;
  position: StepPosition | undefined;
  references: StepReferences | undefined;
  asrBiasing?: StepAsrConfig | undefined;
  dtmfConfig?: StepDtmfConfig | undefined;
}

export interface UpdateAdvancedStep {
  id: string;
  name?: string | undefined;
  prompt?: string | undefined;
  references?: StepReferences | undefined;
}

export interface ImportFlowStep {
  id: string;
  name: string;
  prompt: string;
  position: StepPosition | undefined;
  asrBiasing: StepAsrConfig | undefined;
  dtmfConfig: StepDtmfConfig | undefined;
  references: StepReferences | undefined;
}

export interface FlowUpdateStepAsrConfig {
  flowId: string;
  stepId: string;
  asrBiasing: StepAsrConfigUpdate | undefined;
}

export interface StepAsrConfigUpdate {
  alphanumeric?: boolean | undefined;
  nameSpelling?: boolean | undefined;
  numeric?: boolean | undefined;
  partySize?: boolean | undefined;
  preciseDate?: boolean | undefined;
  relativeDate?: boolean | undefined;
  singleNumber?: boolean | undefined;
  time?: boolean | undefined;
  yesNo?: boolean | undefined;
  address?: boolean | undefined;
  customKeywords?: UpdateAsrKeywords | undefined;
  isEnabled?: boolean | undefined;
}

export interface UpdateAsrKeywords {
  customKeywords: string[];
}

export interface FlowUpdateStepDtmfConfig {
  flowId: string;
  stepId: string;
  dtmfConfig: StepDtmfConfigUpdate | undefined;
}

export interface StepDtmfConfigUpdate {
  isEnabled?: boolean | undefined;
  interDigitTimeout?: number | undefined;
  maxDigits?: number | undefined;
  endKey?: string | undefined;
  collectWhileAgentSpeaking?: boolean | undefined;
  isPii?: boolean | undefined;
}

export interface FlowUpdateStepPosition {
  flowId: string;
  positionUpdate: StepPositionUpdate | undefined;
}

export interface FlowUpdateStepPositions {
  flowId: string;
  newPositions: StepPositionUpdate[];
}

export interface StepPositionUpdate {
  stepId: string;
  newPosition: StepPosition | undefined;
}

export interface MoveFlowComponent {
  flowId: string;
  positionDetail: FlowPositionDetail | undefined;
}

export interface MoveFlowComponents {
  flowId: string;
  positionDetails: FlowPositionDetail[];
}

export interface FlowPositionDetail {
  detail:
    | { $case: "flowStep"; value: FlowStepPositionDetails }
    | { $case: "noCodeStep"; value: NoCodeStepPositionDetail }
    | { $case: "noCodeStepCondition"; value: NoCodeStepConditionPositionDetail }
    | { $case: "noCodeStepConditionExitFlow"; value: NoCodeStepExitFlowPositionDetail }
    | { $case: "functionStep"; value: FunctionStepPositionDetail }
    | { $case: "functionStepCondition"; value: FunctionStepConditionPositionDetail }
    | { $case: "functionStepConditionExitFlow"; value: FunctionStepExitFlowPositionDetail }
    | undefined;
}

export interface FlowStepPositionDetails {
  stepId: string;
  newPosition: StepPosition | undefined;
}

export interface NoCodeStepPositionDetail {
  stepId: string;
  newPosition: StepPosition | undefined;
}

export interface NoCodeStepConditionPositionDetail {
  stepId: string;
  conditionId: string;
  newPosition: StepPosition | undefined;
}

export interface NoCodeStepExitFlowPositionDetail {
  stepId: string;
  conditionId: string;
  newPosition: StepPosition | undefined;
}

export interface FunctionStepPositionDetail {
  stepId: string;
  newPosition: StepPosition | undefined;
}

export interface FunctionStepConditionPositionDetail {
  stepId: string;
  conditionId: string;
  newPosition: StepPosition | undefined;
}

export interface FunctionStepExitFlowPositionDetail {
  stepId: string;
  conditionId: string;
  newPosition: StepPosition | undefined;
}

export interface FlowCreateTransitionFunction {
  flowId: string;
  transitionFunction: TransitionFunctionCreateTransitionFunction | undefined;
}

export interface FlowUpdateTransitionFunction {
  flowId: string;
  transitionFunction: TransitionFunctionUpdateTransitionFunction | undefined;
}

export interface FlowUpdateTransitionFunctionLatencyControl {
  flowId: string;
  latencyControl: FunctionUpdateLatencyControl | undefined;
}

export interface FlowDeleteTransitionFunction {
  flowId: string;
  functionId: string;
}

export interface TransitionFunctionCreateTransitionFunction {
  id: string;
  name: string;
  description: string;
  parameters: FunctionParameterUpdate[];
  code: string;
  errors: FunctionError[];
  latencyControl?: FunctionCreateLatencyControl | undefined;
  references?: TransitionFunctionReferences | undefined;
  archived?: boolean | undefined;
}

export interface TransitionFunctionUpdateTransitionFunction {
  id: string;
  name?: string | undefined;
  description?: string | undefined;
  parameters?: ParametersUpdate | undefined;
  code?: string | undefined;
  errors?: ErrorsUpdate | undefined;
  references?: TransitionFunctionReferences | undefined;
}

export interface CreateNoCodeStep {
  flowId: string;
  stepId: string;
  name: string;
  prompt: string;
  position: StepPosition | undefined;
  references: NoCodeStepReferences | undefined;
}

export interface UpdateNoCodeStep {
  flowId: string;
  stepId: string;
  name?: string | undefined;
  prompt?: string | undefined;
  position?: StepPosition | undefined;
  references?: NoCodeStepReferences | undefined;
}

export interface DeleteNoCodeStep {
  flowId: string;
  stepId: string;
}

export interface UpdateNoCodeStepPosition {
  flowId: string;
  stepId: string;
  newPosition: StepPosition | undefined;
}

export interface ImportNoCodeStep {
  id: string;
  name: string;
  prompt: string;
  position: StepPosition | undefined;
  references: NoCodeStepReferences | undefined;
  conditions: Condition[];
}

export interface CreateNoCodeCondition {
  flowId: string;
  stepId: string;
  conditionId: string;
  config:
    | { $case: "exitFlowCondition"; value: ExitFlowCondition }
    | { $case: "stepCondition"; value: AdvancedStepCondition }
    | { $case: "noCodeStepCondition"; value: NoCodeStepCondition }
    | { $case: "functionStepCondition"; value: FunctionStepCondition }
    | undefined;
}

export interface UpdateNoCodeCondition {
  flowId: string;
  stepId: string;
  conditionId: string;
  config:
    | { $case: "exitFlowCondition"; value: ExitFlowCondition }
    | { $case: "stepCondition"; value: AdvancedStepCondition }
    | { $case: "noCodeStepCondition"; value: NoCodeStepCondition }
    | { $case: "functionStepCondition"; value: FunctionStepCondition }
    | undefined;
}

export interface DeleteNoCodeCondition {
  flowId: string;
  stepId: string;
  conditionId: string;
}

export interface UpdateNoCodeConditionPosition {
  flowId: string;
  stepId: string;
  conditionId: string;
  newPosition: StepPosition | undefined;
}

export interface UpdateNoCodeConditionExitFlowPosition {
  flowId: string;
  stepId: string;
  conditionId: string;
  newPosition: StepPosition | undefined;
}

export interface CreateStep {
  flowId: string;
  payload: { $case: "functionStep"; value: CreateFunctionStep } | undefined;
}

export interface UpdateStep {
  flowId: string;
  stepId: string;
  payload: { $case: "functionStep"; value: UpdateFunctionStep } | undefined;
}

export interface DeleteStep {
  flowId: string;
  stepId: string;
}

export interface CreateStepCondition {
  flowId: string;
  stepId: string;
  conditionId: string;
  config:
    | { $case: "exitFlowCondition"; value: ExitFlowCondition }
    | { $case: "stepCondition"; value: AdvancedStepCondition }
    | { $case: "noCodeStepCondition"; value: NoCodeStepCondition }
    | { $case: "functionStepCondition"; value: FunctionStepCondition }
    | undefined;
}

export interface UpdateStepCondition {
  flowId: string;
  stepId: string;
  conditionId: string;
  config:
    | { $case: "exitFlowCondition"; value: ExitFlowCondition }
    | { $case: "stepCondition"; value: AdvancedStepCondition }
    | { $case: "noCodeStepCondition"; value: NoCodeStepCondition }
    | { $case: "functionStepCondition"; value: FunctionStepCondition }
    | undefined;
}

export interface DeleteStepCondition {
  flowId: string;
  stepId: string;
  conditionId: string;
}

export interface UpdateStepConditionPosition {
  flowId: string;
  stepId: string;
  conditionId: string;
  newPosition: StepPosition | undefined;
}

/** --- Function Steps */
export interface FunctionStepDefinition {
  id: string;
  name: string;
  code: string;
  errors: FunctionError[];
  latencyControl: FunctionLatencyControl | undefined;
  createdAt: Date | undefined;
  createdBy: string;
  updatedAt: Date | undefined;
  updatedBy: string;
  archived: boolean;
}

export interface CreateFunctionStep {
  id: string;
  name: string;
  position: StepPosition | undefined;
  function: CreateFunctionStepDefinition | undefined;
}

export interface UpdateFunctionStep {
  name?: string | undefined;
  position?: StepPosition | undefined;
  function?: UpdateFunctionStepDefinition | undefined;
}

export interface CreateFunctionStepDefinition {
  id: string;
  name: string;
  code: string;
  errors: FunctionError[];
  latencyControl?: FunctionCreateLatencyControl | undefined;
}

export interface UpdateFunctionStepDefinition {
  description?: string | undefined;
  code?: string | undefined;
  errors?: ErrorsUpdate | undefined;
  archived?: boolean | undefined;
  latencyControl?: FunctionCreateLatencyControl | undefined;
}

function createBaseFlow(): Flow {
  return {
    id: "",
    name: "",
    description: "",
    createdAt: undefined,
    createdBy: "",
    updatedAt: undefined,
    updatedBy: "",
    startStepId: "",
    transitionFunctions: [],
    steps: [],
    noCodeSteps: [],
    flowSteps: [],
  };
}

export const Flow: MessageFns<Flow> = {
  encode(message: Flow, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(34).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(42).string(message.createdBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(50).fork()).join();
    }
    if (message.updatedBy !== "") {
      writer.uint32(58).string(message.updatedBy);
    }
    if (message.startStepId !== "") {
      writer.uint32(66).string(message.startStepId);
    }
    for (const v of message.transitionFunctions) {
      TransitionFunction.encode(v!, writer.uint32(82).fork()).join();
    }
    for (const v of message.steps) {
      AdvancedStep.encode(v!, writer.uint32(74).fork()).join();
    }
    for (const v of message.noCodeSteps) {
      DefaultStep.encode(v!, writer.uint32(90).fork()).join();
    }
    for (const v of message.flowSteps) {
      Step.encode(v!, writer.uint32(98).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Flow {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFlow();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.startStepId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.transitionFunctions.push(TransitionFunction.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.steps.push(AdvancedStep.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.noCodeSteps.push(DefaultStep.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.flowSteps.push(Step.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Flow {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
      startStepId: isSet(object.startStepId)
        ? globalThis.String(object.startStepId)
        : isSet(object.start_step_id)
        ? globalThis.String(object.start_step_id)
        : "",
      transitionFunctions: globalThis.Array.isArray(object?.transitionFunctions)
        ? object.transitionFunctions.map((e: any) => TransitionFunction.fromJSON(e))
        : globalThis.Array.isArray(object?.transition_functions)
        ? object.transition_functions.map((e: any) => TransitionFunction.fromJSON(e))
        : [],
      steps: globalThis.Array.isArray(object?.steps) ? object.steps.map((e: any) => AdvancedStep.fromJSON(e)) : [],
      noCodeSteps: globalThis.Array.isArray(object?.noCodeSteps)
        ? object.noCodeSteps.map((e: any) => DefaultStep.fromJSON(e))
        : globalThis.Array.isArray(object?.no_code_steps)
        ? object.no_code_steps.map((e: any) => DefaultStep.fromJSON(e))
        : [],
      flowSteps: globalThis.Array.isArray(object?.flowSteps)
        ? object.flowSteps.map((e: any) => Step.fromJSON(e))
        : globalThis.Array.isArray(object?.flow_steps)
        ? object.flow_steps.map((e: any) => Step.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Flow): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    if (message.startStepId !== "") {
      obj.startStepId = message.startStepId;
    }
    if (message.transitionFunctions?.length) {
      obj.transitionFunctions = message.transitionFunctions.map((e) => TransitionFunction.toJSON(e));
    }
    if (message.steps?.length) {
      obj.steps = message.steps.map((e) => AdvancedStep.toJSON(e));
    }
    if (message.noCodeSteps?.length) {
      obj.noCodeSteps = message.noCodeSteps.map((e) => DefaultStep.toJSON(e));
    }
    if (message.flowSteps?.length) {
      obj.flowSteps = message.flowSteps.map((e) => Step.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<Flow>): Flow {
    return Flow.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Flow>): Flow {
    const message = createBaseFlow();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? "";
    message.startStepId = object.startStepId ?? "";
    message.transitionFunctions = object.transitionFunctions?.map((e) => TransitionFunction.fromPartial(e)) || [];
    message.steps = object.steps?.map((e) => AdvancedStep.fromPartial(e)) || [];
    message.noCodeSteps = object.noCodeSteps?.map((e) => DefaultStep.fromPartial(e)) || [];
    message.flowSteps = object.flowSteps?.map((e) => Step.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFlows(): Flows {
  return { flows: [] };
}

export const Flows: MessageFns<Flows> = {
  encode(message: Flows, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.flows) {
      Flow.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Flows {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFlows();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flows.push(Flow.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Flows {
    return { flows: globalThis.Array.isArray(object?.flows) ? object.flows.map((e: any) => Flow.fromJSON(e)) : [] };
  },

  toJSON(message: Flows): unknown {
    const obj: any = {};
    if (message.flows?.length) {
      obj.flows = message.flows.map((e) => Flow.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<Flows>): Flows {
    return Flows.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Flows>): Flows {
    const message = createBaseFlows();
    message.flows = object.flows?.map((e) => Flow.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAdvancedStep(): AdvancedStep {
  return {
    id: "",
    name: "",
    prompt: "",
    createdAt: undefined,
    createdBy: "",
    updatedAt: undefined,
    updatedBy: "",
    position: undefined,
    asrBiasing: undefined,
    dtmfConfig: undefined,
    references: undefined,
  };
}

export const AdvancedStep: MessageFns<AdvancedStep> = {
  encode(message: AdvancedStep, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.prompt !== "") {
      writer.uint32(26).string(message.prompt);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(34).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(42).string(message.createdBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(50).fork()).join();
    }
    if (message.updatedBy !== "") {
      writer.uint32(58).string(message.updatedBy);
    }
    if (message.position !== undefined) {
      StepPosition.encode(message.position, writer.uint32(66).fork()).join();
    }
    if (message.asrBiasing !== undefined) {
      StepAsrConfig.encode(message.asrBiasing, writer.uint32(74).fork()).join();
    }
    if (message.dtmfConfig !== undefined) {
      StepDtmfConfig.encode(message.dtmfConfig, writer.uint32(82).fork()).join();
    }
    if (message.references !== undefined) {
      StepReferences.encode(message.references, writer.uint32(90).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdvancedStep {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdvancedStep();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.prompt = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.position = StepPosition.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.asrBiasing = StepAsrConfig.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.dtmfConfig = StepDtmfConfig.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.references = StepReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdvancedStep {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      prompt: isSet(object.prompt) ? globalThis.String(object.prompt) : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
      position: isSet(object.position) ? StepPosition.fromJSON(object.position) : undefined,
      asrBiasing: isSet(object.asrBiasing)
        ? StepAsrConfig.fromJSON(object.asrBiasing)
        : isSet(object.asr_biasing)
        ? StepAsrConfig.fromJSON(object.asr_biasing)
        : undefined,
      dtmfConfig: isSet(object.dtmfConfig)
        ? StepDtmfConfig.fromJSON(object.dtmfConfig)
        : isSet(object.dtmf_config)
        ? StepDtmfConfig.fromJSON(object.dtmf_config)
        : undefined,
      references: isSet(object.references) ? StepReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: AdvancedStep): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.prompt !== "") {
      obj.prompt = message.prompt;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    if (message.position !== undefined) {
      obj.position = StepPosition.toJSON(message.position);
    }
    if (message.asrBiasing !== undefined) {
      obj.asrBiasing = StepAsrConfig.toJSON(message.asrBiasing);
    }
    if (message.dtmfConfig !== undefined) {
      obj.dtmfConfig = StepDtmfConfig.toJSON(message.dtmfConfig);
    }
    if (message.references !== undefined) {
      obj.references = StepReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<AdvancedStep>): AdvancedStep {
    return AdvancedStep.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AdvancedStep>): AdvancedStep {
    const message = createBaseAdvancedStep();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.prompt = object.prompt ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? "";
    message.position = (object.position !== undefined && object.position !== null)
      ? StepPosition.fromPartial(object.position)
      : undefined;
    message.asrBiasing = (object.asrBiasing !== undefined && object.asrBiasing !== null)
      ? StepAsrConfig.fromPartial(object.asrBiasing)
      : undefined;
    message.dtmfConfig = (object.dtmfConfig !== undefined && object.dtmfConfig !== null)
      ? StepDtmfConfig.fromPartial(object.dtmfConfig)
      : undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? StepReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBaseDefaultStep(): DefaultStep {
  return {
    id: "",
    name: "",
    prompt: "",
    createdAt: undefined,
    createdBy: "",
    updatedAt: undefined,
    updatedBy: "",
    position: undefined,
    references: undefined,
    conditions: [],
  };
}

export const DefaultStep: MessageFns<DefaultStep> = {
  encode(message: DefaultStep, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.prompt !== "") {
      writer.uint32(26).string(message.prompt);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(34).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(42).string(message.createdBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(50).fork()).join();
    }
    if (message.updatedBy !== "") {
      writer.uint32(58).string(message.updatedBy);
    }
    if (message.position !== undefined) {
      StepPosition.encode(message.position, writer.uint32(66).fork()).join();
    }
    if (message.references !== undefined) {
      NoCodeStepReferences.encode(message.references, writer.uint32(74).fork()).join();
    }
    for (const v of message.conditions) {
      Condition.encode(v!, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DefaultStep {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDefaultStep();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.prompt = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.position = StepPosition.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.references = NoCodeStepReferences.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.conditions.push(Condition.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DefaultStep {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      prompt: isSet(object.prompt) ? globalThis.String(object.prompt) : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
      position: isSet(object.position) ? StepPosition.fromJSON(object.position) : undefined,
      references: isSet(object.references) ? NoCodeStepReferences.fromJSON(object.references) : undefined,
      conditions: globalThis.Array.isArray(object?.conditions)
        ? object.conditions.map((e: any) => Condition.fromJSON(e))
        : [],
    };
  },

  toJSON(message: DefaultStep): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.prompt !== "") {
      obj.prompt = message.prompt;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    if (message.position !== undefined) {
      obj.position = StepPosition.toJSON(message.position);
    }
    if (message.references !== undefined) {
      obj.references = NoCodeStepReferences.toJSON(message.references);
    }
    if (message.conditions?.length) {
      obj.conditions = message.conditions.map((e) => Condition.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<DefaultStep>): DefaultStep {
    return DefaultStep.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DefaultStep>): DefaultStep {
    const message = createBaseDefaultStep();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.prompt = object.prompt ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? "";
    message.position = (object.position !== undefined && object.position !== null)
      ? StepPosition.fromPartial(object.position)
      : undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? NoCodeStepReferences.fromPartial(object.references)
      : undefined;
    message.conditions = object.conditions?.map((e) => Condition.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFunctionStep(): FunctionStep {
  return {
    id: "",
    name: "",
    position: undefined,
    function: undefined,
    conditions: [],
    createdAt: undefined,
    updatedAt: undefined,
    updatedBy: "",
    createdBy: "",
  };
}

export const FunctionStep: MessageFns<FunctionStep> = {
  encode(message: FunctionStep, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.position !== undefined) {
      StepPosition.encode(message.position, writer.uint32(26).fork()).join();
    }
    if (message.function !== undefined) {
      FunctionStepDefinition.encode(message.function, writer.uint32(66).fork()).join();
    }
    for (const v of message.conditions) {
      Condition.encode(v!, writer.uint32(74).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(34).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(50).fork()).join();
    }
    if (message.updatedBy !== "") {
      writer.uint32(58).string(message.updatedBy);
    }
    if (message.createdBy !== "") {
      writer.uint32(42).string(message.createdBy);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionStep {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionStep();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.position = StepPosition.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.function = FunctionStepDefinition.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.conditions.push(Condition.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionStep {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      position: isSet(object.position) ? StepPosition.fromJSON(object.position) : undefined,
      function: isSet(object.function) ? FunctionStepDefinition.fromJSON(object.function) : undefined,
      conditions: globalThis.Array.isArray(object?.conditions)
        ? object.conditions.map((e: any) => Condition.fromJSON(e))
        : [],
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
    };
  },

  toJSON(message: FunctionStep): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.position !== undefined) {
      obj.position = StepPosition.toJSON(message.position);
    }
    if (message.function !== undefined) {
      obj.function = FunctionStepDefinition.toJSON(message.function);
    }
    if (message.conditions?.length) {
      obj.conditions = message.conditions.map((e) => Condition.toJSON(e));
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    return obj;
  },

  create(base?: DeepPartial<FunctionStep>): FunctionStep {
    return FunctionStep.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FunctionStep>): FunctionStep {
    const message = createBaseFunctionStep();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.position = (object.position !== undefined && object.position !== null)
      ? StepPosition.fromPartial(object.position)
      : undefined;
    message.function = (object.function !== undefined && object.function !== null)
      ? FunctionStepDefinition.fromPartial(object.function)
      : undefined;
    message.conditions = object.conditions?.map((e) => Condition.fromPartial(e)) || [];
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? "";
    message.createdBy = object.createdBy ?? "";
    return message;
  },
};

function createBaseStep(): Step {
  return { step: undefined };
}

export const Step: MessageFns<Step> = {
  encode(message: Step, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.step?.$case) {
      case "advancedStep":
        AdvancedStep.encode(message.step.value, writer.uint32(10).fork()).join();
        break;
      case "defaultStep":
        DefaultStep.encode(message.step.value, writer.uint32(18).fork()).join();
        break;
      case "functionStep":
        FunctionStep.encode(message.step.value, writer.uint32(26).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Step {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStep();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.step = { $case: "advancedStep", value: AdvancedStep.decode(reader, reader.uint32()) };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.step = { $case: "defaultStep", value: DefaultStep.decode(reader, reader.uint32()) };
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.step = { $case: "functionStep", value: FunctionStep.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Step {
    return {
      step: isSet(object.advancedStep)
        ? { $case: "advancedStep", value: AdvancedStep.fromJSON(object.advancedStep) }
        : isSet(object.advanced_step)
        ? { $case: "advancedStep", value: AdvancedStep.fromJSON(object.advanced_step) }
        : isSet(object.defaultStep)
        ? { $case: "defaultStep", value: DefaultStep.fromJSON(object.defaultStep) }
        : isSet(object.default_step)
        ? { $case: "defaultStep", value: DefaultStep.fromJSON(object.default_step) }
        : isSet(object.functionStep)
        ? { $case: "functionStep", value: FunctionStep.fromJSON(object.functionStep) }
        : isSet(object.function_step)
        ? { $case: "functionStep", value: FunctionStep.fromJSON(object.function_step) }
        : undefined,
    };
  },

  toJSON(message: Step): unknown {
    const obj: any = {};
    if (message.step?.$case === "advancedStep") {
      obj.advancedStep = AdvancedStep.toJSON(message.step.value);
    } else if (message.step?.$case === "defaultStep") {
      obj.defaultStep = DefaultStep.toJSON(message.step.value);
    } else if (message.step?.$case === "functionStep") {
      obj.functionStep = FunctionStep.toJSON(message.step.value);
    }
    return obj;
  },

  create(base?: DeepPartial<Step>): Step {
    return Step.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Step>): Step {
    const message = createBaseStep();
    switch (object.step?.$case) {
      case "advancedStep": {
        if (object.step?.value !== undefined && object.step?.value !== null) {
          message.step = { $case: "advancedStep", value: AdvancedStep.fromPartial(object.step.value) };
        }
        break;
      }
      case "defaultStep": {
        if (object.step?.value !== undefined && object.step?.value !== null) {
          message.step = { $case: "defaultStep", value: DefaultStep.fromPartial(object.step.value) };
        }
        break;
      }
      case "functionStep": {
        if (object.step?.value !== undefined && object.step?.value !== null) {
          message.step = { $case: "functionStep", value: FunctionStep.fromPartial(object.step.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseStepReferences(): StepReferences {
  return {
    sms: {},
    handoff: {},
    attributes: {},
    transitionFunctions: {},
    globalFunctions: {},
    entities: {},
    variables: {},
  };
}

export const StepReferences: MessageFns<StepReferences> = {
  encode(message: StepReferences, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.sms).forEach(([key, value]: [string, boolean]) => {
      StepReferences_SmsEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    globalThis.Object.entries(message.handoff).forEach(([key, value]: [string, boolean]) => {
      StepReferences_HandoffEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
    });
    globalThis.Object.entries(message.attributes).forEach(([key, value]: [string, boolean]) => {
      StepReferences_AttributesEntry.encode({ key: key as any, value }, writer.uint32(26).fork()).join();
    });
    globalThis.Object.entries(message.transitionFunctions).forEach(([key, value]: [string, boolean]) => {
      StepReferences_TransitionFunctionsEntry.encode({ key: key as any, value }, writer.uint32(34).fork()).join();
    });
    globalThis.Object.entries(message.globalFunctions).forEach(([key, value]: [string, boolean]) => {
      StepReferences_GlobalFunctionsEntry.encode({ key: key as any, value }, writer.uint32(42).fork()).join();
    });
    globalThis.Object.entries(message.entities).forEach(([key, value]: [string, boolean]) => {
      StepReferences_EntitiesEntry.encode({ key: key as any, value }, writer.uint32(50).fork()).join();
    });
    globalThis.Object.entries(message.variables).forEach(([key, value]: [string, boolean]) => {
      StepReferences_VariablesEntry.encode({ key: key as any, value }, writer.uint32(58).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StepReferences {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStepReferences();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = StepReferences_SmsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.sms[entry1.key] = entry1.value;
          }
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = StepReferences_HandoffEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.handoff[entry2.key] = entry2.value;
          }
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          const entry3 = StepReferences_AttributesEntry.decode(reader, reader.uint32());
          if (entry3.value !== undefined) {
            message.attributes[entry3.key] = entry3.value;
          }
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = StepReferences_TransitionFunctionsEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.transitionFunctions[entry4.key] = entry4.value;
          }
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          const entry5 = StepReferences_GlobalFunctionsEntry.decode(reader, reader.uint32());
          if (entry5.value !== undefined) {
            message.globalFunctions[entry5.key] = entry5.value;
          }
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          const entry6 = StepReferences_EntitiesEntry.decode(reader, reader.uint32());
          if (entry6.value !== undefined) {
            message.entities[entry6.key] = entry6.value;
          }
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          const entry7 = StepReferences_VariablesEntry.decode(reader, reader.uint32());
          if (entry7.value !== undefined) {
            message.variables[entry7.key] = entry7.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StepReferences {
    return {
      sms: isObject(object.sms)
        ? (globalThis.Object.entries(object.sms) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      handoff: isObject(object.handoff)
        ? (globalThis.Object.entries(object.handoff) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      attributes: isObject(object.attributes)
        ? (globalThis.Object.entries(object.attributes) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      transitionFunctions: isObject(object.transitionFunctions)
        ? (globalThis.Object.entries(object.transitionFunctions) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : isObject(object.transition_functions)
        ? (globalThis.Object.entries(object.transition_functions) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      globalFunctions: isObject(object.globalFunctions)
        ? (globalThis.Object.entries(object.globalFunctions) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : isObject(object.global_functions)
        ? (globalThis.Object.entries(object.global_functions) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      entities: isObject(object.entities)
        ? (globalThis.Object.entries(object.entities) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      variables: isObject(object.variables)
        ? (globalThis.Object.entries(object.variables) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: StepReferences): unknown {
    const obj: any = {};
    if (message.sms) {
      const entries = globalThis.Object.entries(message.sms) as [string, boolean][];
      if (entries.length > 0) {
        obj.sms = {};
        entries.forEach(([k, v]) => {
          obj.sms[k] = v;
        });
      }
    }
    if (message.handoff) {
      const entries = globalThis.Object.entries(message.handoff) as [string, boolean][];
      if (entries.length > 0) {
        obj.handoff = {};
        entries.forEach(([k, v]) => {
          obj.handoff[k] = v;
        });
      }
    }
    if (message.attributes) {
      const entries = globalThis.Object.entries(message.attributes) as [string, boolean][];
      if (entries.length > 0) {
        obj.attributes = {};
        entries.forEach(([k, v]) => {
          obj.attributes[k] = v;
        });
      }
    }
    if (message.transitionFunctions) {
      const entries = globalThis.Object.entries(message.transitionFunctions) as [string, boolean][];
      if (entries.length > 0) {
        obj.transitionFunctions = {};
        entries.forEach(([k, v]) => {
          obj.transitionFunctions[k] = v;
        });
      }
    }
    if (message.globalFunctions) {
      const entries = globalThis.Object.entries(message.globalFunctions) as [string, boolean][];
      if (entries.length > 0) {
        obj.globalFunctions = {};
        entries.forEach(([k, v]) => {
          obj.globalFunctions[k] = v;
        });
      }
    }
    if (message.entities) {
      const entries = globalThis.Object.entries(message.entities) as [string, boolean][];
      if (entries.length > 0) {
        obj.entities = {};
        entries.forEach(([k, v]) => {
          obj.entities[k] = v;
        });
      }
    }
    if (message.variables) {
      const entries = globalThis.Object.entries(message.variables) as [string, boolean][];
      if (entries.length > 0) {
        obj.variables = {};
        entries.forEach(([k, v]) => {
          obj.variables[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<StepReferences>): StepReferences {
    return StepReferences.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StepReferences>): StepReferences {
    const message = createBaseStepReferences();
    message.sms = (globalThis.Object.entries(object.sms ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.handoff = (globalThis.Object.entries(object.handoff ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.attributes = (globalThis.Object.entries(object.attributes ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.transitionFunctions = (globalThis.Object.entries(object.transitionFunctions ?? {}) as [string, boolean][])
      .reduce((acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      }, {});
    message.globalFunctions = (globalThis.Object.entries(object.globalFunctions ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.entities = (globalThis.Object.entries(object.entities ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.variables = (globalThis.Object.entries(object.variables ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseStepReferences_SmsEntry(): StepReferences_SmsEntry {
  return { key: "", value: false };
}

export const StepReferences_SmsEntry: MessageFns<StepReferences_SmsEntry> = {
  encode(message: StepReferences_SmsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StepReferences_SmsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStepReferences_SmsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StepReferences_SmsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: StepReferences_SmsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<StepReferences_SmsEntry>): StepReferences_SmsEntry {
    return StepReferences_SmsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StepReferences_SmsEntry>): StepReferences_SmsEntry {
    const message = createBaseStepReferences_SmsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseStepReferences_HandoffEntry(): StepReferences_HandoffEntry {
  return { key: "", value: false };
}

export const StepReferences_HandoffEntry: MessageFns<StepReferences_HandoffEntry> = {
  encode(message: StepReferences_HandoffEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StepReferences_HandoffEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStepReferences_HandoffEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StepReferences_HandoffEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: StepReferences_HandoffEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<StepReferences_HandoffEntry>): StepReferences_HandoffEntry {
    return StepReferences_HandoffEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StepReferences_HandoffEntry>): StepReferences_HandoffEntry {
    const message = createBaseStepReferences_HandoffEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseStepReferences_AttributesEntry(): StepReferences_AttributesEntry {
  return { key: "", value: false };
}

export const StepReferences_AttributesEntry: MessageFns<StepReferences_AttributesEntry> = {
  encode(message: StepReferences_AttributesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StepReferences_AttributesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStepReferences_AttributesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StepReferences_AttributesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: StepReferences_AttributesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<StepReferences_AttributesEntry>): StepReferences_AttributesEntry {
    return StepReferences_AttributesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StepReferences_AttributesEntry>): StepReferences_AttributesEntry {
    const message = createBaseStepReferences_AttributesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseStepReferences_TransitionFunctionsEntry(): StepReferences_TransitionFunctionsEntry {
  return { key: "", value: false };
}

export const StepReferences_TransitionFunctionsEntry: MessageFns<StepReferences_TransitionFunctionsEntry> = {
  encode(message: StepReferences_TransitionFunctionsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StepReferences_TransitionFunctionsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStepReferences_TransitionFunctionsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StepReferences_TransitionFunctionsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: StepReferences_TransitionFunctionsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<StepReferences_TransitionFunctionsEntry>): StepReferences_TransitionFunctionsEntry {
    return StepReferences_TransitionFunctionsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StepReferences_TransitionFunctionsEntry>): StepReferences_TransitionFunctionsEntry {
    const message = createBaseStepReferences_TransitionFunctionsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseStepReferences_GlobalFunctionsEntry(): StepReferences_GlobalFunctionsEntry {
  return { key: "", value: false };
}

export const StepReferences_GlobalFunctionsEntry: MessageFns<StepReferences_GlobalFunctionsEntry> = {
  encode(message: StepReferences_GlobalFunctionsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StepReferences_GlobalFunctionsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStepReferences_GlobalFunctionsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StepReferences_GlobalFunctionsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: StepReferences_GlobalFunctionsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<StepReferences_GlobalFunctionsEntry>): StepReferences_GlobalFunctionsEntry {
    return StepReferences_GlobalFunctionsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StepReferences_GlobalFunctionsEntry>): StepReferences_GlobalFunctionsEntry {
    const message = createBaseStepReferences_GlobalFunctionsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseStepReferences_EntitiesEntry(): StepReferences_EntitiesEntry {
  return { key: "", value: false };
}

export const StepReferences_EntitiesEntry: MessageFns<StepReferences_EntitiesEntry> = {
  encode(message: StepReferences_EntitiesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StepReferences_EntitiesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStepReferences_EntitiesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StepReferences_EntitiesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: StepReferences_EntitiesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<StepReferences_EntitiesEntry>): StepReferences_EntitiesEntry {
    return StepReferences_EntitiesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StepReferences_EntitiesEntry>): StepReferences_EntitiesEntry {
    const message = createBaseStepReferences_EntitiesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseStepReferences_VariablesEntry(): StepReferences_VariablesEntry {
  return { key: "", value: false };
}

export const StepReferences_VariablesEntry: MessageFns<StepReferences_VariablesEntry> = {
  encode(message: StepReferences_VariablesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StepReferences_VariablesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStepReferences_VariablesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StepReferences_VariablesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: StepReferences_VariablesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<StepReferences_VariablesEntry>): StepReferences_VariablesEntry {
    return StepReferences_VariablesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StepReferences_VariablesEntry>): StepReferences_VariablesEntry {
    const message = createBaseStepReferences_VariablesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseNoCodeStepReferences(): NoCodeStepReferences {
  return { entities: {}, attributes: {}, variables: {}, extractedEntities: {} };
}

export const NoCodeStepReferences: MessageFns<NoCodeStepReferences> = {
  encode(message: NoCodeStepReferences, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.entities).forEach(([key, value]: [string, boolean]) => {
      NoCodeStepReferences_EntitiesEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    globalThis.Object.entries(message.attributes).forEach(([key, value]: [string, boolean]) => {
      NoCodeStepReferences_AttributesEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
    });
    globalThis.Object.entries(message.variables).forEach(([key, value]: [string, boolean]) => {
      NoCodeStepReferences_VariablesEntry.encode({ key: key as any, value }, writer.uint32(26).fork()).join();
    });
    globalThis.Object.entries(message.extractedEntities).forEach(([key, value]: [string, boolean]) => {
      NoCodeStepReferences_ExtractedEntitiesEntry.encode({ key: key as any, value }, writer.uint32(34).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NoCodeStepReferences {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNoCodeStepReferences();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = NoCodeStepReferences_EntitiesEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.entities[entry1.key] = entry1.value;
          }
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = NoCodeStepReferences_AttributesEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.attributes[entry2.key] = entry2.value;
          }
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          const entry3 = NoCodeStepReferences_VariablesEntry.decode(reader, reader.uint32());
          if (entry3.value !== undefined) {
            message.variables[entry3.key] = entry3.value;
          }
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = NoCodeStepReferences_ExtractedEntitiesEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.extractedEntities[entry4.key] = entry4.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NoCodeStepReferences {
    return {
      entities: isObject(object.entities)
        ? (globalThis.Object.entries(object.entities) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      attributes: isObject(object.attributes)
        ? (globalThis.Object.entries(object.attributes) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      variables: isObject(object.variables)
        ? (globalThis.Object.entries(object.variables) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      extractedEntities: isObject(object.extractedEntities)
        ? (globalThis.Object.entries(object.extractedEntities) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : isObject(object.extracted_entities)
        ? (globalThis.Object.entries(object.extracted_entities) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: NoCodeStepReferences): unknown {
    const obj: any = {};
    if (message.entities) {
      const entries = globalThis.Object.entries(message.entities) as [string, boolean][];
      if (entries.length > 0) {
        obj.entities = {};
        entries.forEach(([k, v]) => {
          obj.entities[k] = v;
        });
      }
    }
    if (message.attributes) {
      const entries = globalThis.Object.entries(message.attributes) as [string, boolean][];
      if (entries.length > 0) {
        obj.attributes = {};
        entries.forEach(([k, v]) => {
          obj.attributes[k] = v;
        });
      }
    }
    if (message.variables) {
      const entries = globalThis.Object.entries(message.variables) as [string, boolean][];
      if (entries.length > 0) {
        obj.variables = {};
        entries.forEach(([k, v]) => {
          obj.variables[k] = v;
        });
      }
    }
    if (message.extractedEntities) {
      const entries = globalThis.Object.entries(message.extractedEntities) as [string, boolean][];
      if (entries.length > 0) {
        obj.extractedEntities = {};
        entries.forEach(([k, v]) => {
          obj.extractedEntities[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<NoCodeStepReferences>): NoCodeStepReferences {
    return NoCodeStepReferences.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<NoCodeStepReferences>): NoCodeStepReferences {
    const message = createBaseNoCodeStepReferences();
    message.entities = (globalThis.Object.entries(object.entities ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.attributes = (globalThis.Object.entries(object.attributes ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.variables = (globalThis.Object.entries(object.variables ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.extractedEntities = (globalThis.Object.entries(object.extractedEntities ?? {}) as [string, boolean][])
      .reduce((acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      }, {});
    return message;
  },
};

function createBaseNoCodeStepReferences_EntitiesEntry(): NoCodeStepReferences_EntitiesEntry {
  return { key: "", value: false };
}

export const NoCodeStepReferences_EntitiesEntry: MessageFns<NoCodeStepReferences_EntitiesEntry> = {
  encode(message: NoCodeStepReferences_EntitiesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NoCodeStepReferences_EntitiesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNoCodeStepReferences_EntitiesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NoCodeStepReferences_EntitiesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: NoCodeStepReferences_EntitiesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<NoCodeStepReferences_EntitiesEntry>): NoCodeStepReferences_EntitiesEntry {
    return NoCodeStepReferences_EntitiesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<NoCodeStepReferences_EntitiesEntry>): NoCodeStepReferences_EntitiesEntry {
    const message = createBaseNoCodeStepReferences_EntitiesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseNoCodeStepReferences_AttributesEntry(): NoCodeStepReferences_AttributesEntry {
  return { key: "", value: false };
}

export const NoCodeStepReferences_AttributesEntry: MessageFns<NoCodeStepReferences_AttributesEntry> = {
  encode(message: NoCodeStepReferences_AttributesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NoCodeStepReferences_AttributesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNoCodeStepReferences_AttributesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NoCodeStepReferences_AttributesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: NoCodeStepReferences_AttributesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<NoCodeStepReferences_AttributesEntry>): NoCodeStepReferences_AttributesEntry {
    return NoCodeStepReferences_AttributesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<NoCodeStepReferences_AttributesEntry>): NoCodeStepReferences_AttributesEntry {
    const message = createBaseNoCodeStepReferences_AttributesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseNoCodeStepReferences_VariablesEntry(): NoCodeStepReferences_VariablesEntry {
  return { key: "", value: false };
}

export const NoCodeStepReferences_VariablesEntry: MessageFns<NoCodeStepReferences_VariablesEntry> = {
  encode(message: NoCodeStepReferences_VariablesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NoCodeStepReferences_VariablesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNoCodeStepReferences_VariablesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NoCodeStepReferences_VariablesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: NoCodeStepReferences_VariablesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<NoCodeStepReferences_VariablesEntry>): NoCodeStepReferences_VariablesEntry {
    return NoCodeStepReferences_VariablesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<NoCodeStepReferences_VariablesEntry>): NoCodeStepReferences_VariablesEntry {
    const message = createBaseNoCodeStepReferences_VariablesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseNoCodeStepReferences_ExtractedEntitiesEntry(): NoCodeStepReferences_ExtractedEntitiesEntry {
  return { key: "", value: false };
}

export const NoCodeStepReferences_ExtractedEntitiesEntry: MessageFns<NoCodeStepReferences_ExtractedEntitiesEntry> = {
  encode(
    message: NoCodeStepReferences_ExtractedEntitiesEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NoCodeStepReferences_ExtractedEntitiesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNoCodeStepReferences_ExtractedEntitiesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NoCodeStepReferences_ExtractedEntitiesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: NoCodeStepReferences_ExtractedEntitiesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<NoCodeStepReferences_ExtractedEntitiesEntry>): NoCodeStepReferences_ExtractedEntitiesEntry {
    return NoCodeStepReferences_ExtractedEntitiesEntry.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<NoCodeStepReferences_ExtractedEntitiesEntry>,
  ): NoCodeStepReferences_ExtractedEntitiesEntry {
    const message = createBaseNoCodeStepReferences_ExtractedEntitiesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseTransitionFunctionReferences(): TransitionFunctionReferences {
  return { flowSteps: {}, variables: {} };
}

export const TransitionFunctionReferences: MessageFns<TransitionFunctionReferences> = {
  encode(message: TransitionFunctionReferences, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.flowSteps).forEach(([key, value]: [string, boolean]) => {
      TransitionFunctionReferences_FlowStepsEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    globalThis.Object.entries(message.variables).forEach(([key, value]: [string, boolean]) => {
      TransitionFunctionReferences_VariablesEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TransitionFunctionReferences {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTransitionFunctionReferences();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = TransitionFunctionReferences_FlowStepsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.flowSteps[entry1.key] = entry1.value;
          }
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = TransitionFunctionReferences_VariablesEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.variables[entry2.key] = entry2.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TransitionFunctionReferences {
    return {
      flowSteps: isObject(object.flowSteps)
        ? (globalThis.Object.entries(object.flowSteps) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : isObject(object.flow_steps)
        ? (globalThis.Object.entries(object.flow_steps) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      variables: isObject(object.variables)
        ? (globalThis.Object.entries(object.variables) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: TransitionFunctionReferences): unknown {
    const obj: any = {};
    if (message.flowSteps) {
      const entries = globalThis.Object.entries(message.flowSteps) as [string, boolean][];
      if (entries.length > 0) {
        obj.flowSteps = {};
        entries.forEach(([k, v]) => {
          obj.flowSteps[k] = v;
        });
      }
    }
    if (message.variables) {
      const entries = globalThis.Object.entries(message.variables) as [string, boolean][];
      if (entries.length > 0) {
        obj.variables = {};
        entries.forEach(([k, v]) => {
          obj.variables[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<TransitionFunctionReferences>): TransitionFunctionReferences {
    return TransitionFunctionReferences.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TransitionFunctionReferences>): TransitionFunctionReferences {
    const message = createBaseTransitionFunctionReferences();
    message.flowSteps = (globalThis.Object.entries(object.flowSteps ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.variables = (globalThis.Object.entries(object.variables ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseTransitionFunctionReferences_FlowStepsEntry(): TransitionFunctionReferences_FlowStepsEntry {
  return { key: "", value: false };
}

export const TransitionFunctionReferences_FlowStepsEntry: MessageFns<TransitionFunctionReferences_FlowStepsEntry> = {
  encode(
    message: TransitionFunctionReferences_FlowStepsEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TransitionFunctionReferences_FlowStepsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTransitionFunctionReferences_FlowStepsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TransitionFunctionReferences_FlowStepsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: TransitionFunctionReferences_FlowStepsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<TransitionFunctionReferences_FlowStepsEntry>): TransitionFunctionReferences_FlowStepsEntry {
    return TransitionFunctionReferences_FlowStepsEntry.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<TransitionFunctionReferences_FlowStepsEntry>,
  ): TransitionFunctionReferences_FlowStepsEntry {
    const message = createBaseTransitionFunctionReferences_FlowStepsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseTransitionFunctionReferences_VariablesEntry(): TransitionFunctionReferences_VariablesEntry {
  return { key: "", value: false };
}

export const TransitionFunctionReferences_VariablesEntry: MessageFns<TransitionFunctionReferences_VariablesEntry> = {
  encode(
    message: TransitionFunctionReferences_VariablesEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TransitionFunctionReferences_VariablesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTransitionFunctionReferences_VariablesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TransitionFunctionReferences_VariablesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: TransitionFunctionReferences_VariablesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<TransitionFunctionReferences_VariablesEntry>): TransitionFunctionReferences_VariablesEntry {
    return TransitionFunctionReferences_VariablesEntry.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<TransitionFunctionReferences_VariablesEntry>,
  ): TransitionFunctionReferences_VariablesEntry {
    const message = createBaseTransitionFunctionReferences_VariablesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseTransitionFunction(): TransitionFunction {
  return {
    id: "",
    name: "",
    description: "",
    parameters: [],
    code: "",
    errors: [],
    latencyControl: undefined,
    createdAt: undefined,
    createdBy: "",
    updatedAt: undefined,
    updatedBy: "",
    archived: false,
    references: undefined,
  };
}

export const TransitionFunction: MessageFns<TransitionFunction> = {
  encode(message: TransitionFunction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.parameters) {
      FunctionParameter.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.code !== "") {
      writer.uint32(42).string(message.code);
    }
    for (const v of message.errors) {
      FunctionError.encode(v!, writer.uint32(50).fork()).join();
    }
    if (message.latencyControl !== undefined) {
      FunctionLatencyControl.encode(message.latencyControl, writer.uint32(58).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(66).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(74).string(message.createdBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(82).fork()).join();
    }
    if (message.updatedBy !== "") {
      writer.uint32(90).string(message.updatedBy);
    }
    if (message.archived !== false) {
      writer.uint32(96).bool(message.archived);
    }
    if (message.references !== undefined) {
      TransitionFunctionReferences.encode(message.references, writer.uint32(106).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TransitionFunction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTransitionFunction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.parameters.push(FunctionParameter.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.errors.push(FunctionError.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.latencyControl = FunctionLatencyControl.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.archived = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.references = TransitionFunctionReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TransitionFunction {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      parameters: globalThis.Array.isArray(object?.parameters)
        ? object.parameters.map((e: any) => FunctionParameter.fromJSON(e))
        : [],
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      errors: globalThis.Array.isArray(object?.errors) ? object.errors.map((e: any) => FunctionError.fromJSON(e)) : [],
      latencyControl: isSet(object.latencyControl)
        ? FunctionLatencyControl.fromJSON(object.latencyControl)
        : isSet(object.latency_control)
        ? FunctionLatencyControl.fromJSON(object.latency_control)
        : undefined,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
      archived: isSet(object.archived) ? globalThis.Boolean(object.archived) : false,
      references: isSet(object.references) ? TransitionFunctionReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: TransitionFunction): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.parameters?.length) {
      obj.parameters = message.parameters.map((e) => FunctionParameter.toJSON(e));
    }
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.errors?.length) {
      obj.errors = message.errors.map((e) => FunctionError.toJSON(e));
    }
    if (message.latencyControl !== undefined) {
      obj.latencyControl = FunctionLatencyControl.toJSON(message.latencyControl);
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    if (message.archived !== false) {
      obj.archived = message.archived;
    }
    if (message.references !== undefined) {
      obj.references = TransitionFunctionReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<TransitionFunction>): TransitionFunction {
    return TransitionFunction.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TransitionFunction>): TransitionFunction {
    const message = createBaseTransitionFunction();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.parameters = object.parameters?.map((e) => FunctionParameter.fromPartial(e)) || [];
    message.code = object.code ?? "";
    message.errors = object.errors?.map((e) => FunctionError.fromPartial(e)) || [];
    message.latencyControl = (object.latencyControl !== undefined && object.latencyControl !== null)
      ? FunctionLatencyControl.fromPartial(object.latencyControl)
      : undefined;
    message.createdAt = object.createdAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? "";
    message.archived = object.archived ?? false;
    message.references = (object.references !== undefined && object.references !== null)
      ? TransitionFunctionReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBaseCondition(): Condition {
  return { id: "", config: undefined };
}

export const Condition: MessageFns<Condition> = {
  encode(message: Condition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    switch (message.config?.$case) {
      case "exitFlowCondition":
        ExitFlowCondition.encode(message.config.value, writer.uint32(18).fork()).join();
        break;
      case "stepCondition":
        AdvancedStepCondition.encode(message.config.value, writer.uint32(26).fork()).join();
        break;
      case "noCodeStepCondition":
        NoCodeStepCondition.encode(message.config.value, writer.uint32(34).fork()).join();
        break;
      case "functionStepCondition":
        FunctionStepCondition.encode(message.config.value, writer.uint32(42).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Condition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCondition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.config = { $case: "exitFlowCondition", value: ExitFlowCondition.decode(reader, reader.uint32()) };
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = { $case: "stepCondition", value: AdvancedStepCondition.decode(reader, reader.uint32()) };
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.config = { $case: "noCodeStepCondition", value: NoCodeStepCondition.decode(reader, reader.uint32()) };
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.config = {
            $case: "functionStepCondition",
            value: FunctionStepCondition.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Condition {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      config: isSet(object.exitFlowCondition)
        ? { $case: "exitFlowCondition", value: ExitFlowCondition.fromJSON(object.exitFlowCondition) }
        : isSet(object.exit_flow_condition)
        ? { $case: "exitFlowCondition", value: ExitFlowCondition.fromJSON(object.exit_flow_condition) }
        : isSet(object.stepCondition)
        ? { $case: "stepCondition", value: AdvancedStepCondition.fromJSON(object.stepCondition) }
        : isSet(object.step_condition)
        ? { $case: "stepCondition", value: AdvancedStepCondition.fromJSON(object.step_condition) }
        : isSet(object.noCodeStepCondition)
        ? { $case: "noCodeStepCondition", value: NoCodeStepCondition.fromJSON(object.noCodeStepCondition) }
        : isSet(object.no_code_step_condition)
        ? { $case: "noCodeStepCondition", value: NoCodeStepCondition.fromJSON(object.no_code_step_condition) }
        : isSet(object.functionStepCondition)
        ? { $case: "functionStepCondition", value: FunctionStepCondition.fromJSON(object.functionStepCondition) }
        : isSet(object.function_step_condition)
        ? { $case: "functionStepCondition", value: FunctionStepCondition.fromJSON(object.function_step_condition) }
        : undefined,
    };
  },

  toJSON(message: Condition): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.config?.$case === "exitFlowCondition") {
      obj.exitFlowCondition = ExitFlowCondition.toJSON(message.config.value);
    } else if (message.config?.$case === "stepCondition") {
      obj.stepCondition = AdvancedStepCondition.toJSON(message.config.value);
    } else if (message.config?.$case === "noCodeStepCondition") {
      obj.noCodeStepCondition = NoCodeStepCondition.toJSON(message.config.value);
    } else if (message.config?.$case === "functionStepCondition") {
      obj.functionStepCondition = FunctionStepCondition.toJSON(message.config.value);
    }
    return obj;
  },

  create(base?: DeepPartial<Condition>): Condition {
    return Condition.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Condition>): Condition {
    const message = createBaseCondition();
    message.id = object.id ?? "";
    switch (object.config?.$case) {
      case "exitFlowCondition": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "exitFlowCondition", value: ExitFlowCondition.fromPartial(object.config.value) };
        }
        break;
      }
      case "stepCondition": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "stepCondition", value: AdvancedStepCondition.fromPartial(object.config.value) };
        }
        break;
      }
      case "noCodeStepCondition": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = {
            $case: "noCodeStepCondition",
            value: NoCodeStepCondition.fromPartial(object.config.value),
          };
        }
        break;
      }
      case "functionStepCondition": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = {
            $case: "functionStepCondition",
            value: FunctionStepCondition.fromPartial(object.config.value),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseConditionDetails(): ConditionDetails {
  return { label: "", description: undefined, requiredEntities: [], position: undefined, ingressPosition: "" };
}

export const ConditionDetails: MessageFns<ConditionDetails> = {
  encode(message: ConditionDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.label !== "") {
      writer.uint32(10).string(message.label);
    }
    if (message.description !== undefined) {
      writer.uint32(18).string(message.description);
    }
    for (const v of message.requiredEntities) {
      writer.uint32(26).string(v!);
    }
    if (message.position !== undefined) {
      StepPosition.encode(message.position, writer.uint32(34).fork()).join();
    }
    if (message.ingressPosition !== "") {
      writer.uint32(42).string(message.ingressPosition);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConditionDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConditionDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.label = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.requiredEntities.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.position = StepPosition.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.ingressPosition = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ConditionDetails {
    return {
      label: isSet(object.label) ? globalThis.String(object.label) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      requiredEntities: globalThis.Array.isArray(object?.requiredEntities)
        ? object.requiredEntities.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.required_entities)
        ? object.required_entities.map((e: any) => globalThis.String(e))
        : [],
      position: isSet(object.position) ? StepPosition.fromJSON(object.position) : undefined,
      ingressPosition: isSet(object.ingressPosition)
        ? globalThis.String(object.ingressPosition)
        : isSet(object.ingress_position)
        ? globalThis.String(object.ingress_position)
        : "",
    };
  },

  toJSON(message: ConditionDetails): unknown {
    const obj: any = {};
    if (message.label !== "") {
      obj.label = message.label;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.requiredEntities?.length) {
      obj.requiredEntities = message.requiredEntities;
    }
    if (message.position !== undefined) {
      obj.position = StepPosition.toJSON(message.position);
    }
    if (message.ingressPosition !== "") {
      obj.ingressPosition = message.ingressPosition;
    }
    return obj;
  },

  create(base?: DeepPartial<ConditionDetails>): ConditionDetails {
    return ConditionDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ConditionDetails>): ConditionDetails {
    const message = createBaseConditionDetails();
    message.label = object.label ?? "";
    message.description = object.description ?? undefined;
    message.requiredEntities = object.requiredEntities?.map((e) => e) || [];
    message.position = (object.position !== undefined && object.position !== null)
      ? StepPosition.fromPartial(object.position)
      : undefined;
    message.ingressPosition = object.ingressPosition ?? "";
    return message;
  },
};

function createBaseExitFlowCondition(): ExitFlowCondition {
  return { details: undefined, exitFlowPosition: undefined };
}

export const ExitFlowCondition: MessageFns<ExitFlowCondition> = {
  encode(message: ExitFlowCondition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.details !== undefined) {
      ConditionDetails.encode(message.details, writer.uint32(10).fork()).join();
    }
    if (message.exitFlowPosition !== undefined) {
      StepPosition.encode(message.exitFlowPosition, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExitFlowCondition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExitFlowCondition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.details = ConditionDetails.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.exitFlowPosition = StepPosition.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExitFlowCondition {
    return {
      details: isSet(object.details) ? ConditionDetails.fromJSON(object.details) : undefined,
      exitFlowPosition: isSet(object.exitFlowPosition)
        ? StepPosition.fromJSON(object.exitFlowPosition)
        : isSet(object.exit_flow_position)
        ? StepPosition.fromJSON(object.exit_flow_position)
        : undefined,
    };
  },

  toJSON(message: ExitFlowCondition): unknown {
    const obj: any = {};
    if (message.details !== undefined) {
      obj.details = ConditionDetails.toJSON(message.details);
    }
    if (message.exitFlowPosition !== undefined) {
      obj.exitFlowPosition = StepPosition.toJSON(message.exitFlowPosition);
    }
    return obj;
  },

  create(base?: DeepPartial<ExitFlowCondition>): ExitFlowCondition {
    return ExitFlowCondition.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ExitFlowCondition>): ExitFlowCondition {
    const message = createBaseExitFlowCondition();
    message.details = (object.details !== undefined && object.details !== null)
      ? ConditionDetails.fromPartial(object.details)
      : undefined;
    message.exitFlowPosition = (object.exitFlowPosition !== undefined && object.exitFlowPosition !== null)
      ? StepPosition.fromPartial(object.exitFlowPosition)
      : undefined;
    return message;
  },
};

function createBaseAdvancedStepCondition(): AdvancedStepCondition {
  return { details: undefined, childStepId: "" };
}

export const AdvancedStepCondition: MessageFns<AdvancedStepCondition> = {
  encode(message: AdvancedStepCondition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.details !== undefined) {
      ConditionDetails.encode(message.details, writer.uint32(10).fork()).join();
    }
    if (message.childStepId !== "") {
      writer.uint32(18).string(message.childStepId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdvancedStepCondition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdvancedStepCondition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.details = ConditionDetails.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.childStepId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdvancedStepCondition {
    return {
      details: isSet(object.details) ? ConditionDetails.fromJSON(object.details) : undefined,
      childStepId: isSet(object.childStepId)
        ? globalThis.String(object.childStepId)
        : isSet(object.child_step_id)
        ? globalThis.String(object.child_step_id)
        : "",
    };
  },

  toJSON(message: AdvancedStepCondition): unknown {
    const obj: any = {};
    if (message.details !== undefined) {
      obj.details = ConditionDetails.toJSON(message.details);
    }
    if (message.childStepId !== "") {
      obj.childStepId = message.childStepId;
    }
    return obj;
  },

  create(base?: DeepPartial<AdvancedStepCondition>): AdvancedStepCondition {
    return AdvancedStepCondition.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AdvancedStepCondition>): AdvancedStepCondition {
    const message = createBaseAdvancedStepCondition();
    message.details = (object.details !== undefined && object.details !== null)
      ? ConditionDetails.fromPartial(object.details)
      : undefined;
    message.childStepId = object.childStepId ?? "";
    return message;
  },
};

function createBaseNoCodeStepCondition(): NoCodeStepCondition {
  return { details: undefined, childStepId: "" };
}

export const NoCodeStepCondition: MessageFns<NoCodeStepCondition> = {
  encode(message: NoCodeStepCondition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.details !== undefined) {
      ConditionDetails.encode(message.details, writer.uint32(10).fork()).join();
    }
    if (message.childStepId !== "") {
      writer.uint32(18).string(message.childStepId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NoCodeStepCondition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNoCodeStepCondition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.details = ConditionDetails.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.childStepId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NoCodeStepCondition {
    return {
      details: isSet(object.details) ? ConditionDetails.fromJSON(object.details) : undefined,
      childStepId: isSet(object.childStepId)
        ? globalThis.String(object.childStepId)
        : isSet(object.child_step_id)
        ? globalThis.String(object.child_step_id)
        : "",
    };
  },

  toJSON(message: NoCodeStepCondition): unknown {
    const obj: any = {};
    if (message.details !== undefined) {
      obj.details = ConditionDetails.toJSON(message.details);
    }
    if (message.childStepId !== "") {
      obj.childStepId = message.childStepId;
    }
    return obj;
  },

  create(base?: DeepPartial<NoCodeStepCondition>): NoCodeStepCondition {
    return NoCodeStepCondition.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<NoCodeStepCondition>): NoCodeStepCondition {
    const message = createBaseNoCodeStepCondition();
    message.details = (object.details !== undefined && object.details !== null)
      ? ConditionDetails.fromPartial(object.details)
      : undefined;
    message.childStepId = object.childStepId ?? "";
    return message;
  },
};

function createBaseFunctionStepCondition(): FunctionStepCondition {
  return { details: undefined, childStepId: "" };
}

export const FunctionStepCondition: MessageFns<FunctionStepCondition> = {
  encode(message: FunctionStepCondition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.details !== undefined) {
      ConditionDetails.encode(message.details, writer.uint32(10).fork()).join();
    }
    if (message.childStepId !== "") {
      writer.uint32(18).string(message.childStepId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionStepCondition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionStepCondition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.details = ConditionDetails.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.childStepId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionStepCondition {
    return {
      details: isSet(object.details) ? ConditionDetails.fromJSON(object.details) : undefined,
      childStepId: isSet(object.childStepId)
        ? globalThis.String(object.childStepId)
        : isSet(object.child_step_id)
        ? globalThis.String(object.child_step_id)
        : "",
    };
  },

  toJSON(message: FunctionStepCondition): unknown {
    const obj: any = {};
    if (message.details !== undefined) {
      obj.details = ConditionDetails.toJSON(message.details);
    }
    if (message.childStepId !== "") {
      obj.childStepId = message.childStepId;
    }
    return obj;
  },

  create(base?: DeepPartial<FunctionStepCondition>): FunctionStepCondition {
    return FunctionStepCondition.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FunctionStepCondition>): FunctionStepCondition {
    const message = createBaseFunctionStepCondition();
    message.details = (object.details !== undefined && object.details !== null)
      ? ConditionDetails.fromPartial(object.details)
      : undefined;
    message.childStepId = object.childStepId ?? "";
    return message;
  },
};

function createBaseStepPosition(): StepPosition {
  return { x: 0, y: 0 };
}

export const StepPosition: MessageFns<StepPosition> = {
  encode(message: StepPosition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.x !== 0) {
      writer.uint32(13).float(message.x);
    }
    if (message.y !== 0) {
      writer.uint32(21).float(message.y);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StepPosition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStepPosition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.x = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.y = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StepPosition {
    return {
      x: isSet(object.x) ? globalThis.Number(object.x) : 0,
      y: isSet(object.y) ? globalThis.Number(object.y) : 0,
    };
  },

  toJSON(message: StepPosition): unknown {
    const obj: any = {};
    if (message.x !== 0) {
      obj.x = message.x;
    }
    if (message.y !== 0) {
      obj.y = message.y;
    }
    return obj;
  },

  create(base?: DeepPartial<StepPosition>): StepPosition {
    return StepPosition.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StepPosition>): StepPosition {
    const message = createBaseStepPosition();
    message.x = object.x ?? 0;
    message.y = object.y ?? 0;
    return message;
  },
};

function createBaseStepAsrConfig(): StepAsrConfig {
  return {
    alphanumeric: false,
    nameSpelling: false,
    numeric: false,
    partySize: false,
    preciseDate: false,
    relativeDate: false,
    singleNumber: false,
    time: false,
    yesNo: false,
    address: false,
    customKeywords: [],
    isEnabled: false,
  };
}

export const StepAsrConfig: MessageFns<StepAsrConfig> = {
  encode(message: StepAsrConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.alphanumeric !== false) {
      writer.uint32(8).bool(message.alphanumeric);
    }
    if (message.nameSpelling !== false) {
      writer.uint32(16).bool(message.nameSpelling);
    }
    if (message.numeric !== false) {
      writer.uint32(24).bool(message.numeric);
    }
    if (message.partySize !== false) {
      writer.uint32(32).bool(message.partySize);
    }
    if (message.preciseDate !== false) {
      writer.uint32(40).bool(message.preciseDate);
    }
    if (message.relativeDate !== false) {
      writer.uint32(48).bool(message.relativeDate);
    }
    if (message.singleNumber !== false) {
      writer.uint32(56).bool(message.singleNumber);
    }
    if (message.time !== false) {
      writer.uint32(64).bool(message.time);
    }
    if (message.yesNo !== false) {
      writer.uint32(72).bool(message.yesNo);
    }
    if (message.address !== false) {
      writer.uint32(80).bool(message.address);
    }
    for (const v of message.customKeywords) {
      writer.uint32(90).string(v!);
    }
    if (message.isEnabled !== false) {
      writer.uint32(96).bool(message.isEnabled);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StepAsrConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStepAsrConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.alphanumeric = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.nameSpelling = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.numeric = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.partySize = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.preciseDate = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.relativeDate = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.singleNumber = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.time = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.yesNo = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.address = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.customKeywords.push(reader.string());
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.isEnabled = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StepAsrConfig {
    return {
      alphanumeric: isSet(object.alphanumeric) ? globalThis.Boolean(object.alphanumeric) : false,
      nameSpelling: isSet(object.nameSpelling)
        ? globalThis.Boolean(object.nameSpelling)
        : isSet(object.name_spelling)
        ? globalThis.Boolean(object.name_spelling)
        : false,
      numeric: isSet(object.numeric) ? globalThis.Boolean(object.numeric) : false,
      partySize: isSet(object.partySize)
        ? globalThis.Boolean(object.partySize)
        : isSet(object.party_size)
        ? globalThis.Boolean(object.party_size)
        : false,
      preciseDate: isSet(object.preciseDate)
        ? globalThis.Boolean(object.preciseDate)
        : isSet(object.precise_date)
        ? globalThis.Boolean(object.precise_date)
        : false,
      relativeDate: isSet(object.relativeDate)
        ? globalThis.Boolean(object.relativeDate)
        : isSet(object.relative_date)
        ? globalThis.Boolean(object.relative_date)
        : false,
      singleNumber: isSet(object.singleNumber)
        ? globalThis.Boolean(object.singleNumber)
        : isSet(object.single_number)
        ? globalThis.Boolean(object.single_number)
        : false,
      time: isSet(object.time) ? globalThis.Boolean(object.time) : false,
      yesNo: isSet(object.yesNo)
        ? globalThis.Boolean(object.yesNo)
        : isSet(object.yes_no)
        ? globalThis.Boolean(object.yes_no)
        : false,
      address: isSet(object.address) ? globalThis.Boolean(object.address) : false,
      customKeywords: globalThis.Array.isArray(object?.customKeywords)
        ? object.customKeywords.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.custom_keywords)
        ? object.custom_keywords.map((e: any) => globalThis.String(e))
        : [],
      isEnabled: isSet(object.isEnabled)
        ? globalThis.Boolean(object.isEnabled)
        : isSet(object.is_enabled)
        ? globalThis.Boolean(object.is_enabled)
        : false,
    };
  },

  toJSON(message: StepAsrConfig): unknown {
    const obj: any = {};
    if (message.alphanumeric !== false) {
      obj.alphanumeric = message.alphanumeric;
    }
    if (message.nameSpelling !== false) {
      obj.nameSpelling = message.nameSpelling;
    }
    if (message.numeric !== false) {
      obj.numeric = message.numeric;
    }
    if (message.partySize !== false) {
      obj.partySize = message.partySize;
    }
    if (message.preciseDate !== false) {
      obj.preciseDate = message.preciseDate;
    }
    if (message.relativeDate !== false) {
      obj.relativeDate = message.relativeDate;
    }
    if (message.singleNumber !== false) {
      obj.singleNumber = message.singleNumber;
    }
    if (message.time !== false) {
      obj.time = message.time;
    }
    if (message.yesNo !== false) {
      obj.yesNo = message.yesNo;
    }
    if (message.address !== false) {
      obj.address = message.address;
    }
    if (message.customKeywords?.length) {
      obj.customKeywords = message.customKeywords;
    }
    if (message.isEnabled !== false) {
      obj.isEnabled = message.isEnabled;
    }
    return obj;
  },

  create(base?: DeepPartial<StepAsrConfig>): StepAsrConfig {
    return StepAsrConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StepAsrConfig>): StepAsrConfig {
    const message = createBaseStepAsrConfig();
    message.alphanumeric = object.alphanumeric ?? false;
    message.nameSpelling = object.nameSpelling ?? false;
    message.numeric = object.numeric ?? false;
    message.partySize = object.partySize ?? false;
    message.preciseDate = object.preciseDate ?? false;
    message.relativeDate = object.relativeDate ?? false;
    message.singleNumber = object.singleNumber ?? false;
    message.time = object.time ?? false;
    message.yesNo = object.yesNo ?? false;
    message.address = object.address ?? false;
    message.customKeywords = object.customKeywords?.map((e) => e) || [];
    message.isEnabled = object.isEnabled ?? false;
    return message;
  },
};

function createBaseStepDtmfConfig(): StepDtmfConfig {
  return {
    isEnabled: false,
    interDigitTimeout: 0,
    maxDigits: 0,
    endKey: "",
    collectWhileAgentSpeaking: false,
    isPii: false,
  };
}

export const StepDtmfConfig: MessageFns<StepDtmfConfig> = {
  encode(message: StepDtmfConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.isEnabled !== false) {
      writer.uint32(8).bool(message.isEnabled);
    }
    if (message.interDigitTimeout !== 0) {
      writer.uint32(16).int32(message.interDigitTimeout);
    }
    if (message.maxDigits !== 0) {
      writer.uint32(24).int32(message.maxDigits);
    }
    if (message.endKey !== "") {
      writer.uint32(34).string(message.endKey);
    }
    if (message.collectWhileAgentSpeaking !== false) {
      writer.uint32(40).bool(message.collectWhileAgentSpeaking);
    }
    if (message.isPii !== false) {
      writer.uint32(48).bool(message.isPii);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StepDtmfConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStepDtmfConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.isEnabled = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.interDigitTimeout = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.maxDigits = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.endKey = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.collectWhileAgentSpeaking = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.isPii = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StepDtmfConfig {
    return {
      isEnabled: isSet(object.isEnabled)
        ? globalThis.Boolean(object.isEnabled)
        : isSet(object.is_enabled)
        ? globalThis.Boolean(object.is_enabled)
        : false,
      interDigitTimeout: isSet(object.interDigitTimeout)
        ? globalThis.Number(object.interDigitTimeout)
        : isSet(object.inter_digit_timeout)
        ? globalThis.Number(object.inter_digit_timeout)
        : 0,
      maxDigits: isSet(object.maxDigits)
        ? globalThis.Number(object.maxDigits)
        : isSet(object.max_digits)
        ? globalThis.Number(object.max_digits)
        : 0,
      endKey: isSet(object.endKey)
        ? globalThis.String(object.endKey)
        : isSet(object.end_key)
        ? globalThis.String(object.end_key)
        : "",
      collectWhileAgentSpeaking: isSet(object.collectWhileAgentSpeaking)
        ? globalThis.Boolean(object.collectWhileAgentSpeaking)
        : isSet(object.collect_while_agent_speaking)
        ? globalThis.Boolean(object.collect_while_agent_speaking)
        : false,
      isPii: isSet(object.isPii)
        ? globalThis.Boolean(object.isPii)
        : isSet(object.is_pii)
        ? globalThis.Boolean(object.is_pii)
        : false,
    };
  },

  toJSON(message: StepDtmfConfig): unknown {
    const obj: any = {};
    if (message.isEnabled !== false) {
      obj.isEnabled = message.isEnabled;
    }
    if (message.interDigitTimeout !== 0) {
      obj.interDigitTimeout = Math.round(message.interDigitTimeout);
    }
    if (message.maxDigits !== 0) {
      obj.maxDigits = Math.round(message.maxDigits);
    }
    if (message.endKey !== "") {
      obj.endKey = message.endKey;
    }
    if (message.collectWhileAgentSpeaking !== false) {
      obj.collectWhileAgentSpeaking = message.collectWhileAgentSpeaking;
    }
    if (message.isPii !== false) {
      obj.isPii = message.isPii;
    }
    return obj;
  },

  create(base?: DeepPartial<StepDtmfConfig>): StepDtmfConfig {
    return StepDtmfConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StepDtmfConfig>): StepDtmfConfig {
    const message = createBaseStepDtmfConfig();
    message.isEnabled = object.isEnabled ?? false;
    message.interDigitTimeout = object.interDigitTimeout ?? 0;
    message.maxDigits = object.maxDigits ?? 0;
    message.endKey = object.endKey ?? "";
    message.collectWhileAgentSpeaking = object.collectWhileAgentSpeaking ?? false;
    message.isPii = object.isPii ?? false;
    return message;
  },
};

function createBaseFlowCreateFlow(): FlowCreateFlow {
  return { id: "", name: "", description: "", startStepId: "", steps: [], transitionFunctions: [], noCodeSteps: [] };
}

export const FlowCreateFlow: MessageFns<FlowCreateFlow> = {
  encode(message: FlowCreateFlow, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.startStepId !== "") {
      writer.uint32(34).string(message.startStepId);
    }
    for (const v of message.steps) {
      CreateAdvancedStep.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.transitionFunctions) {
      TransitionFunctionCreateTransitionFunction.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.noCodeSteps) {
      CreateNoCodeStep.encode(v!, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FlowCreateFlow {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFlowCreateFlow();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.startStepId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.steps.push(CreateAdvancedStep.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.transitionFunctions.push(TransitionFunctionCreateTransitionFunction.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.noCodeSteps.push(CreateNoCodeStep.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FlowCreateFlow {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      startStepId: isSet(object.startStepId)
        ? globalThis.String(object.startStepId)
        : isSet(object.start_step_id)
        ? globalThis.String(object.start_step_id)
        : "",
      steps: globalThis.Array.isArray(object?.steps)
        ? object.steps.map((e: any) => CreateAdvancedStep.fromJSON(e))
        : [],
      transitionFunctions: globalThis.Array.isArray(object?.transitionFunctions)
        ? object.transitionFunctions.map((e: any) => TransitionFunctionCreateTransitionFunction.fromJSON(e))
        : globalThis.Array.isArray(object?.transition_functions)
        ? object.transition_functions.map((e: any) => TransitionFunctionCreateTransitionFunction.fromJSON(e))
        : [],
      noCodeSteps: globalThis.Array.isArray(object?.noCodeSteps)
        ? object.noCodeSteps.map((e: any) => CreateNoCodeStep.fromJSON(e))
        : globalThis.Array.isArray(object?.no_code_steps)
        ? object.no_code_steps.map((e: any) => CreateNoCodeStep.fromJSON(e))
        : [],
    };
  },

  toJSON(message: FlowCreateFlow): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.startStepId !== "") {
      obj.startStepId = message.startStepId;
    }
    if (message.steps?.length) {
      obj.steps = message.steps.map((e) => CreateAdvancedStep.toJSON(e));
    }
    if (message.transitionFunctions?.length) {
      obj.transitionFunctions = message.transitionFunctions.map((e) =>
        TransitionFunctionCreateTransitionFunction.toJSON(e)
      );
    }
    if (message.noCodeSteps?.length) {
      obj.noCodeSteps = message.noCodeSteps.map((e) => CreateNoCodeStep.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<FlowCreateFlow>): FlowCreateFlow {
    return FlowCreateFlow.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FlowCreateFlow>): FlowCreateFlow {
    const message = createBaseFlowCreateFlow();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.startStepId = object.startStepId ?? "";
    message.steps = object.steps?.map((e) => CreateAdvancedStep.fromPartial(e)) || [];
    message.transitionFunctions =
      object.transitionFunctions?.map((e) => TransitionFunctionCreateTransitionFunction.fromPartial(e)) || [];
    message.noCodeSteps = object.noCodeSteps?.map((e) => CreateNoCodeStep.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFlowUpdateFlow(): FlowUpdateFlow {
  return { flowId: "", name: undefined, description: undefined, startStepId: undefined, oldFlowName: undefined };
}

export const FlowUpdateFlow: MessageFns<FlowUpdateFlow> = {
  encode(message: FlowUpdateFlow, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== undefined) {
      writer.uint32(26).string(message.description);
    }
    if (message.startStepId !== undefined) {
      writer.uint32(34).string(message.startStepId);
    }
    if (message.oldFlowName !== undefined) {
      writer.uint32(42).string(message.oldFlowName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FlowUpdateFlow {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFlowUpdateFlow();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.startStepId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.oldFlowName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FlowUpdateFlow {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      startStepId: isSet(object.startStepId)
        ? globalThis.String(object.startStepId)
        : isSet(object.start_step_id)
        ? globalThis.String(object.start_step_id)
        : undefined,
      oldFlowName: isSet(object.oldFlowName)
        ? globalThis.String(object.oldFlowName)
        : isSet(object.old_flow_name)
        ? globalThis.String(object.old_flow_name)
        : undefined,
    };
  },

  toJSON(message: FlowUpdateFlow): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.startStepId !== undefined) {
      obj.startStepId = message.startStepId;
    }
    if (message.oldFlowName !== undefined) {
      obj.oldFlowName = message.oldFlowName;
    }
    return obj;
  },

  create(base?: DeepPartial<FlowUpdateFlow>): FlowUpdateFlow {
    return FlowUpdateFlow.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FlowUpdateFlow>): FlowUpdateFlow {
    const message = createBaseFlowUpdateFlow();
    message.flowId = object.flowId ?? "";
    message.name = object.name ?? undefined;
    message.description = object.description ?? undefined;
    message.startStepId = object.startStepId ?? undefined;
    message.oldFlowName = object.oldFlowName ?? undefined;
    return message;
  },
};

function createBaseFlowDeleteFlow(): FlowDeleteFlow {
  return { flowId: "" };
}

export const FlowDeleteFlow: MessageFns<FlowDeleteFlow> = {
  encode(message: FlowDeleteFlow, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FlowDeleteFlow {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFlowDeleteFlow();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FlowDeleteFlow {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
    };
  },

  toJSON(message: FlowDeleteFlow): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    return obj;
  },

  create(base?: DeepPartial<FlowDeleteFlow>): FlowDeleteFlow {
    return FlowDeleteFlow.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FlowDeleteFlow>): FlowDeleteFlow {
    const message = createBaseFlowDeleteFlow();
    message.flowId = object.flowId ?? "";
    return message;
  },
};

function createBaseFlowImportFlow(): FlowImportFlow {
  return {
    flowId: "",
    steps: [],
    transitionFunctions: [],
    globalFunctions: [],
    handoffs: [],
    sms: [],
    attributes: [],
    noCodeSteps: [],
    entities: [],
  };
}

export const FlowImportFlow: MessageFns<FlowImportFlow> = {
  encode(message: FlowImportFlow, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    for (const v of message.steps) {
      ImportFlowStep.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.transitionFunctions) {
      TransitionFunctionCreateTransitionFunction.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.globalFunctions) {
      FunctionCreateFunction.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.handoffs) {
      HandoffCreate.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.sms) {
      SMSCreateTemplate.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.attributes) {
      VariantCreateAttribute.encode(v!, writer.uint32(58).fork()).join();
    }
    for (const v of message.noCodeSteps) {
      ImportNoCodeStep.encode(v!, writer.uint32(66).fork()).join();
    }
    for (const v of message.entities) {
      EntityCreate.encode(v!, writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FlowImportFlow {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFlowImportFlow();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.steps.push(ImportFlowStep.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.transitionFunctions.push(TransitionFunctionCreateTransitionFunction.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.globalFunctions.push(FunctionCreateFunction.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.handoffs.push(HandoffCreate.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.sms.push(SMSCreateTemplate.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.attributes.push(VariantCreateAttribute.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.noCodeSteps.push(ImportNoCodeStep.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.entities.push(EntityCreate.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FlowImportFlow {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      steps: globalThis.Array.isArray(object?.steps) ? object.steps.map((e: any) => ImportFlowStep.fromJSON(e)) : [],
      transitionFunctions: globalThis.Array.isArray(object?.transitionFunctions)
        ? object.transitionFunctions.map((e: any) => TransitionFunctionCreateTransitionFunction.fromJSON(e))
        : globalThis.Array.isArray(object?.transition_functions)
        ? object.transition_functions.map((e: any) => TransitionFunctionCreateTransitionFunction.fromJSON(e))
        : [],
      globalFunctions: globalThis.Array.isArray(object?.globalFunctions)
        ? object.globalFunctions.map((e: any) => FunctionCreateFunction.fromJSON(e))
        : globalThis.Array.isArray(object?.global_functions)
        ? object.global_functions.map((e: any) => FunctionCreateFunction.fromJSON(e))
        : [],
      handoffs: globalThis.Array.isArray(object?.handoffs)
        ? object.handoffs.map((e: any) => HandoffCreate.fromJSON(e))
        : [],
      sms: globalThis.Array.isArray(object?.sms) ? object.sms.map((e: any) => SMSCreateTemplate.fromJSON(e)) : [],
      attributes: globalThis.Array.isArray(object?.attributes)
        ? object.attributes.map((e: any) => VariantCreateAttribute.fromJSON(e))
        : [],
      noCodeSteps: globalThis.Array.isArray(object?.noCodeSteps)
        ? object.noCodeSteps.map((e: any) => ImportNoCodeStep.fromJSON(e))
        : globalThis.Array.isArray(object?.no_code_steps)
        ? object.no_code_steps.map((e: any) => ImportNoCodeStep.fromJSON(e))
        : [],
      entities: globalThis.Array.isArray(object?.entities)
        ? object.entities.map((e: any) => EntityCreate.fromJSON(e))
        : [],
    };
  },

  toJSON(message: FlowImportFlow): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.steps?.length) {
      obj.steps = message.steps.map((e) => ImportFlowStep.toJSON(e));
    }
    if (message.transitionFunctions?.length) {
      obj.transitionFunctions = message.transitionFunctions.map((e) =>
        TransitionFunctionCreateTransitionFunction.toJSON(e)
      );
    }
    if (message.globalFunctions?.length) {
      obj.globalFunctions = message.globalFunctions.map((e) => FunctionCreateFunction.toJSON(e));
    }
    if (message.handoffs?.length) {
      obj.handoffs = message.handoffs.map((e) => HandoffCreate.toJSON(e));
    }
    if (message.sms?.length) {
      obj.sms = message.sms.map((e) => SMSCreateTemplate.toJSON(e));
    }
    if (message.attributes?.length) {
      obj.attributes = message.attributes.map((e) => VariantCreateAttribute.toJSON(e));
    }
    if (message.noCodeSteps?.length) {
      obj.noCodeSteps = message.noCodeSteps.map((e) => ImportNoCodeStep.toJSON(e));
    }
    if (message.entities?.length) {
      obj.entities = message.entities.map((e) => EntityCreate.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<FlowImportFlow>): FlowImportFlow {
    return FlowImportFlow.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FlowImportFlow>): FlowImportFlow {
    const message = createBaseFlowImportFlow();
    message.flowId = object.flowId ?? "";
    message.steps = object.steps?.map((e) => ImportFlowStep.fromPartial(e)) || [];
    message.transitionFunctions =
      object.transitionFunctions?.map((e) => TransitionFunctionCreateTransitionFunction.fromPartial(e)) || [];
    message.globalFunctions = object.globalFunctions?.map((e) => FunctionCreateFunction.fromPartial(e)) || [];
    message.handoffs = object.handoffs?.map((e) => HandoffCreate.fromPartial(e)) || [];
    message.sms = object.sms?.map((e) => SMSCreateTemplate.fromPartial(e)) || [];
    message.attributes = object.attributes?.map((e) => VariantCreateAttribute.fromPartial(e)) || [];
    message.noCodeSteps = object.noCodeSteps?.map((e) => ImportNoCodeStep.fromPartial(e)) || [];
    message.entities = object.entities?.map((e) => EntityCreate.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFlowCreateStep(): FlowCreateStep {
  return { flowId: "", step: undefined };
}

export const FlowCreateStep: MessageFns<FlowCreateStep> = {
  encode(message: FlowCreateStep, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    if (message.step !== undefined) {
      CreateAdvancedStep.encode(message.step, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FlowCreateStep {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFlowCreateStep();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.step = CreateAdvancedStep.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FlowCreateStep {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      step: isSet(object.step) ? CreateAdvancedStep.fromJSON(object.step) : undefined,
    };
  },

  toJSON(message: FlowCreateStep): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.step !== undefined) {
      obj.step = CreateAdvancedStep.toJSON(message.step);
    }
    return obj;
  },

  create(base?: DeepPartial<FlowCreateStep>): FlowCreateStep {
    return FlowCreateStep.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FlowCreateStep>): FlowCreateStep {
    const message = createBaseFlowCreateStep();
    message.flowId = object.flowId ?? "";
    message.step = (object.step !== undefined && object.step !== null)
      ? CreateAdvancedStep.fromPartial(object.step)
      : undefined;
    return message;
  },
};

function createBaseFlowUpdateStep(): FlowUpdateStep {
  return { flowId: "", step: undefined };
}

export const FlowUpdateStep: MessageFns<FlowUpdateStep> = {
  encode(message: FlowUpdateStep, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    if (message.step !== undefined) {
      UpdateAdvancedStep.encode(message.step, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FlowUpdateStep {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFlowUpdateStep();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.step = UpdateAdvancedStep.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FlowUpdateStep {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      step: isSet(object.step) ? UpdateAdvancedStep.fromJSON(object.step) : undefined,
    };
  },

  toJSON(message: FlowUpdateStep): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.step !== undefined) {
      obj.step = UpdateAdvancedStep.toJSON(message.step);
    }
    return obj;
  },

  create(base?: DeepPartial<FlowUpdateStep>): FlowUpdateStep {
    return FlowUpdateStep.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FlowUpdateStep>): FlowUpdateStep {
    const message = createBaseFlowUpdateStep();
    message.flowId = object.flowId ?? "";
    message.step = (object.step !== undefined && object.step !== null)
      ? UpdateAdvancedStep.fromPartial(object.step)
      : undefined;
    return message;
  },
};

function createBaseFlowDeleteStep(): FlowDeleteStep {
  return { flowId: "", stepId: "" };
}

export const FlowDeleteStep: MessageFns<FlowDeleteStep> = {
  encode(message: FlowDeleteStep, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    if (message.stepId !== "") {
      writer.uint32(18).string(message.stepId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FlowDeleteStep {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFlowDeleteStep();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stepId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FlowDeleteStep {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      stepId: isSet(object.stepId)
        ? globalThis.String(object.stepId)
        : isSet(object.step_id)
        ? globalThis.String(object.step_id)
        : "",
    };
  },

  toJSON(message: FlowDeleteStep): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.stepId !== "") {
      obj.stepId = message.stepId;
    }
    return obj;
  },

  create(base?: DeepPartial<FlowDeleteStep>): FlowDeleteStep {
    return FlowDeleteStep.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FlowDeleteStep>): FlowDeleteStep {
    const message = createBaseFlowDeleteStep();
    message.flowId = object.flowId ?? "";
    message.stepId = object.stepId ?? "";
    return message;
  },
};

function createBaseCreateAdvancedStep(): CreateAdvancedStep {
  return {
    id: "",
    name: "",
    prompt: "",
    position: undefined,
    references: undefined,
    asrBiasing: undefined,
    dtmfConfig: undefined,
  };
}

export const CreateAdvancedStep: MessageFns<CreateAdvancedStep> = {
  encode(message: CreateAdvancedStep, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.prompt !== "") {
      writer.uint32(26).string(message.prompt);
    }
    if (message.position !== undefined) {
      StepPosition.encode(message.position, writer.uint32(34).fork()).join();
    }
    if (message.references !== undefined) {
      StepReferences.encode(message.references, writer.uint32(42).fork()).join();
    }
    if (message.asrBiasing !== undefined) {
      StepAsrConfig.encode(message.asrBiasing, writer.uint32(50).fork()).join();
    }
    if (message.dtmfConfig !== undefined) {
      StepDtmfConfig.encode(message.dtmfConfig, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateAdvancedStep {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateAdvancedStep();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.prompt = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.position = StepPosition.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.references = StepReferences.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.asrBiasing = StepAsrConfig.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.dtmfConfig = StepDtmfConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateAdvancedStep {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      prompt: isSet(object.prompt) ? globalThis.String(object.prompt) : "",
      position: isSet(object.position) ? StepPosition.fromJSON(object.position) : undefined,
      references: isSet(object.references) ? StepReferences.fromJSON(object.references) : undefined,
      asrBiasing: isSet(object.asrBiasing)
        ? StepAsrConfig.fromJSON(object.asrBiasing)
        : isSet(object.asr_biasing)
        ? StepAsrConfig.fromJSON(object.asr_biasing)
        : undefined,
      dtmfConfig: isSet(object.dtmfConfig)
        ? StepDtmfConfig.fromJSON(object.dtmfConfig)
        : isSet(object.dtmf_config)
        ? StepDtmfConfig.fromJSON(object.dtmf_config)
        : undefined,
    };
  },

  toJSON(message: CreateAdvancedStep): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.prompt !== "") {
      obj.prompt = message.prompt;
    }
    if (message.position !== undefined) {
      obj.position = StepPosition.toJSON(message.position);
    }
    if (message.references !== undefined) {
      obj.references = StepReferences.toJSON(message.references);
    }
    if (message.asrBiasing !== undefined) {
      obj.asrBiasing = StepAsrConfig.toJSON(message.asrBiasing);
    }
    if (message.dtmfConfig !== undefined) {
      obj.dtmfConfig = StepDtmfConfig.toJSON(message.dtmfConfig);
    }
    return obj;
  },

  create(base?: DeepPartial<CreateAdvancedStep>): CreateAdvancedStep {
    return CreateAdvancedStep.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateAdvancedStep>): CreateAdvancedStep {
    const message = createBaseCreateAdvancedStep();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.prompt = object.prompt ?? "";
    message.position = (object.position !== undefined && object.position !== null)
      ? StepPosition.fromPartial(object.position)
      : undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? StepReferences.fromPartial(object.references)
      : undefined;
    message.asrBiasing = (object.asrBiasing !== undefined && object.asrBiasing !== null)
      ? StepAsrConfig.fromPartial(object.asrBiasing)
      : undefined;
    message.dtmfConfig = (object.dtmfConfig !== undefined && object.dtmfConfig !== null)
      ? StepDtmfConfig.fromPartial(object.dtmfConfig)
      : undefined;
    return message;
  },
};

function createBaseUpdateAdvancedStep(): UpdateAdvancedStep {
  return { id: "", name: undefined, prompt: undefined, references: undefined };
}

export const UpdateAdvancedStep: MessageFns<UpdateAdvancedStep> = {
  encode(message: UpdateAdvancedStep, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name);
    }
    if (message.prompt !== undefined) {
      writer.uint32(26).string(message.prompt);
    }
    if (message.references !== undefined) {
      StepReferences.encode(message.references, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateAdvancedStep {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateAdvancedStep();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.prompt = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.references = StepReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateAdvancedStep {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      prompt: isSet(object.prompt) ? globalThis.String(object.prompt) : undefined,
      references: isSet(object.references) ? StepReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: UpdateAdvancedStep): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.prompt !== undefined) {
      obj.prompt = message.prompt;
    }
    if (message.references !== undefined) {
      obj.references = StepReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateAdvancedStep>): UpdateAdvancedStep {
    return UpdateAdvancedStep.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateAdvancedStep>): UpdateAdvancedStep {
    const message = createBaseUpdateAdvancedStep();
    message.id = object.id ?? "";
    message.name = object.name ?? undefined;
    message.prompt = object.prompt ?? undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? StepReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBaseImportFlowStep(): ImportFlowStep {
  return {
    id: "",
    name: "",
    prompt: "",
    position: undefined,
    asrBiasing: undefined,
    dtmfConfig: undefined,
    references: undefined,
  };
}

export const ImportFlowStep: MessageFns<ImportFlowStep> = {
  encode(message: ImportFlowStep, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.prompt !== "") {
      writer.uint32(26).string(message.prompt);
    }
    if (message.position !== undefined) {
      StepPosition.encode(message.position, writer.uint32(34).fork()).join();
    }
    if (message.asrBiasing !== undefined) {
      StepAsrConfig.encode(message.asrBiasing, writer.uint32(42).fork()).join();
    }
    if (message.dtmfConfig !== undefined) {
      StepDtmfConfig.encode(message.dtmfConfig, writer.uint32(50).fork()).join();
    }
    if (message.references !== undefined) {
      StepReferences.encode(message.references, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImportFlowStep {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImportFlowStep();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.prompt = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.position = StepPosition.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.asrBiasing = StepAsrConfig.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.dtmfConfig = StepDtmfConfig.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.references = StepReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ImportFlowStep {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      prompt: isSet(object.prompt) ? globalThis.String(object.prompt) : "",
      position: isSet(object.position) ? StepPosition.fromJSON(object.position) : undefined,
      asrBiasing: isSet(object.asrBiasing)
        ? StepAsrConfig.fromJSON(object.asrBiasing)
        : isSet(object.asr_biasing)
        ? StepAsrConfig.fromJSON(object.asr_biasing)
        : undefined,
      dtmfConfig: isSet(object.dtmfConfig)
        ? StepDtmfConfig.fromJSON(object.dtmfConfig)
        : isSet(object.dtmf_config)
        ? StepDtmfConfig.fromJSON(object.dtmf_config)
        : undefined,
      references: isSet(object.references) ? StepReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: ImportFlowStep): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.prompt !== "") {
      obj.prompt = message.prompt;
    }
    if (message.position !== undefined) {
      obj.position = StepPosition.toJSON(message.position);
    }
    if (message.asrBiasing !== undefined) {
      obj.asrBiasing = StepAsrConfig.toJSON(message.asrBiasing);
    }
    if (message.dtmfConfig !== undefined) {
      obj.dtmfConfig = StepDtmfConfig.toJSON(message.dtmfConfig);
    }
    if (message.references !== undefined) {
      obj.references = StepReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<ImportFlowStep>): ImportFlowStep {
    return ImportFlowStep.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ImportFlowStep>): ImportFlowStep {
    const message = createBaseImportFlowStep();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.prompt = object.prompt ?? "";
    message.position = (object.position !== undefined && object.position !== null)
      ? StepPosition.fromPartial(object.position)
      : undefined;
    message.asrBiasing = (object.asrBiasing !== undefined && object.asrBiasing !== null)
      ? StepAsrConfig.fromPartial(object.asrBiasing)
      : undefined;
    message.dtmfConfig = (object.dtmfConfig !== undefined && object.dtmfConfig !== null)
      ? StepDtmfConfig.fromPartial(object.dtmfConfig)
      : undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? StepReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBaseFlowUpdateStepAsrConfig(): FlowUpdateStepAsrConfig {
  return { flowId: "", stepId: "", asrBiasing: undefined };
}

export const FlowUpdateStepAsrConfig: MessageFns<FlowUpdateStepAsrConfig> = {
  encode(message: FlowUpdateStepAsrConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    if (message.stepId !== "") {
      writer.uint32(18).string(message.stepId);
    }
    if (message.asrBiasing !== undefined) {
      StepAsrConfigUpdate.encode(message.asrBiasing, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FlowUpdateStepAsrConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFlowUpdateStepAsrConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stepId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.asrBiasing = StepAsrConfigUpdate.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FlowUpdateStepAsrConfig {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      stepId: isSet(object.stepId)
        ? globalThis.String(object.stepId)
        : isSet(object.step_id)
        ? globalThis.String(object.step_id)
        : "",
      asrBiasing: isSet(object.asrBiasing)
        ? StepAsrConfigUpdate.fromJSON(object.asrBiasing)
        : isSet(object.asr_biasing)
        ? StepAsrConfigUpdate.fromJSON(object.asr_biasing)
        : undefined,
    };
  },

  toJSON(message: FlowUpdateStepAsrConfig): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.stepId !== "") {
      obj.stepId = message.stepId;
    }
    if (message.asrBiasing !== undefined) {
      obj.asrBiasing = StepAsrConfigUpdate.toJSON(message.asrBiasing);
    }
    return obj;
  },

  create(base?: DeepPartial<FlowUpdateStepAsrConfig>): FlowUpdateStepAsrConfig {
    return FlowUpdateStepAsrConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FlowUpdateStepAsrConfig>): FlowUpdateStepAsrConfig {
    const message = createBaseFlowUpdateStepAsrConfig();
    message.flowId = object.flowId ?? "";
    message.stepId = object.stepId ?? "";
    message.asrBiasing = (object.asrBiasing !== undefined && object.asrBiasing !== null)
      ? StepAsrConfigUpdate.fromPartial(object.asrBiasing)
      : undefined;
    return message;
  },
};

function createBaseStepAsrConfigUpdate(): StepAsrConfigUpdate {
  return {
    alphanumeric: undefined,
    nameSpelling: undefined,
    numeric: undefined,
    partySize: undefined,
    preciseDate: undefined,
    relativeDate: undefined,
    singleNumber: undefined,
    time: undefined,
    yesNo: undefined,
    address: undefined,
    customKeywords: undefined,
    isEnabled: undefined,
  };
}

export const StepAsrConfigUpdate: MessageFns<StepAsrConfigUpdate> = {
  encode(message: StepAsrConfigUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.alphanumeric !== undefined) {
      writer.uint32(24).bool(message.alphanumeric);
    }
    if (message.nameSpelling !== undefined) {
      writer.uint32(32).bool(message.nameSpelling);
    }
    if (message.numeric !== undefined) {
      writer.uint32(40).bool(message.numeric);
    }
    if (message.partySize !== undefined) {
      writer.uint32(48).bool(message.partySize);
    }
    if (message.preciseDate !== undefined) {
      writer.uint32(56).bool(message.preciseDate);
    }
    if (message.relativeDate !== undefined) {
      writer.uint32(64).bool(message.relativeDate);
    }
    if (message.singleNumber !== undefined) {
      writer.uint32(72).bool(message.singleNumber);
    }
    if (message.time !== undefined) {
      writer.uint32(80).bool(message.time);
    }
    if (message.yesNo !== undefined) {
      writer.uint32(88).bool(message.yesNo);
    }
    if (message.address !== undefined) {
      writer.uint32(96).bool(message.address);
    }
    if (message.customKeywords !== undefined) {
      UpdateAsrKeywords.encode(message.customKeywords, writer.uint32(106).fork()).join();
    }
    if (message.isEnabled !== undefined) {
      writer.uint32(112).bool(message.isEnabled);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StepAsrConfigUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStepAsrConfigUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.alphanumeric = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.nameSpelling = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.numeric = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.partySize = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.preciseDate = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.relativeDate = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.singleNumber = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.time = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.yesNo = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.address = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.customKeywords = UpdateAsrKeywords.decode(reader, reader.uint32());
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.isEnabled = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StepAsrConfigUpdate {
    return {
      alphanumeric: isSet(object.alphanumeric) ? globalThis.Boolean(object.alphanumeric) : undefined,
      nameSpelling: isSet(object.nameSpelling)
        ? globalThis.Boolean(object.nameSpelling)
        : isSet(object.name_spelling)
        ? globalThis.Boolean(object.name_spelling)
        : undefined,
      numeric: isSet(object.numeric) ? globalThis.Boolean(object.numeric) : undefined,
      partySize: isSet(object.partySize)
        ? globalThis.Boolean(object.partySize)
        : isSet(object.party_size)
        ? globalThis.Boolean(object.party_size)
        : undefined,
      preciseDate: isSet(object.preciseDate)
        ? globalThis.Boolean(object.preciseDate)
        : isSet(object.precise_date)
        ? globalThis.Boolean(object.precise_date)
        : undefined,
      relativeDate: isSet(object.relativeDate)
        ? globalThis.Boolean(object.relativeDate)
        : isSet(object.relative_date)
        ? globalThis.Boolean(object.relative_date)
        : undefined,
      singleNumber: isSet(object.singleNumber)
        ? globalThis.Boolean(object.singleNumber)
        : isSet(object.single_number)
        ? globalThis.Boolean(object.single_number)
        : undefined,
      time: isSet(object.time) ? globalThis.Boolean(object.time) : undefined,
      yesNo: isSet(object.yesNo)
        ? globalThis.Boolean(object.yesNo)
        : isSet(object.yes_no)
        ? globalThis.Boolean(object.yes_no)
        : undefined,
      address: isSet(object.address) ? globalThis.Boolean(object.address) : undefined,
      customKeywords: isSet(object.customKeywords)
        ? UpdateAsrKeywords.fromJSON(object.customKeywords)
        : isSet(object.custom_keywords)
        ? UpdateAsrKeywords.fromJSON(object.custom_keywords)
        : undefined,
      isEnabled: isSet(object.isEnabled)
        ? globalThis.Boolean(object.isEnabled)
        : isSet(object.is_enabled)
        ? globalThis.Boolean(object.is_enabled)
        : undefined,
    };
  },

  toJSON(message: StepAsrConfigUpdate): unknown {
    const obj: any = {};
    if (message.alphanumeric !== undefined) {
      obj.alphanumeric = message.alphanumeric;
    }
    if (message.nameSpelling !== undefined) {
      obj.nameSpelling = message.nameSpelling;
    }
    if (message.numeric !== undefined) {
      obj.numeric = message.numeric;
    }
    if (message.partySize !== undefined) {
      obj.partySize = message.partySize;
    }
    if (message.preciseDate !== undefined) {
      obj.preciseDate = message.preciseDate;
    }
    if (message.relativeDate !== undefined) {
      obj.relativeDate = message.relativeDate;
    }
    if (message.singleNumber !== undefined) {
      obj.singleNumber = message.singleNumber;
    }
    if (message.time !== undefined) {
      obj.time = message.time;
    }
    if (message.yesNo !== undefined) {
      obj.yesNo = message.yesNo;
    }
    if (message.address !== undefined) {
      obj.address = message.address;
    }
    if (message.customKeywords !== undefined) {
      obj.customKeywords = UpdateAsrKeywords.toJSON(message.customKeywords);
    }
    if (message.isEnabled !== undefined) {
      obj.isEnabled = message.isEnabled;
    }
    return obj;
  },

  create(base?: DeepPartial<StepAsrConfigUpdate>): StepAsrConfigUpdate {
    return StepAsrConfigUpdate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StepAsrConfigUpdate>): StepAsrConfigUpdate {
    const message = createBaseStepAsrConfigUpdate();
    message.alphanumeric = object.alphanumeric ?? undefined;
    message.nameSpelling = object.nameSpelling ?? undefined;
    message.numeric = object.numeric ?? undefined;
    message.partySize = object.partySize ?? undefined;
    message.preciseDate = object.preciseDate ?? undefined;
    message.relativeDate = object.relativeDate ?? undefined;
    message.singleNumber = object.singleNumber ?? undefined;
    message.time = object.time ?? undefined;
    message.yesNo = object.yesNo ?? undefined;
    message.address = object.address ?? undefined;
    message.customKeywords = (object.customKeywords !== undefined && object.customKeywords !== null)
      ? UpdateAsrKeywords.fromPartial(object.customKeywords)
      : undefined;
    message.isEnabled = object.isEnabled ?? undefined;
    return message;
  },
};

function createBaseUpdateAsrKeywords(): UpdateAsrKeywords {
  return { customKeywords: [] };
}

export const UpdateAsrKeywords: MessageFns<UpdateAsrKeywords> = {
  encode(message: UpdateAsrKeywords, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.customKeywords) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateAsrKeywords {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateAsrKeywords();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.customKeywords.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateAsrKeywords {
    return {
      customKeywords: globalThis.Array.isArray(object?.customKeywords)
        ? object.customKeywords.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.custom_keywords)
        ? object.custom_keywords.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: UpdateAsrKeywords): unknown {
    const obj: any = {};
    if (message.customKeywords?.length) {
      obj.customKeywords = message.customKeywords;
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateAsrKeywords>): UpdateAsrKeywords {
    return UpdateAsrKeywords.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateAsrKeywords>): UpdateAsrKeywords {
    const message = createBaseUpdateAsrKeywords();
    message.customKeywords = object.customKeywords?.map((e) => e) || [];
    return message;
  },
};

function createBaseFlowUpdateStepDtmfConfig(): FlowUpdateStepDtmfConfig {
  return { flowId: "", stepId: "", dtmfConfig: undefined };
}

export const FlowUpdateStepDtmfConfig: MessageFns<FlowUpdateStepDtmfConfig> = {
  encode(message: FlowUpdateStepDtmfConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    if (message.stepId !== "") {
      writer.uint32(18).string(message.stepId);
    }
    if (message.dtmfConfig !== undefined) {
      StepDtmfConfigUpdate.encode(message.dtmfConfig, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FlowUpdateStepDtmfConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFlowUpdateStepDtmfConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stepId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.dtmfConfig = StepDtmfConfigUpdate.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FlowUpdateStepDtmfConfig {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      stepId: isSet(object.stepId)
        ? globalThis.String(object.stepId)
        : isSet(object.step_id)
        ? globalThis.String(object.step_id)
        : "",
      dtmfConfig: isSet(object.dtmfConfig)
        ? StepDtmfConfigUpdate.fromJSON(object.dtmfConfig)
        : isSet(object.dtmf_config)
        ? StepDtmfConfigUpdate.fromJSON(object.dtmf_config)
        : undefined,
    };
  },

  toJSON(message: FlowUpdateStepDtmfConfig): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.stepId !== "") {
      obj.stepId = message.stepId;
    }
    if (message.dtmfConfig !== undefined) {
      obj.dtmfConfig = StepDtmfConfigUpdate.toJSON(message.dtmfConfig);
    }
    return obj;
  },

  create(base?: DeepPartial<FlowUpdateStepDtmfConfig>): FlowUpdateStepDtmfConfig {
    return FlowUpdateStepDtmfConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FlowUpdateStepDtmfConfig>): FlowUpdateStepDtmfConfig {
    const message = createBaseFlowUpdateStepDtmfConfig();
    message.flowId = object.flowId ?? "";
    message.stepId = object.stepId ?? "";
    message.dtmfConfig = (object.dtmfConfig !== undefined && object.dtmfConfig !== null)
      ? StepDtmfConfigUpdate.fromPartial(object.dtmfConfig)
      : undefined;
    return message;
  },
};

function createBaseStepDtmfConfigUpdate(): StepDtmfConfigUpdate {
  return {
    isEnabled: undefined,
    interDigitTimeout: undefined,
    maxDigits: undefined,
    endKey: undefined,
    collectWhileAgentSpeaking: undefined,
    isPii: undefined,
  };
}

export const StepDtmfConfigUpdate: MessageFns<StepDtmfConfigUpdate> = {
  encode(message: StepDtmfConfigUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.isEnabled !== undefined) {
      writer.uint32(24).bool(message.isEnabled);
    }
    if (message.interDigitTimeout !== undefined) {
      writer.uint32(32).int32(message.interDigitTimeout);
    }
    if (message.maxDigits !== undefined) {
      writer.uint32(40).int32(message.maxDigits);
    }
    if (message.endKey !== undefined) {
      writer.uint32(50).string(message.endKey);
    }
    if (message.collectWhileAgentSpeaking !== undefined) {
      writer.uint32(56).bool(message.collectWhileAgentSpeaking);
    }
    if (message.isPii !== undefined) {
      writer.uint32(64).bool(message.isPii);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StepDtmfConfigUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStepDtmfConfigUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.isEnabled = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.interDigitTimeout = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.maxDigits = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.endKey = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.collectWhileAgentSpeaking = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.isPii = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StepDtmfConfigUpdate {
    return {
      isEnabled: isSet(object.isEnabled)
        ? globalThis.Boolean(object.isEnabled)
        : isSet(object.is_enabled)
        ? globalThis.Boolean(object.is_enabled)
        : undefined,
      interDigitTimeout: isSet(object.interDigitTimeout)
        ? globalThis.Number(object.interDigitTimeout)
        : isSet(object.inter_digit_timeout)
        ? globalThis.Number(object.inter_digit_timeout)
        : undefined,
      maxDigits: isSet(object.maxDigits)
        ? globalThis.Number(object.maxDigits)
        : isSet(object.max_digits)
        ? globalThis.Number(object.max_digits)
        : undefined,
      endKey: isSet(object.endKey)
        ? globalThis.String(object.endKey)
        : isSet(object.end_key)
        ? globalThis.String(object.end_key)
        : undefined,
      collectWhileAgentSpeaking: isSet(object.collectWhileAgentSpeaking)
        ? globalThis.Boolean(object.collectWhileAgentSpeaking)
        : isSet(object.collect_while_agent_speaking)
        ? globalThis.Boolean(object.collect_while_agent_speaking)
        : undefined,
      isPii: isSet(object.isPii)
        ? globalThis.Boolean(object.isPii)
        : isSet(object.is_pii)
        ? globalThis.Boolean(object.is_pii)
        : undefined,
    };
  },

  toJSON(message: StepDtmfConfigUpdate): unknown {
    const obj: any = {};
    if (message.isEnabled !== undefined) {
      obj.isEnabled = message.isEnabled;
    }
    if (message.interDigitTimeout !== undefined) {
      obj.interDigitTimeout = Math.round(message.interDigitTimeout);
    }
    if (message.maxDigits !== undefined) {
      obj.maxDigits = Math.round(message.maxDigits);
    }
    if (message.endKey !== undefined) {
      obj.endKey = message.endKey;
    }
    if (message.collectWhileAgentSpeaking !== undefined) {
      obj.collectWhileAgentSpeaking = message.collectWhileAgentSpeaking;
    }
    if (message.isPii !== undefined) {
      obj.isPii = message.isPii;
    }
    return obj;
  },

  create(base?: DeepPartial<StepDtmfConfigUpdate>): StepDtmfConfigUpdate {
    return StepDtmfConfigUpdate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StepDtmfConfigUpdate>): StepDtmfConfigUpdate {
    const message = createBaseStepDtmfConfigUpdate();
    message.isEnabled = object.isEnabled ?? undefined;
    message.interDigitTimeout = object.interDigitTimeout ?? undefined;
    message.maxDigits = object.maxDigits ?? undefined;
    message.endKey = object.endKey ?? undefined;
    message.collectWhileAgentSpeaking = object.collectWhileAgentSpeaking ?? undefined;
    message.isPii = object.isPii ?? undefined;
    return message;
  },
};

function createBaseFlowUpdateStepPosition(): FlowUpdateStepPosition {
  return { flowId: "", positionUpdate: undefined };
}

export const FlowUpdateStepPosition: MessageFns<FlowUpdateStepPosition> = {
  encode(message: FlowUpdateStepPosition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    if (message.positionUpdate !== undefined) {
      StepPositionUpdate.encode(message.positionUpdate, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FlowUpdateStepPosition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFlowUpdateStepPosition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.positionUpdate = StepPositionUpdate.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FlowUpdateStepPosition {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      positionUpdate: isSet(object.positionUpdate)
        ? StepPositionUpdate.fromJSON(object.positionUpdate)
        : isSet(object.position_update)
        ? StepPositionUpdate.fromJSON(object.position_update)
        : undefined,
    };
  },

  toJSON(message: FlowUpdateStepPosition): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.positionUpdate !== undefined) {
      obj.positionUpdate = StepPositionUpdate.toJSON(message.positionUpdate);
    }
    return obj;
  },

  create(base?: DeepPartial<FlowUpdateStepPosition>): FlowUpdateStepPosition {
    return FlowUpdateStepPosition.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FlowUpdateStepPosition>): FlowUpdateStepPosition {
    const message = createBaseFlowUpdateStepPosition();
    message.flowId = object.flowId ?? "";
    message.positionUpdate = (object.positionUpdate !== undefined && object.positionUpdate !== null)
      ? StepPositionUpdate.fromPartial(object.positionUpdate)
      : undefined;
    return message;
  },
};

function createBaseFlowUpdateStepPositions(): FlowUpdateStepPositions {
  return { flowId: "", newPositions: [] };
}

export const FlowUpdateStepPositions: MessageFns<FlowUpdateStepPositions> = {
  encode(message: FlowUpdateStepPositions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    for (const v of message.newPositions) {
      StepPositionUpdate.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FlowUpdateStepPositions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFlowUpdateStepPositions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.newPositions.push(StepPositionUpdate.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FlowUpdateStepPositions {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      newPositions: globalThis.Array.isArray(object?.newPositions)
        ? object.newPositions.map((e: any) => StepPositionUpdate.fromJSON(e))
        : globalThis.Array.isArray(object?.new_positions)
        ? object.new_positions.map((e: any) => StepPositionUpdate.fromJSON(e))
        : [],
    };
  },

  toJSON(message: FlowUpdateStepPositions): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.newPositions?.length) {
      obj.newPositions = message.newPositions.map((e) => StepPositionUpdate.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<FlowUpdateStepPositions>): FlowUpdateStepPositions {
    return FlowUpdateStepPositions.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FlowUpdateStepPositions>): FlowUpdateStepPositions {
    const message = createBaseFlowUpdateStepPositions();
    message.flowId = object.flowId ?? "";
    message.newPositions = object.newPositions?.map((e) => StepPositionUpdate.fromPartial(e)) || [];
    return message;
  },
};

function createBaseStepPositionUpdate(): StepPositionUpdate {
  return { stepId: "", newPosition: undefined };
}

export const StepPositionUpdate: MessageFns<StepPositionUpdate> = {
  encode(message: StepPositionUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.stepId !== "") {
      writer.uint32(10).string(message.stepId);
    }
    if (message.newPosition !== undefined) {
      StepPosition.encode(message.newPosition, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StepPositionUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStepPositionUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.stepId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.newPosition = StepPosition.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StepPositionUpdate {
    return {
      stepId: isSet(object.stepId)
        ? globalThis.String(object.stepId)
        : isSet(object.step_id)
        ? globalThis.String(object.step_id)
        : "",
      newPosition: isSet(object.newPosition)
        ? StepPosition.fromJSON(object.newPosition)
        : isSet(object.new_position)
        ? StepPosition.fromJSON(object.new_position)
        : undefined,
    };
  },

  toJSON(message: StepPositionUpdate): unknown {
    const obj: any = {};
    if (message.stepId !== "") {
      obj.stepId = message.stepId;
    }
    if (message.newPosition !== undefined) {
      obj.newPosition = StepPosition.toJSON(message.newPosition);
    }
    return obj;
  },

  create(base?: DeepPartial<StepPositionUpdate>): StepPositionUpdate {
    return StepPositionUpdate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StepPositionUpdate>): StepPositionUpdate {
    const message = createBaseStepPositionUpdate();
    message.stepId = object.stepId ?? "";
    message.newPosition = (object.newPosition !== undefined && object.newPosition !== null)
      ? StepPosition.fromPartial(object.newPosition)
      : undefined;
    return message;
  },
};

function createBaseMoveFlowComponent(): MoveFlowComponent {
  return { flowId: "", positionDetail: undefined };
}

export const MoveFlowComponent: MessageFns<MoveFlowComponent> = {
  encode(message: MoveFlowComponent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    if (message.positionDetail !== undefined) {
      FlowPositionDetail.encode(message.positionDetail, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MoveFlowComponent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMoveFlowComponent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.positionDetail = FlowPositionDetail.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MoveFlowComponent {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      positionDetail: isSet(object.positionDetail)
        ? FlowPositionDetail.fromJSON(object.positionDetail)
        : isSet(object.position_detail)
        ? FlowPositionDetail.fromJSON(object.position_detail)
        : undefined,
    };
  },

  toJSON(message: MoveFlowComponent): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.positionDetail !== undefined) {
      obj.positionDetail = FlowPositionDetail.toJSON(message.positionDetail);
    }
    return obj;
  },

  create(base?: DeepPartial<MoveFlowComponent>): MoveFlowComponent {
    return MoveFlowComponent.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MoveFlowComponent>): MoveFlowComponent {
    const message = createBaseMoveFlowComponent();
    message.flowId = object.flowId ?? "";
    message.positionDetail = (object.positionDetail !== undefined && object.positionDetail !== null)
      ? FlowPositionDetail.fromPartial(object.positionDetail)
      : undefined;
    return message;
  },
};

function createBaseMoveFlowComponents(): MoveFlowComponents {
  return { flowId: "", positionDetails: [] };
}

export const MoveFlowComponents: MessageFns<MoveFlowComponents> = {
  encode(message: MoveFlowComponents, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    for (const v of message.positionDetails) {
      FlowPositionDetail.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MoveFlowComponents {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMoveFlowComponents();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.positionDetails.push(FlowPositionDetail.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MoveFlowComponents {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      positionDetails: globalThis.Array.isArray(object?.positionDetails)
        ? object.positionDetails.map((e: any) => FlowPositionDetail.fromJSON(e))
        : globalThis.Array.isArray(object?.position_details)
        ? object.position_details.map((e: any) => FlowPositionDetail.fromJSON(e))
        : [],
    };
  },

  toJSON(message: MoveFlowComponents): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.positionDetails?.length) {
      obj.positionDetails = message.positionDetails.map((e) => FlowPositionDetail.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<MoveFlowComponents>): MoveFlowComponents {
    return MoveFlowComponents.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MoveFlowComponents>): MoveFlowComponents {
    const message = createBaseMoveFlowComponents();
    message.flowId = object.flowId ?? "";
    message.positionDetails = object.positionDetails?.map((e) => FlowPositionDetail.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFlowPositionDetail(): FlowPositionDetail {
  return { detail: undefined };
}

export const FlowPositionDetail: MessageFns<FlowPositionDetail> = {
  encode(message: FlowPositionDetail, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.detail?.$case) {
      case "flowStep":
        FlowStepPositionDetails.encode(message.detail.value, writer.uint32(10).fork()).join();
        break;
      case "noCodeStep":
        NoCodeStepPositionDetail.encode(message.detail.value, writer.uint32(18).fork()).join();
        break;
      case "noCodeStepCondition":
        NoCodeStepConditionPositionDetail.encode(message.detail.value, writer.uint32(26).fork()).join();
        break;
      case "noCodeStepConditionExitFlow":
        NoCodeStepExitFlowPositionDetail.encode(message.detail.value, writer.uint32(34).fork()).join();
        break;
      case "functionStep":
        FunctionStepPositionDetail.encode(message.detail.value, writer.uint32(42).fork()).join();
        break;
      case "functionStepCondition":
        FunctionStepConditionPositionDetail.encode(message.detail.value, writer.uint32(50).fork()).join();
        break;
      case "functionStepConditionExitFlow":
        FunctionStepExitFlowPositionDetail.encode(message.detail.value, writer.uint32(58).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FlowPositionDetail {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFlowPositionDetail();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.detail = { $case: "flowStep", value: FlowStepPositionDetails.decode(reader, reader.uint32()) };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.detail = { $case: "noCodeStep", value: NoCodeStepPositionDetail.decode(reader, reader.uint32()) };
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.detail = {
            $case: "noCodeStepCondition",
            value: NoCodeStepConditionPositionDetail.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.detail = {
            $case: "noCodeStepConditionExitFlow",
            value: NoCodeStepExitFlowPositionDetail.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.detail = { $case: "functionStep", value: FunctionStepPositionDetail.decode(reader, reader.uint32()) };
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.detail = {
            $case: "functionStepCondition",
            value: FunctionStepConditionPositionDetail.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.detail = {
            $case: "functionStepConditionExitFlow",
            value: FunctionStepExitFlowPositionDetail.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FlowPositionDetail {
    return {
      detail: isSet(object.flowStep)
        ? { $case: "flowStep", value: FlowStepPositionDetails.fromJSON(object.flowStep) }
        : isSet(object.flow_step)
        ? { $case: "flowStep", value: FlowStepPositionDetails.fromJSON(object.flow_step) }
        : isSet(object.noCodeStep)
        ? { $case: "noCodeStep", value: NoCodeStepPositionDetail.fromJSON(object.noCodeStep) }
        : isSet(object.no_code_step)
        ? { $case: "noCodeStep", value: NoCodeStepPositionDetail.fromJSON(object.no_code_step) }
        : isSet(object.noCodeStepCondition)
        ? {
          $case: "noCodeStepCondition",
          value: NoCodeStepConditionPositionDetail.fromJSON(object.noCodeStepCondition),
        }
        : isSet(object.no_code_step_condition)
        ? {
          $case: "noCodeStepCondition",
          value: NoCodeStepConditionPositionDetail.fromJSON(object.no_code_step_condition),
        }
        : isSet(object.noCodeStepConditionExitFlow)
        ? {
          $case: "noCodeStepConditionExitFlow",
          value: NoCodeStepExitFlowPositionDetail.fromJSON(object.noCodeStepConditionExitFlow),
        }
        : isSet(object.no_code_step_condition_exit_flow)
        ? {
          $case: "noCodeStepConditionExitFlow",
          value: NoCodeStepExitFlowPositionDetail.fromJSON(object.no_code_step_condition_exit_flow),
        }
        : isSet(object.functionStep)
        ? { $case: "functionStep", value: FunctionStepPositionDetail.fromJSON(object.functionStep) }
        : isSet(object.function_step)
        ? { $case: "functionStep", value: FunctionStepPositionDetail.fromJSON(object.function_step) }
        : isSet(object.functionStepCondition)
        ? {
          $case: "functionStepCondition",
          value: FunctionStepConditionPositionDetail.fromJSON(object.functionStepCondition),
        }
        : isSet(object.function_step_condition)
        ? {
          $case: "functionStepCondition",
          value: FunctionStepConditionPositionDetail.fromJSON(object.function_step_condition),
        }
        : isSet(object.functionStepConditionExitFlow)
        ? {
          $case: "functionStepConditionExitFlow",
          value: FunctionStepExitFlowPositionDetail.fromJSON(object.functionStepConditionExitFlow),
        }
        : isSet(object.function_step_condition_exit_flow)
        ? {
          $case: "functionStepConditionExitFlow",
          value: FunctionStepExitFlowPositionDetail.fromJSON(object.function_step_condition_exit_flow),
        }
        : undefined,
    };
  },

  toJSON(message: FlowPositionDetail): unknown {
    const obj: any = {};
    if (message.detail?.$case === "flowStep") {
      obj.flowStep = FlowStepPositionDetails.toJSON(message.detail.value);
    } else if (message.detail?.$case === "noCodeStep") {
      obj.noCodeStep = NoCodeStepPositionDetail.toJSON(message.detail.value);
    } else if (message.detail?.$case === "noCodeStepCondition") {
      obj.noCodeStepCondition = NoCodeStepConditionPositionDetail.toJSON(message.detail.value);
    } else if (message.detail?.$case === "noCodeStepConditionExitFlow") {
      obj.noCodeStepConditionExitFlow = NoCodeStepExitFlowPositionDetail.toJSON(message.detail.value);
    } else if (message.detail?.$case === "functionStep") {
      obj.functionStep = FunctionStepPositionDetail.toJSON(message.detail.value);
    } else if (message.detail?.$case === "functionStepCondition") {
      obj.functionStepCondition = FunctionStepConditionPositionDetail.toJSON(message.detail.value);
    } else if (message.detail?.$case === "functionStepConditionExitFlow") {
      obj.functionStepConditionExitFlow = FunctionStepExitFlowPositionDetail.toJSON(message.detail.value);
    }
    return obj;
  },

  create(base?: DeepPartial<FlowPositionDetail>): FlowPositionDetail {
    return FlowPositionDetail.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FlowPositionDetail>): FlowPositionDetail {
    const message = createBaseFlowPositionDetail();
    switch (object.detail?.$case) {
      case "flowStep": {
        if (object.detail?.value !== undefined && object.detail?.value !== null) {
          message.detail = { $case: "flowStep", value: FlowStepPositionDetails.fromPartial(object.detail.value) };
        }
        break;
      }
      case "noCodeStep": {
        if (object.detail?.value !== undefined && object.detail?.value !== null) {
          message.detail = { $case: "noCodeStep", value: NoCodeStepPositionDetail.fromPartial(object.detail.value) };
        }
        break;
      }
      case "noCodeStepCondition": {
        if (object.detail?.value !== undefined && object.detail?.value !== null) {
          message.detail = {
            $case: "noCodeStepCondition",
            value: NoCodeStepConditionPositionDetail.fromPartial(object.detail.value),
          };
        }
        break;
      }
      case "noCodeStepConditionExitFlow": {
        if (object.detail?.value !== undefined && object.detail?.value !== null) {
          message.detail = {
            $case: "noCodeStepConditionExitFlow",
            value: NoCodeStepExitFlowPositionDetail.fromPartial(object.detail.value),
          };
        }
        break;
      }
      case "functionStep": {
        if (object.detail?.value !== undefined && object.detail?.value !== null) {
          message.detail = {
            $case: "functionStep",
            value: FunctionStepPositionDetail.fromPartial(object.detail.value),
          };
        }
        break;
      }
      case "functionStepCondition": {
        if (object.detail?.value !== undefined && object.detail?.value !== null) {
          message.detail = {
            $case: "functionStepCondition",
            value: FunctionStepConditionPositionDetail.fromPartial(object.detail.value),
          };
        }
        break;
      }
      case "functionStepConditionExitFlow": {
        if (object.detail?.value !== undefined && object.detail?.value !== null) {
          message.detail = {
            $case: "functionStepConditionExitFlow",
            value: FunctionStepExitFlowPositionDetail.fromPartial(object.detail.value),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseFlowStepPositionDetails(): FlowStepPositionDetails {
  return { stepId: "", newPosition: undefined };
}

export const FlowStepPositionDetails: MessageFns<FlowStepPositionDetails> = {
  encode(message: FlowStepPositionDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.stepId !== "") {
      writer.uint32(10).string(message.stepId);
    }
    if (message.newPosition !== undefined) {
      StepPosition.encode(message.newPosition, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FlowStepPositionDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFlowStepPositionDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.stepId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.newPosition = StepPosition.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FlowStepPositionDetails {
    return {
      stepId: isSet(object.stepId)
        ? globalThis.String(object.stepId)
        : isSet(object.step_id)
        ? globalThis.String(object.step_id)
        : "",
      newPosition: isSet(object.newPosition)
        ? StepPosition.fromJSON(object.newPosition)
        : isSet(object.new_position)
        ? StepPosition.fromJSON(object.new_position)
        : undefined,
    };
  },

  toJSON(message: FlowStepPositionDetails): unknown {
    const obj: any = {};
    if (message.stepId !== "") {
      obj.stepId = message.stepId;
    }
    if (message.newPosition !== undefined) {
      obj.newPosition = StepPosition.toJSON(message.newPosition);
    }
    return obj;
  },

  create(base?: DeepPartial<FlowStepPositionDetails>): FlowStepPositionDetails {
    return FlowStepPositionDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FlowStepPositionDetails>): FlowStepPositionDetails {
    const message = createBaseFlowStepPositionDetails();
    message.stepId = object.stepId ?? "";
    message.newPosition = (object.newPosition !== undefined && object.newPosition !== null)
      ? StepPosition.fromPartial(object.newPosition)
      : undefined;
    return message;
  },
};

function createBaseNoCodeStepPositionDetail(): NoCodeStepPositionDetail {
  return { stepId: "", newPosition: undefined };
}

export const NoCodeStepPositionDetail: MessageFns<NoCodeStepPositionDetail> = {
  encode(message: NoCodeStepPositionDetail, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.stepId !== "") {
      writer.uint32(10).string(message.stepId);
    }
    if (message.newPosition !== undefined) {
      StepPosition.encode(message.newPosition, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NoCodeStepPositionDetail {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNoCodeStepPositionDetail();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.stepId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.newPosition = StepPosition.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NoCodeStepPositionDetail {
    return {
      stepId: isSet(object.stepId)
        ? globalThis.String(object.stepId)
        : isSet(object.step_id)
        ? globalThis.String(object.step_id)
        : "",
      newPosition: isSet(object.newPosition)
        ? StepPosition.fromJSON(object.newPosition)
        : isSet(object.new_position)
        ? StepPosition.fromJSON(object.new_position)
        : undefined,
    };
  },

  toJSON(message: NoCodeStepPositionDetail): unknown {
    const obj: any = {};
    if (message.stepId !== "") {
      obj.stepId = message.stepId;
    }
    if (message.newPosition !== undefined) {
      obj.newPosition = StepPosition.toJSON(message.newPosition);
    }
    return obj;
  },

  create(base?: DeepPartial<NoCodeStepPositionDetail>): NoCodeStepPositionDetail {
    return NoCodeStepPositionDetail.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<NoCodeStepPositionDetail>): NoCodeStepPositionDetail {
    const message = createBaseNoCodeStepPositionDetail();
    message.stepId = object.stepId ?? "";
    message.newPosition = (object.newPosition !== undefined && object.newPosition !== null)
      ? StepPosition.fromPartial(object.newPosition)
      : undefined;
    return message;
  },
};

function createBaseNoCodeStepConditionPositionDetail(): NoCodeStepConditionPositionDetail {
  return { stepId: "", conditionId: "", newPosition: undefined };
}

export const NoCodeStepConditionPositionDetail: MessageFns<NoCodeStepConditionPositionDetail> = {
  encode(message: NoCodeStepConditionPositionDetail, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.stepId !== "") {
      writer.uint32(10).string(message.stepId);
    }
    if (message.conditionId !== "") {
      writer.uint32(18).string(message.conditionId);
    }
    if (message.newPosition !== undefined) {
      StepPosition.encode(message.newPosition, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NoCodeStepConditionPositionDetail {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNoCodeStepConditionPositionDetail();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.stepId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.conditionId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.newPosition = StepPosition.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NoCodeStepConditionPositionDetail {
    return {
      stepId: isSet(object.stepId)
        ? globalThis.String(object.stepId)
        : isSet(object.step_id)
        ? globalThis.String(object.step_id)
        : "",
      conditionId: isSet(object.conditionId)
        ? globalThis.String(object.conditionId)
        : isSet(object.condition_id)
        ? globalThis.String(object.condition_id)
        : "",
      newPosition: isSet(object.newPosition)
        ? StepPosition.fromJSON(object.newPosition)
        : isSet(object.new_position)
        ? StepPosition.fromJSON(object.new_position)
        : undefined,
    };
  },

  toJSON(message: NoCodeStepConditionPositionDetail): unknown {
    const obj: any = {};
    if (message.stepId !== "") {
      obj.stepId = message.stepId;
    }
    if (message.conditionId !== "") {
      obj.conditionId = message.conditionId;
    }
    if (message.newPosition !== undefined) {
      obj.newPosition = StepPosition.toJSON(message.newPosition);
    }
    return obj;
  },

  create(base?: DeepPartial<NoCodeStepConditionPositionDetail>): NoCodeStepConditionPositionDetail {
    return NoCodeStepConditionPositionDetail.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<NoCodeStepConditionPositionDetail>): NoCodeStepConditionPositionDetail {
    const message = createBaseNoCodeStepConditionPositionDetail();
    message.stepId = object.stepId ?? "";
    message.conditionId = object.conditionId ?? "";
    message.newPosition = (object.newPosition !== undefined && object.newPosition !== null)
      ? StepPosition.fromPartial(object.newPosition)
      : undefined;
    return message;
  },
};

function createBaseNoCodeStepExitFlowPositionDetail(): NoCodeStepExitFlowPositionDetail {
  return { stepId: "", conditionId: "", newPosition: undefined };
}

export const NoCodeStepExitFlowPositionDetail: MessageFns<NoCodeStepExitFlowPositionDetail> = {
  encode(message: NoCodeStepExitFlowPositionDetail, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.stepId !== "") {
      writer.uint32(10).string(message.stepId);
    }
    if (message.conditionId !== "") {
      writer.uint32(18).string(message.conditionId);
    }
    if (message.newPosition !== undefined) {
      StepPosition.encode(message.newPosition, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NoCodeStepExitFlowPositionDetail {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNoCodeStepExitFlowPositionDetail();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.stepId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.conditionId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.newPosition = StepPosition.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NoCodeStepExitFlowPositionDetail {
    return {
      stepId: isSet(object.stepId)
        ? globalThis.String(object.stepId)
        : isSet(object.step_id)
        ? globalThis.String(object.step_id)
        : "",
      conditionId: isSet(object.conditionId)
        ? globalThis.String(object.conditionId)
        : isSet(object.condition_id)
        ? globalThis.String(object.condition_id)
        : "",
      newPosition: isSet(object.newPosition)
        ? StepPosition.fromJSON(object.newPosition)
        : isSet(object.new_position)
        ? StepPosition.fromJSON(object.new_position)
        : undefined,
    };
  },

  toJSON(message: NoCodeStepExitFlowPositionDetail): unknown {
    const obj: any = {};
    if (message.stepId !== "") {
      obj.stepId = message.stepId;
    }
    if (message.conditionId !== "") {
      obj.conditionId = message.conditionId;
    }
    if (message.newPosition !== undefined) {
      obj.newPosition = StepPosition.toJSON(message.newPosition);
    }
    return obj;
  },

  create(base?: DeepPartial<NoCodeStepExitFlowPositionDetail>): NoCodeStepExitFlowPositionDetail {
    return NoCodeStepExitFlowPositionDetail.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<NoCodeStepExitFlowPositionDetail>): NoCodeStepExitFlowPositionDetail {
    const message = createBaseNoCodeStepExitFlowPositionDetail();
    message.stepId = object.stepId ?? "";
    message.conditionId = object.conditionId ?? "";
    message.newPosition = (object.newPosition !== undefined && object.newPosition !== null)
      ? StepPosition.fromPartial(object.newPosition)
      : undefined;
    return message;
  },
};

function createBaseFunctionStepPositionDetail(): FunctionStepPositionDetail {
  return { stepId: "", newPosition: undefined };
}

export const FunctionStepPositionDetail: MessageFns<FunctionStepPositionDetail> = {
  encode(message: FunctionStepPositionDetail, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.stepId !== "") {
      writer.uint32(10).string(message.stepId);
    }
    if (message.newPosition !== undefined) {
      StepPosition.encode(message.newPosition, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionStepPositionDetail {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionStepPositionDetail();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.stepId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.newPosition = StepPosition.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionStepPositionDetail {
    return {
      stepId: isSet(object.stepId)
        ? globalThis.String(object.stepId)
        : isSet(object.step_id)
        ? globalThis.String(object.step_id)
        : "",
      newPosition: isSet(object.newPosition)
        ? StepPosition.fromJSON(object.newPosition)
        : isSet(object.new_position)
        ? StepPosition.fromJSON(object.new_position)
        : undefined,
    };
  },

  toJSON(message: FunctionStepPositionDetail): unknown {
    const obj: any = {};
    if (message.stepId !== "") {
      obj.stepId = message.stepId;
    }
    if (message.newPosition !== undefined) {
      obj.newPosition = StepPosition.toJSON(message.newPosition);
    }
    return obj;
  },

  create(base?: DeepPartial<FunctionStepPositionDetail>): FunctionStepPositionDetail {
    return FunctionStepPositionDetail.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FunctionStepPositionDetail>): FunctionStepPositionDetail {
    const message = createBaseFunctionStepPositionDetail();
    message.stepId = object.stepId ?? "";
    message.newPosition = (object.newPosition !== undefined && object.newPosition !== null)
      ? StepPosition.fromPartial(object.newPosition)
      : undefined;
    return message;
  },
};

function createBaseFunctionStepConditionPositionDetail(): FunctionStepConditionPositionDetail {
  return { stepId: "", conditionId: "", newPosition: undefined };
}

export const FunctionStepConditionPositionDetail: MessageFns<FunctionStepConditionPositionDetail> = {
  encode(message: FunctionStepConditionPositionDetail, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.stepId !== "") {
      writer.uint32(10).string(message.stepId);
    }
    if (message.conditionId !== "") {
      writer.uint32(18).string(message.conditionId);
    }
    if (message.newPosition !== undefined) {
      StepPosition.encode(message.newPosition, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionStepConditionPositionDetail {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionStepConditionPositionDetail();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.stepId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.conditionId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.newPosition = StepPosition.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionStepConditionPositionDetail {
    return {
      stepId: isSet(object.stepId)
        ? globalThis.String(object.stepId)
        : isSet(object.step_id)
        ? globalThis.String(object.step_id)
        : "",
      conditionId: isSet(object.conditionId)
        ? globalThis.String(object.conditionId)
        : isSet(object.condition_id)
        ? globalThis.String(object.condition_id)
        : "",
      newPosition: isSet(object.newPosition)
        ? StepPosition.fromJSON(object.newPosition)
        : isSet(object.new_position)
        ? StepPosition.fromJSON(object.new_position)
        : undefined,
    };
  },

  toJSON(message: FunctionStepConditionPositionDetail): unknown {
    const obj: any = {};
    if (message.stepId !== "") {
      obj.stepId = message.stepId;
    }
    if (message.conditionId !== "") {
      obj.conditionId = message.conditionId;
    }
    if (message.newPosition !== undefined) {
      obj.newPosition = StepPosition.toJSON(message.newPosition);
    }
    return obj;
  },

  create(base?: DeepPartial<FunctionStepConditionPositionDetail>): FunctionStepConditionPositionDetail {
    return FunctionStepConditionPositionDetail.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FunctionStepConditionPositionDetail>): FunctionStepConditionPositionDetail {
    const message = createBaseFunctionStepConditionPositionDetail();
    message.stepId = object.stepId ?? "";
    message.conditionId = object.conditionId ?? "";
    message.newPosition = (object.newPosition !== undefined && object.newPosition !== null)
      ? StepPosition.fromPartial(object.newPosition)
      : undefined;
    return message;
  },
};

function createBaseFunctionStepExitFlowPositionDetail(): FunctionStepExitFlowPositionDetail {
  return { stepId: "", conditionId: "", newPosition: undefined };
}

export const FunctionStepExitFlowPositionDetail: MessageFns<FunctionStepExitFlowPositionDetail> = {
  encode(message: FunctionStepExitFlowPositionDetail, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.stepId !== "") {
      writer.uint32(10).string(message.stepId);
    }
    if (message.conditionId !== "") {
      writer.uint32(18).string(message.conditionId);
    }
    if (message.newPosition !== undefined) {
      StepPosition.encode(message.newPosition, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionStepExitFlowPositionDetail {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionStepExitFlowPositionDetail();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.stepId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.conditionId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.newPosition = StepPosition.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionStepExitFlowPositionDetail {
    return {
      stepId: isSet(object.stepId)
        ? globalThis.String(object.stepId)
        : isSet(object.step_id)
        ? globalThis.String(object.step_id)
        : "",
      conditionId: isSet(object.conditionId)
        ? globalThis.String(object.conditionId)
        : isSet(object.condition_id)
        ? globalThis.String(object.condition_id)
        : "",
      newPosition: isSet(object.newPosition)
        ? StepPosition.fromJSON(object.newPosition)
        : isSet(object.new_position)
        ? StepPosition.fromJSON(object.new_position)
        : undefined,
    };
  },

  toJSON(message: FunctionStepExitFlowPositionDetail): unknown {
    const obj: any = {};
    if (message.stepId !== "") {
      obj.stepId = message.stepId;
    }
    if (message.conditionId !== "") {
      obj.conditionId = message.conditionId;
    }
    if (message.newPosition !== undefined) {
      obj.newPosition = StepPosition.toJSON(message.newPosition);
    }
    return obj;
  },

  create(base?: DeepPartial<FunctionStepExitFlowPositionDetail>): FunctionStepExitFlowPositionDetail {
    return FunctionStepExitFlowPositionDetail.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FunctionStepExitFlowPositionDetail>): FunctionStepExitFlowPositionDetail {
    const message = createBaseFunctionStepExitFlowPositionDetail();
    message.stepId = object.stepId ?? "";
    message.conditionId = object.conditionId ?? "";
    message.newPosition = (object.newPosition !== undefined && object.newPosition !== null)
      ? StepPosition.fromPartial(object.newPosition)
      : undefined;
    return message;
  },
};

function createBaseFlowCreateTransitionFunction(): FlowCreateTransitionFunction {
  return { flowId: "", transitionFunction: undefined };
}

export const FlowCreateTransitionFunction: MessageFns<FlowCreateTransitionFunction> = {
  encode(message: FlowCreateTransitionFunction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    if (message.transitionFunction !== undefined) {
      TransitionFunctionCreateTransitionFunction.encode(message.transitionFunction, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FlowCreateTransitionFunction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFlowCreateTransitionFunction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.transitionFunction = TransitionFunctionCreateTransitionFunction.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FlowCreateTransitionFunction {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      transitionFunction: isSet(object.transitionFunction)
        ? TransitionFunctionCreateTransitionFunction.fromJSON(object.transitionFunction)
        : isSet(object.transition_function)
        ? TransitionFunctionCreateTransitionFunction.fromJSON(object.transition_function)
        : undefined,
    };
  },

  toJSON(message: FlowCreateTransitionFunction): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.transitionFunction !== undefined) {
      obj.transitionFunction = TransitionFunctionCreateTransitionFunction.toJSON(message.transitionFunction);
    }
    return obj;
  },

  create(base?: DeepPartial<FlowCreateTransitionFunction>): FlowCreateTransitionFunction {
    return FlowCreateTransitionFunction.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FlowCreateTransitionFunction>): FlowCreateTransitionFunction {
    const message = createBaseFlowCreateTransitionFunction();
    message.flowId = object.flowId ?? "";
    message.transitionFunction = (object.transitionFunction !== undefined && object.transitionFunction !== null)
      ? TransitionFunctionCreateTransitionFunction.fromPartial(object.transitionFunction)
      : undefined;
    return message;
  },
};

function createBaseFlowUpdateTransitionFunction(): FlowUpdateTransitionFunction {
  return { flowId: "", transitionFunction: undefined };
}

export const FlowUpdateTransitionFunction: MessageFns<FlowUpdateTransitionFunction> = {
  encode(message: FlowUpdateTransitionFunction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    if (message.transitionFunction !== undefined) {
      TransitionFunctionUpdateTransitionFunction.encode(message.transitionFunction, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FlowUpdateTransitionFunction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFlowUpdateTransitionFunction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.transitionFunction = TransitionFunctionUpdateTransitionFunction.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FlowUpdateTransitionFunction {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      transitionFunction: isSet(object.transitionFunction)
        ? TransitionFunctionUpdateTransitionFunction.fromJSON(object.transitionFunction)
        : isSet(object.transition_function)
        ? TransitionFunctionUpdateTransitionFunction.fromJSON(object.transition_function)
        : undefined,
    };
  },

  toJSON(message: FlowUpdateTransitionFunction): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.transitionFunction !== undefined) {
      obj.transitionFunction = TransitionFunctionUpdateTransitionFunction.toJSON(message.transitionFunction);
    }
    return obj;
  },

  create(base?: DeepPartial<FlowUpdateTransitionFunction>): FlowUpdateTransitionFunction {
    return FlowUpdateTransitionFunction.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FlowUpdateTransitionFunction>): FlowUpdateTransitionFunction {
    const message = createBaseFlowUpdateTransitionFunction();
    message.flowId = object.flowId ?? "";
    message.transitionFunction = (object.transitionFunction !== undefined && object.transitionFunction !== null)
      ? TransitionFunctionUpdateTransitionFunction.fromPartial(object.transitionFunction)
      : undefined;
    return message;
  },
};

function createBaseFlowUpdateTransitionFunctionLatencyControl(): FlowUpdateTransitionFunctionLatencyControl {
  return { flowId: "", latencyControl: undefined };
}

export const FlowUpdateTransitionFunctionLatencyControl: MessageFns<FlowUpdateTransitionFunctionLatencyControl> = {
  encode(message: FlowUpdateTransitionFunctionLatencyControl, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    if (message.latencyControl !== undefined) {
      FunctionUpdateLatencyControl.encode(message.latencyControl, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FlowUpdateTransitionFunctionLatencyControl {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFlowUpdateTransitionFunctionLatencyControl();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latencyControl = FunctionUpdateLatencyControl.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FlowUpdateTransitionFunctionLatencyControl {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      latencyControl: isSet(object.latencyControl)
        ? FunctionUpdateLatencyControl.fromJSON(object.latencyControl)
        : isSet(object.latency_control)
        ? FunctionUpdateLatencyControl.fromJSON(object.latency_control)
        : undefined,
    };
  },

  toJSON(message: FlowUpdateTransitionFunctionLatencyControl): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.latencyControl !== undefined) {
      obj.latencyControl = FunctionUpdateLatencyControl.toJSON(message.latencyControl);
    }
    return obj;
  },

  create(base?: DeepPartial<FlowUpdateTransitionFunctionLatencyControl>): FlowUpdateTransitionFunctionLatencyControl {
    return FlowUpdateTransitionFunctionLatencyControl.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<FlowUpdateTransitionFunctionLatencyControl>,
  ): FlowUpdateTransitionFunctionLatencyControl {
    const message = createBaseFlowUpdateTransitionFunctionLatencyControl();
    message.flowId = object.flowId ?? "";
    message.latencyControl = (object.latencyControl !== undefined && object.latencyControl !== null)
      ? FunctionUpdateLatencyControl.fromPartial(object.latencyControl)
      : undefined;
    return message;
  },
};

function createBaseFlowDeleteTransitionFunction(): FlowDeleteTransitionFunction {
  return { flowId: "", functionId: "" };
}

export const FlowDeleteTransitionFunction: MessageFns<FlowDeleteTransitionFunction> = {
  encode(message: FlowDeleteTransitionFunction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    if (message.functionId !== "") {
      writer.uint32(18).string(message.functionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FlowDeleteTransitionFunction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFlowDeleteTransitionFunction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.functionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FlowDeleteTransitionFunction {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      functionId: isSet(object.functionId)
        ? globalThis.String(object.functionId)
        : isSet(object.function_id)
        ? globalThis.String(object.function_id)
        : "",
    };
  },

  toJSON(message: FlowDeleteTransitionFunction): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.functionId !== "") {
      obj.functionId = message.functionId;
    }
    return obj;
  },

  create(base?: DeepPartial<FlowDeleteTransitionFunction>): FlowDeleteTransitionFunction {
    return FlowDeleteTransitionFunction.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FlowDeleteTransitionFunction>): FlowDeleteTransitionFunction {
    const message = createBaseFlowDeleteTransitionFunction();
    message.flowId = object.flowId ?? "";
    message.functionId = object.functionId ?? "";
    return message;
  },
};

function createBaseTransitionFunctionCreateTransitionFunction(): TransitionFunctionCreateTransitionFunction {
  return {
    id: "",
    name: "",
    description: "",
    parameters: [],
    code: "",
    errors: [],
    latencyControl: undefined,
    references: undefined,
    archived: undefined,
  };
}

export const TransitionFunctionCreateTransitionFunction: MessageFns<TransitionFunctionCreateTransitionFunction> = {
  encode(message: TransitionFunctionCreateTransitionFunction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.parameters) {
      FunctionParameterUpdate.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.code !== "") {
      writer.uint32(42).string(message.code);
    }
    for (const v of message.errors) {
      FunctionError.encode(v!, writer.uint32(50).fork()).join();
    }
    if (message.latencyControl !== undefined) {
      FunctionCreateLatencyControl.encode(message.latencyControl, writer.uint32(58).fork()).join();
    }
    if (message.references !== undefined) {
      TransitionFunctionReferences.encode(message.references, writer.uint32(66).fork()).join();
    }
    if (message.archived !== undefined) {
      writer.uint32(72).bool(message.archived);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TransitionFunctionCreateTransitionFunction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTransitionFunctionCreateTransitionFunction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.parameters.push(FunctionParameterUpdate.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.errors.push(FunctionError.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.latencyControl = FunctionCreateLatencyControl.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.references = TransitionFunctionReferences.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.archived = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TransitionFunctionCreateTransitionFunction {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      parameters: globalThis.Array.isArray(object?.parameters)
        ? object.parameters.map((e: any) => FunctionParameterUpdate.fromJSON(e))
        : [],
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      errors: globalThis.Array.isArray(object?.errors) ? object.errors.map((e: any) => FunctionError.fromJSON(e)) : [],
      latencyControl: isSet(object.latencyControl)
        ? FunctionCreateLatencyControl.fromJSON(object.latencyControl)
        : isSet(object.latency_control)
        ? FunctionCreateLatencyControl.fromJSON(object.latency_control)
        : undefined,
      references: isSet(object.references) ? TransitionFunctionReferences.fromJSON(object.references) : undefined,
      archived: isSet(object.archived) ? globalThis.Boolean(object.archived) : undefined,
    };
  },

  toJSON(message: TransitionFunctionCreateTransitionFunction): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.parameters?.length) {
      obj.parameters = message.parameters.map((e) => FunctionParameterUpdate.toJSON(e));
    }
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.errors?.length) {
      obj.errors = message.errors.map((e) => FunctionError.toJSON(e));
    }
    if (message.latencyControl !== undefined) {
      obj.latencyControl = FunctionCreateLatencyControl.toJSON(message.latencyControl);
    }
    if (message.references !== undefined) {
      obj.references = TransitionFunctionReferences.toJSON(message.references);
    }
    if (message.archived !== undefined) {
      obj.archived = message.archived;
    }
    return obj;
  },

  create(base?: DeepPartial<TransitionFunctionCreateTransitionFunction>): TransitionFunctionCreateTransitionFunction {
    return TransitionFunctionCreateTransitionFunction.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<TransitionFunctionCreateTransitionFunction>,
  ): TransitionFunctionCreateTransitionFunction {
    const message = createBaseTransitionFunctionCreateTransitionFunction();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.parameters = object.parameters?.map((e) => FunctionParameterUpdate.fromPartial(e)) || [];
    message.code = object.code ?? "";
    message.errors = object.errors?.map((e) => FunctionError.fromPartial(e)) || [];
    message.latencyControl = (object.latencyControl !== undefined && object.latencyControl !== null)
      ? FunctionCreateLatencyControl.fromPartial(object.latencyControl)
      : undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? TransitionFunctionReferences.fromPartial(object.references)
      : undefined;
    message.archived = object.archived ?? undefined;
    return message;
  },
};

function createBaseTransitionFunctionUpdateTransitionFunction(): TransitionFunctionUpdateTransitionFunction {
  return {
    id: "",
    name: undefined,
    description: undefined,
    parameters: undefined,
    code: undefined,
    errors: undefined,
    references: undefined,
  };
}

export const TransitionFunctionUpdateTransitionFunction: MessageFns<TransitionFunctionUpdateTransitionFunction> = {
  encode(message: TransitionFunctionUpdateTransitionFunction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== undefined) {
      writer.uint32(26).string(message.description);
    }
    if (message.parameters !== undefined) {
      ParametersUpdate.encode(message.parameters, writer.uint32(34).fork()).join();
    }
    if (message.code !== undefined) {
      writer.uint32(42).string(message.code);
    }
    if (message.errors !== undefined) {
      ErrorsUpdate.encode(message.errors, writer.uint32(50).fork()).join();
    }
    if (message.references !== undefined) {
      TransitionFunctionReferences.encode(message.references, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TransitionFunctionUpdateTransitionFunction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTransitionFunctionUpdateTransitionFunction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.parameters = ParametersUpdate.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.errors = ErrorsUpdate.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.references = TransitionFunctionReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TransitionFunctionUpdateTransitionFunction {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      parameters: isSet(object.parameters) ? ParametersUpdate.fromJSON(object.parameters) : undefined,
      code: isSet(object.code) ? globalThis.String(object.code) : undefined,
      errors: isSet(object.errors) ? ErrorsUpdate.fromJSON(object.errors) : undefined,
      references: isSet(object.references) ? TransitionFunctionReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: TransitionFunctionUpdateTransitionFunction): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.parameters !== undefined) {
      obj.parameters = ParametersUpdate.toJSON(message.parameters);
    }
    if (message.code !== undefined) {
      obj.code = message.code;
    }
    if (message.errors !== undefined) {
      obj.errors = ErrorsUpdate.toJSON(message.errors);
    }
    if (message.references !== undefined) {
      obj.references = TransitionFunctionReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<TransitionFunctionUpdateTransitionFunction>): TransitionFunctionUpdateTransitionFunction {
    return TransitionFunctionUpdateTransitionFunction.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<TransitionFunctionUpdateTransitionFunction>,
  ): TransitionFunctionUpdateTransitionFunction {
    const message = createBaseTransitionFunctionUpdateTransitionFunction();
    message.id = object.id ?? "";
    message.name = object.name ?? undefined;
    message.description = object.description ?? undefined;
    message.parameters = (object.parameters !== undefined && object.parameters !== null)
      ? ParametersUpdate.fromPartial(object.parameters)
      : undefined;
    message.code = object.code ?? undefined;
    message.errors = (object.errors !== undefined && object.errors !== null)
      ? ErrorsUpdate.fromPartial(object.errors)
      : undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? TransitionFunctionReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBaseCreateNoCodeStep(): CreateNoCodeStep {
  return { flowId: "", stepId: "", name: "", prompt: "", position: undefined, references: undefined };
}

export const CreateNoCodeStep: MessageFns<CreateNoCodeStep> = {
  encode(message: CreateNoCodeStep, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    if (message.stepId !== "") {
      writer.uint32(18).string(message.stepId);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.prompt !== "") {
      writer.uint32(34).string(message.prompt);
    }
    if (message.position !== undefined) {
      StepPosition.encode(message.position, writer.uint32(42).fork()).join();
    }
    if (message.references !== undefined) {
      NoCodeStepReferences.encode(message.references, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateNoCodeStep {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateNoCodeStep();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stepId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.prompt = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.position = StepPosition.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.references = NoCodeStepReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateNoCodeStep {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      stepId: isSet(object.stepId)
        ? globalThis.String(object.stepId)
        : isSet(object.step_id)
        ? globalThis.String(object.step_id)
        : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      prompt: isSet(object.prompt) ? globalThis.String(object.prompt) : "",
      position: isSet(object.position) ? StepPosition.fromJSON(object.position) : undefined,
      references: isSet(object.references) ? NoCodeStepReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: CreateNoCodeStep): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.stepId !== "") {
      obj.stepId = message.stepId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.prompt !== "") {
      obj.prompt = message.prompt;
    }
    if (message.position !== undefined) {
      obj.position = StepPosition.toJSON(message.position);
    }
    if (message.references !== undefined) {
      obj.references = NoCodeStepReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<CreateNoCodeStep>): CreateNoCodeStep {
    return CreateNoCodeStep.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateNoCodeStep>): CreateNoCodeStep {
    const message = createBaseCreateNoCodeStep();
    message.flowId = object.flowId ?? "";
    message.stepId = object.stepId ?? "";
    message.name = object.name ?? "";
    message.prompt = object.prompt ?? "";
    message.position = (object.position !== undefined && object.position !== null)
      ? StepPosition.fromPartial(object.position)
      : undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? NoCodeStepReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBaseUpdateNoCodeStep(): UpdateNoCodeStep {
  return { flowId: "", stepId: "", name: undefined, prompt: undefined, position: undefined, references: undefined };
}

export const UpdateNoCodeStep: MessageFns<UpdateNoCodeStep> = {
  encode(message: UpdateNoCodeStep, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    if (message.stepId !== "") {
      writer.uint32(18).string(message.stepId);
    }
    if (message.name !== undefined) {
      writer.uint32(26).string(message.name);
    }
    if (message.prompt !== undefined) {
      writer.uint32(34).string(message.prompt);
    }
    if (message.position !== undefined) {
      StepPosition.encode(message.position, writer.uint32(42).fork()).join();
    }
    if (message.references !== undefined) {
      NoCodeStepReferences.encode(message.references, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateNoCodeStep {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateNoCodeStep();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stepId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.prompt = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.position = StepPosition.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.references = NoCodeStepReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateNoCodeStep {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      stepId: isSet(object.stepId)
        ? globalThis.String(object.stepId)
        : isSet(object.step_id)
        ? globalThis.String(object.step_id)
        : "",
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      prompt: isSet(object.prompt) ? globalThis.String(object.prompt) : undefined,
      position: isSet(object.position) ? StepPosition.fromJSON(object.position) : undefined,
      references: isSet(object.references) ? NoCodeStepReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: UpdateNoCodeStep): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.stepId !== "") {
      obj.stepId = message.stepId;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.prompt !== undefined) {
      obj.prompt = message.prompt;
    }
    if (message.position !== undefined) {
      obj.position = StepPosition.toJSON(message.position);
    }
    if (message.references !== undefined) {
      obj.references = NoCodeStepReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateNoCodeStep>): UpdateNoCodeStep {
    return UpdateNoCodeStep.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateNoCodeStep>): UpdateNoCodeStep {
    const message = createBaseUpdateNoCodeStep();
    message.flowId = object.flowId ?? "";
    message.stepId = object.stepId ?? "";
    message.name = object.name ?? undefined;
    message.prompt = object.prompt ?? undefined;
    message.position = (object.position !== undefined && object.position !== null)
      ? StepPosition.fromPartial(object.position)
      : undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? NoCodeStepReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBaseDeleteNoCodeStep(): DeleteNoCodeStep {
  return { flowId: "", stepId: "" };
}

export const DeleteNoCodeStep: MessageFns<DeleteNoCodeStep> = {
  encode(message: DeleteNoCodeStep, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    if (message.stepId !== "") {
      writer.uint32(18).string(message.stepId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteNoCodeStep {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteNoCodeStep();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stepId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteNoCodeStep {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      stepId: isSet(object.stepId)
        ? globalThis.String(object.stepId)
        : isSet(object.step_id)
        ? globalThis.String(object.step_id)
        : "",
    };
  },

  toJSON(message: DeleteNoCodeStep): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.stepId !== "") {
      obj.stepId = message.stepId;
    }
    return obj;
  },

  create(base?: DeepPartial<DeleteNoCodeStep>): DeleteNoCodeStep {
    return DeleteNoCodeStep.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DeleteNoCodeStep>): DeleteNoCodeStep {
    const message = createBaseDeleteNoCodeStep();
    message.flowId = object.flowId ?? "";
    message.stepId = object.stepId ?? "";
    return message;
  },
};

function createBaseUpdateNoCodeStepPosition(): UpdateNoCodeStepPosition {
  return { flowId: "", stepId: "", newPosition: undefined };
}

export const UpdateNoCodeStepPosition: MessageFns<UpdateNoCodeStepPosition> = {
  encode(message: UpdateNoCodeStepPosition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    if (message.stepId !== "") {
      writer.uint32(18).string(message.stepId);
    }
    if (message.newPosition !== undefined) {
      StepPosition.encode(message.newPosition, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateNoCodeStepPosition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateNoCodeStepPosition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stepId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.newPosition = StepPosition.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateNoCodeStepPosition {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      stepId: isSet(object.stepId)
        ? globalThis.String(object.stepId)
        : isSet(object.step_id)
        ? globalThis.String(object.step_id)
        : "",
      newPosition: isSet(object.newPosition)
        ? StepPosition.fromJSON(object.newPosition)
        : isSet(object.new_position)
        ? StepPosition.fromJSON(object.new_position)
        : undefined,
    };
  },

  toJSON(message: UpdateNoCodeStepPosition): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.stepId !== "") {
      obj.stepId = message.stepId;
    }
    if (message.newPosition !== undefined) {
      obj.newPosition = StepPosition.toJSON(message.newPosition);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateNoCodeStepPosition>): UpdateNoCodeStepPosition {
    return UpdateNoCodeStepPosition.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateNoCodeStepPosition>): UpdateNoCodeStepPosition {
    const message = createBaseUpdateNoCodeStepPosition();
    message.flowId = object.flowId ?? "";
    message.stepId = object.stepId ?? "";
    message.newPosition = (object.newPosition !== undefined && object.newPosition !== null)
      ? StepPosition.fromPartial(object.newPosition)
      : undefined;
    return message;
  },
};

function createBaseImportNoCodeStep(): ImportNoCodeStep {
  return { id: "", name: "", prompt: "", position: undefined, references: undefined, conditions: [] };
}

export const ImportNoCodeStep: MessageFns<ImportNoCodeStep> = {
  encode(message: ImportNoCodeStep, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.prompt !== "") {
      writer.uint32(26).string(message.prompt);
    }
    if (message.position !== undefined) {
      StepPosition.encode(message.position, writer.uint32(34).fork()).join();
    }
    if (message.references !== undefined) {
      NoCodeStepReferences.encode(message.references, writer.uint32(42).fork()).join();
    }
    for (const v of message.conditions) {
      Condition.encode(v!, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImportNoCodeStep {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImportNoCodeStep();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.prompt = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.position = StepPosition.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.references = NoCodeStepReferences.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.conditions.push(Condition.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ImportNoCodeStep {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      prompt: isSet(object.prompt) ? globalThis.String(object.prompt) : "",
      position: isSet(object.position) ? StepPosition.fromJSON(object.position) : undefined,
      references: isSet(object.references) ? NoCodeStepReferences.fromJSON(object.references) : undefined,
      conditions: globalThis.Array.isArray(object?.conditions)
        ? object.conditions.map((e: any) => Condition.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ImportNoCodeStep): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.prompt !== "") {
      obj.prompt = message.prompt;
    }
    if (message.position !== undefined) {
      obj.position = StepPosition.toJSON(message.position);
    }
    if (message.references !== undefined) {
      obj.references = NoCodeStepReferences.toJSON(message.references);
    }
    if (message.conditions?.length) {
      obj.conditions = message.conditions.map((e) => Condition.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ImportNoCodeStep>): ImportNoCodeStep {
    return ImportNoCodeStep.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ImportNoCodeStep>): ImportNoCodeStep {
    const message = createBaseImportNoCodeStep();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.prompt = object.prompt ?? "";
    message.position = (object.position !== undefined && object.position !== null)
      ? StepPosition.fromPartial(object.position)
      : undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? NoCodeStepReferences.fromPartial(object.references)
      : undefined;
    message.conditions = object.conditions?.map((e) => Condition.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCreateNoCodeCondition(): CreateNoCodeCondition {
  return { flowId: "", stepId: "", conditionId: "", config: undefined };
}

export const CreateNoCodeCondition: MessageFns<CreateNoCodeCondition> = {
  encode(message: CreateNoCodeCondition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    if (message.stepId !== "") {
      writer.uint32(18).string(message.stepId);
    }
    if (message.conditionId !== "") {
      writer.uint32(26).string(message.conditionId);
    }
    switch (message.config?.$case) {
      case "exitFlowCondition":
        ExitFlowCondition.encode(message.config.value, writer.uint32(34).fork()).join();
        break;
      case "stepCondition":
        AdvancedStepCondition.encode(message.config.value, writer.uint32(42).fork()).join();
        break;
      case "noCodeStepCondition":
        NoCodeStepCondition.encode(message.config.value, writer.uint32(50).fork()).join();
        break;
      case "functionStepCondition":
        FunctionStepCondition.encode(message.config.value, writer.uint32(58).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateNoCodeCondition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateNoCodeCondition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stepId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.conditionId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.config = { $case: "exitFlowCondition", value: ExitFlowCondition.decode(reader, reader.uint32()) };
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.config = { $case: "stepCondition", value: AdvancedStepCondition.decode(reader, reader.uint32()) };
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = { $case: "noCodeStepCondition", value: NoCodeStepCondition.decode(reader, reader.uint32()) };
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.config = {
            $case: "functionStepCondition",
            value: FunctionStepCondition.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateNoCodeCondition {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      stepId: isSet(object.stepId)
        ? globalThis.String(object.stepId)
        : isSet(object.step_id)
        ? globalThis.String(object.step_id)
        : "",
      conditionId: isSet(object.conditionId)
        ? globalThis.String(object.conditionId)
        : isSet(object.condition_id)
        ? globalThis.String(object.condition_id)
        : "",
      config: isSet(object.exitFlowCondition)
        ? { $case: "exitFlowCondition", value: ExitFlowCondition.fromJSON(object.exitFlowCondition) }
        : isSet(object.exit_flow_condition)
        ? { $case: "exitFlowCondition", value: ExitFlowCondition.fromJSON(object.exit_flow_condition) }
        : isSet(object.stepCondition)
        ? { $case: "stepCondition", value: AdvancedStepCondition.fromJSON(object.stepCondition) }
        : isSet(object.step_condition)
        ? { $case: "stepCondition", value: AdvancedStepCondition.fromJSON(object.step_condition) }
        : isSet(object.noCodeStepCondition)
        ? { $case: "noCodeStepCondition", value: NoCodeStepCondition.fromJSON(object.noCodeStepCondition) }
        : isSet(object.no_code_step_condition)
        ? { $case: "noCodeStepCondition", value: NoCodeStepCondition.fromJSON(object.no_code_step_condition) }
        : isSet(object.functionStepCondition)
        ? { $case: "functionStepCondition", value: FunctionStepCondition.fromJSON(object.functionStepCondition) }
        : isSet(object.function_step_condition)
        ? { $case: "functionStepCondition", value: FunctionStepCondition.fromJSON(object.function_step_condition) }
        : undefined,
    };
  },

  toJSON(message: CreateNoCodeCondition): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.stepId !== "") {
      obj.stepId = message.stepId;
    }
    if (message.conditionId !== "") {
      obj.conditionId = message.conditionId;
    }
    if (message.config?.$case === "exitFlowCondition") {
      obj.exitFlowCondition = ExitFlowCondition.toJSON(message.config.value);
    } else if (message.config?.$case === "stepCondition") {
      obj.stepCondition = AdvancedStepCondition.toJSON(message.config.value);
    } else if (message.config?.$case === "noCodeStepCondition") {
      obj.noCodeStepCondition = NoCodeStepCondition.toJSON(message.config.value);
    } else if (message.config?.$case === "functionStepCondition") {
      obj.functionStepCondition = FunctionStepCondition.toJSON(message.config.value);
    }
    return obj;
  },

  create(base?: DeepPartial<CreateNoCodeCondition>): CreateNoCodeCondition {
    return CreateNoCodeCondition.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateNoCodeCondition>): CreateNoCodeCondition {
    const message = createBaseCreateNoCodeCondition();
    message.flowId = object.flowId ?? "";
    message.stepId = object.stepId ?? "";
    message.conditionId = object.conditionId ?? "";
    switch (object.config?.$case) {
      case "exitFlowCondition": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "exitFlowCondition", value: ExitFlowCondition.fromPartial(object.config.value) };
        }
        break;
      }
      case "stepCondition": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "stepCondition", value: AdvancedStepCondition.fromPartial(object.config.value) };
        }
        break;
      }
      case "noCodeStepCondition": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = {
            $case: "noCodeStepCondition",
            value: NoCodeStepCondition.fromPartial(object.config.value),
          };
        }
        break;
      }
      case "functionStepCondition": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = {
            $case: "functionStepCondition",
            value: FunctionStepCondition.fromPartial(object.config.value),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseUpdateNoCodeCondition(): UpdateNoCodeCondition {
  return { flowId: "", stepId: "", conditionId: "", config: undefined };
}

export const UpdateNoCodeCondition: MessageFns<UpdateNoCodeCondition> = {
  encode(message: UpdateNoCodeCondition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    if (message.stepId !== "") {
      writer.uint32(18).string(message.stepId);
    }
    if (message.conditionId !== "") {
      writer.uint32(26).string(message.conditionId);
    }
    switch (message.config?.$case) {
      case "exitFlowCondition":
        ExitFlowCondition.encode(message.config.value, writer.uint32(34).fork()).join();
        break;
      case "stepCondition":
        AdvancedStepCondition.encode(message.config.value, writer.uint32(42).fork()).join();
        break;
      case "noCodeStepCondition":
        NoCodeStepCondition.encode(message.config.value, writer.uint32(50).fork()).join();
        break;
      case "functionStepCondition":
        FunctionStepCondition.encode(message.config.value, writer.uint32(58).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateNoCodeCondition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateNoCodeCondition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stepId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.conditionId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.config = { $case: "exitFlowCondition", value: ExitFlowCondition.decode(reader, reader.uint32()) };
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.config = { $case: "stepCondition", value: AdvancedStepCondition.decode(reader, reader.uint32()) };
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = { $case: "noCodeStepCondition", value: NoCodeStepCondition.decode(reader, reader.uint32()) };
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.config = {
            $case: "functionStepCondition",
            value: FunctionStepCondition.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateNoCodeCondition {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      stepId: isSet(object.stepId)
        ? globalThis.String(object.stepId)
        : isSet(object.step_id)
        ? globalThis.String(object.step_id)
        : "",
      conditionId: isSet(object.conditionId)
        ? globalThis.String(object.conditionId)
        : isSet(object.condition_id)
        ? globalThis.String(object.condition_id)
        : "",
      config: isSet(object.exitFlowCondition)
        ? { $case: "exitFlowCondition", value: ExitFlowCondition.fromJSON(object.exitFlowCondition) }
        : isSet(object.exit_flow_condition)
        ? { $case: "exitFlowCondition", value: ExitFlowCondition.fromJSON(object.exit_flow_condition) }
        : isSet(object.stepCondition)
        ? { $case: "stepCondition", value: AdvancedStepCondition.fromJSON(object.stepCondition) }
        : isSet(object.step_condition)
        ? { $case: "stepCondition", value: AdvancedStepCondition.fromJSON(object.step_condition) }
        : isSet(object.noCodeStepCondition)
        ? { $case: "noCodeStepCondition", value: NoCodeStepCondition.fromJSON(object.noCodeStepCondition) }
        : isSet(object.no_code_step_condition)
        ? { $case: "noCodeStepCondition", value: NoCodeStepCondition.fromJSON(object.no_code_step_condition) }
        : isSet(object.functionStepCondition)
        ? { $case: "functionStepCondition", value: FunctionStepCondition.fromJSON(object.functionStepCondition) }
        : isSet(object.function_step_condition)
        ? { $case: "functionStepCondition", value: FunctionStepCondition.fromJSON(object.function_step_condition) }
        : undefined,
    };
  },

  toJSON(message: UpdateNoCodeCondition): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.stepId !== "") {
      obj.stepId = message.stepId;
    }
    if (message.conditionId !== "") {
      obj.conditionId = message.conditionId;
    }
    if (message.config?.$case === "exitFlowCondition") {
      obj.exitFlowCondition = ExitFlowCondition.toJSON(message.config.value);
    } else if (message.config?.$case === "stepCondition") {
      obj.stepCondition = AdvancedStepCondition.toJSON(message.config.value);
    } else if (message.config?.$case === "noCodeStepCondition") {
      obj.noCodeStepCondition = NoCodeStepCondition.toJSON(message.config.value);
    } else if (message.config?.$case === "functionStepCondition") {
      obj.functionStepCondition = FunctionStepCondition.toJSON(message.config.value);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateNoCodeCondition>): UpdateNoCodeCondition {
    return UpdateNoCodeCondition.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateNoCodeCondition>): UpdateNoCodeCondition {
    const message = createBaseUpdateNoCodeCondition();
    message.flowId = object.flowId ?? "";
    message.stepId = object.stepId ?? "";
    message.conditionId = object.conditionId ?? "";
    switch (object.config?.$case) {
      case "exitFlowCondition": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "exitFlowCondition", value: ExitFlowCondition.fromPartial(object.config.value) };
        }
        break;
      }
      case "stepCondition": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "stepCondition", value: AdvancedStepCondition.fromPartial(object.config.value) };
        }
        break;
      }
      case "noCodeStepCondition": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = {
            $case: "noCodeStepCondition",
            value: NoCodeStepCondition.fromPartial(object.config.value),
          };
        }
        break;
      }
      case "functionStepCondition": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = {
            $case: "functionStepCondition",
            value: FunctionStepCondition.fromPartial(object.config.value),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseDeleteNoCodeCondition(): DeleteNoCodeCondition {
  return { flowId: "", stepId: "", conditionId: "" };
}

export const DeleteNoCodeCondition: MessageFns<DeleteNoCodeCondition> = {
  encode(message: DeleteNoCodeCondition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    if (message.stepId !== "") {
      writer.uint32(18).string(message.stepId);
    }
    if (message.conditionId !== "") {
      writer.uint32(26).string(message.conditionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteNoCodeCondition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteNoCodeCondition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stepId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.conditionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteNoCodeCondition {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      stepId: isSet(object.stepId)
        ? globalThis.String(object.stepId)
        : isSet(object.step_id)
        ? globalThis.String(object.step_id)
        : "",
      conditionId: isSet(object.conditionId)
        ? globalThis.String(object.conditionId)
        : isSet(object.condition_id)
        ? globalThis.String(object.condition_id)
        : "",
    };
  },

  toJSON(message: DeleteNoCodeCondition): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.stepId !== "") {
      obj.stepId = message.stepId;
    }
    if (message.conditionId !== "") {
      obj.conditionId = message.conditionId;
    }
    return obj;
  },

  create(base?: DeepPartial<DeleteNoCodeCondition>): DeleteNoCodeCondition {
    return DeleteNoCodeCondition.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DeleteNoCodeCondition>): DeleteNoCodeCondition {
    const message = createBaseDeleteNoCodeCondition();
    message.flowId = object.flowId ?? "";
    message.stepId = object.stepId ?? "";
    message.conditionId = object.conditionId ?? "";
    return message;
  },
};

function createBaseUpdateNoCodeConditionPosition(): UpdateNoCodeConditionPosition {
  return { flowId: "", stepId: "", conditionId: "", newPosition: undefined };
}

export const UpdateNoCodeConditionPosition: MessageFns<UpdateNoCodeConditionPosition> = {
  encode(message: UpdateNoCodeConditionPosition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    if (message.stepId !== "") {
      writer.uint32(18).string(message.stepId);
    }
    if (message.conditionId !== "") {
      writer.uint32(26).string(message.conditionId);
    }
    if (message.newPosition !== undefined) {
      StepPosition.encode(message.newPosition, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateNoCodeConditionPosition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateNoCodeConditionPosition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stepId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.conditionId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.newPosition = StepPosition.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateNoCodeConditionPosition {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      stepId: isSet(object.stepId)
        ? globalThis.String(object.stepId)
        : isSet(object.step_id)
        ? globalThis.String(object.step_id)
        : "",
      conditionId: isSet(object.conditionId)
        ? globalThis.String(object.conditionId)
        : isSet(object.condition_id)
        ? globalThis.String(object.condition_id)
        : "",
      newPosition: isSet(object.newPosition)
        ? StepPosition.fromJSON(object.newPosition)
        : isSet(object.new_position)
        ? StepPosition.fromJSON(object.new_position)
        : undefined,
    };
  },

  toJSON(message: UpdateNoCodeConditionPosition): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.stepId !== "") {
      obj.stepId = message.stepId;
    }
    if (message.conditionId !== "") {
      obj.conditionId = message.conditionId;
    }
    if (message.newPosition !== undefined) {
      obj.newPosition = StepPosition.toJSON(message.newPosition);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateNoCodeConditionPosition>): UpdateNoCodeConditionPosition {
    return UpdateNoCodeConditionPosition.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateNoCodeConditionPosition>): UpdateNoCodeConditionPosition {
    const message = createBaseUpdateNoCodeConditionPosition();
    message.flowId = object.flowId ?? "";
    message.stepId = object.stepId ?? "";
    message.conditionId = object.conditionId ?? "";
    message.newPosition = (object.newPosition !== undefined && object.newPosition !== null)
      ? StepPosition.fromPartial(object.newPosition)
      : undefined;
    return message;
  },
};

function createBaseUpdateNoCodeConditionExitFlowPosition(): UpdateNoCodeConditionExitFlowPosition {
  return { flowId: "", stepId: "", conditionId: "", newPosition: undefined };
}

export const UpdateNoCodeConditionExitFlowPosition: MessageFns<UpdateNoCodeConditionExitFlowPosition> = {
  encode(message: UpdateNoCodeConditionExitFlowPosition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    if (message.stepId !== "") {
      writer.uint32(18).string(message.stepId);
    }
    if (message.conditionId !== "") {
      writer.uint32(26).string(message.conditionId);
    }
    if (message.newPosition !== undefined) {
      StepPosition.encode(message.newPosition, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateNoCodeConditionExitFlowPosition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateNoCodeConditionExitFlowPosition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stepId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.conditionId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.newPosition = StepPosition.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateNoCodeConditionExitFlowPosition {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      stepId: isSet(object.stepId)
        ? globalThis.String(object.stepId)
        : isSet(object.step_id)
        ? globalThis.String(object.step_id)
        : "",
      conditionId: isSet(object.conditionId)
        ? globalThis.String(object.conditionId)
        : isSet(object.condition_id)
        ? globalThis.String(object.condition_id)
        : "",
      newPosition: isSet(object.newPosition)
        ? StepPosition.fromJSON(object.newPosition)
        : isSet(object.new_position)
        ? StepPosition.fromJSON(object.new_position)
        : undefined,
    };
  },

  toJSON(message: UpdateNoCodeConditionExitFlowPosition): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.stepId !== "") {
      obj.stepId = message.stepId;
    }
    if (message.conditionId !== "") {
      obj.conditionId = message.conditionId;
    }
    if (message.newPosition !== undefined) {
      obj.newPosition = StepPosition.toJSON(message.newPosition);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateNoCodeConditionExitFlowPosition>): UpdateNoCodeConditionExitFlowPosition {
    return UpdateNoCodeConditionExitFlowPosition.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateNoCodeConditionExitFlowPosition>): UpdateNoCodeConditionExitFlowPosition {
    const message = createBaseUpdateNoCodeConditionExitFlowPosition();
    message.flowId = object.flowId ?? "";
    message.stepId = object.stepId ?? "";
    message.conditionId = object.conditionId ?? "";
    message.newPosition = (object.newPosition !== undefined && object.newPosition !== null)
      ? StepPosition.fromPartial(object.newPosition)
      : undefined;
    return message;
  },
};

function createBaseCreateStep(): CreateStep {
  return { flowId: "", payload: undefined };
}

export const CreateStep: MessageFns<CreateStep> = {
  encode(message: CreateStep, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    switch (message.payload?.$case) {
      case "functionStep":
        CreateFunctionStep.encode(message.payload.value, writer.uint32(18).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateStep {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateStep();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.payload = { $case: "functionStep", value: CreateFunctionStep.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateStep {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      payload: isSet(object.functionStep)
        ? { $case: "functionStep", value: CreateFunctionStep.fromJSON(object.functionStep) }
        : isSet(object.function_step)
        ? { $case: "functionStep", value: CreateFunctionStep.fromJSON(object.function_step) }
        : undefined,
    };
  },

  toJSON(message: CreateStep): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.payload?.$case === "functionStep") {
      obj.functionStep = CreateFunctionStep.toJSON(message.payload.value);
    }
    return obj;
  },

  create(base?: DeepPartial<CreateStep>): CreateStep {
    return CreateStep.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateStep>): CreateStep {
    const message = createBaseCreateStep();
    message.flowId = object.flowId ?? "";
    switch (object.payload?.$case) {
      case "functionStep": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "functionStep", value: CreateFunctionStep.fromPartial(object.payload.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseUpdateStep(): UpdateStep {
  return { flowId: "", stepId: "", payload: undefined };
}

export const UpdateStep: MessageFns<UpdateStep> = {
  encode(message: UpdateStep, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    if (message.stepId !== "") {
      writer.uint32(18).string(message.stepId);
    }
    switch (message.payload?.$case) {
      case "functionStep":
        UpdateFunctionStep.encode(message.payload.value, writer.uint32(26).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateStep {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateStep();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stepId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.payload = { $case: "functionStep", value: UpdateFunctionStep.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateStep {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      stepId: isSet(object.stepId)
        ? globalThis.String(object.stepId)
        : isSet(object.step_id)
        ? globalThis.String(object.step_id)
        : "",
      payload: isSet(object.functionStep)
        ? { $case: "functionStep", value: UpdateFunctionStep.fromJSON(object.functionStep) }
        : isSet(object.function_step)
        ? { $case: "functionStep", value: UpdateFunctionStep.fromJSON(object.function_step) }
        : undefined,
    };
  },

  toJSON(message: UpdateStep): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.stepId !== "") {
      obj.stepId = message.stepId;
    }
    if (message.payload?.$case === "functionStep") {
      obj.functionStep = UpdateFunctionStep.toJSON(message.payload.value);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateStep>): UpdateStep {
    return UpdateStep.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateStep>): UpdateStep {
    const message = createBaseUpdateStep();
    message.flowId = object.flowId ?? "";
    message.stepId = object.stepId ?? "";
    switch (object.payload?.$case) {
      case "functionStep": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "functionStep", value: UpdateFunctionStep.fromPartial(object.payload.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseDeleteStep(): DeleteStep {
  return { flowId: "", stepId: "" };
}

export const DeleteStep: MessageFns<DeleteStep> = {
  encode(message: DeleteStep, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    if (message.stepId !== "") {
      writer.uint32(18).string(message.stepId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteStep {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteStep();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stepId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteStep {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      stepId: isSet(object.stepId)
        ? globalThis.String(object.stepId)
        : isSet(object.step_id)
        ? globalThis.String(object.step_id)
        : "",
    };
  },

  toJSON(message: DeleteStep): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.stepId !== "") {
      obj.stepId = message.stepId;
    }
    return obj;
  },

  create(base?: DeepPartial<DeleteStep>): DeleteStep {
    return DeleteStep.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DeleteStep>): DeleteStep {
    const message = createBaseDeleteStep();
    message.flowId = object.flowId ?? "";
    message.stepId = object.stepId ?? "";
    return message;
  },
};

function createBaseCreateStepCondition(): CreateStepCondition {
  return { flowId: "", stepId: "", conditionId: "", config: undefined };
}

export const CreateStepCondition: MessageFns<CreateStepCondition> = {
  encode(message: CreateStepCondition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    if (message.stepId !== "") {
      writer.uint32(18).string(message.stepId);
    }
    if (message.conditionId !== "") {
      writer.uint32(26).string(message.conditionId);
    }
    switch (message.config?.$case) {
      case "exitFlowCondition":
        ExitFlowCondition.encode(message.config.value, writer.uint32(34).fork()).join();
        break;
      case "stepCondition":
        AdvancedStepCondition.encode(message.config.value, writer.uint32(42).fork()).join();
        break;
      case "noCodeStepCondition":
        NoCodeStepCondition.encode(message.config.value, writer.uint32(50).fork()).join();
        break;
      case "functionStepCondition":
        FunctionStepCondition.encode(message.config.value, writer.uint32(58).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateStepCondition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateStepCondition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stepId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.conditionId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.config = { $case: "exitFlowCondition", value: ExitFlowCondition.decode(reader, reader.uint32()) };
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.config = { $case: "stepCondition", value: AdvancedStepCondition.decode(reader, reader.uint32()) };
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = { $case: "noCodeStepCondition", value: NoCodeStepCondition.decode(reader, reader.uint32()) };
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.config = {
            $case: "functionStepCondition",
            value: FunctionStepCondition.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateStepCondition {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      stepId: isSet(object.stepId)
        ? globalThis.String(object.stepId)
        : isSet(object.step_id)
        ? globalThis.String(object.step_id)
        : "",
      conditionId: isSet(object.conditionId)
        ? globalThis.String(object.conditionId)
        : isSet(object.condition_id)
        ? globalThis.String(object.condition_id)
        : "",
      config: isSet(object.exitFlowCondition)
        ? { $case: "exitFlowCondition", value: ExitFlowCondition.fromJSON(object.exitFlowCondition) }
        : isSet(object.exit_flow_condition)
        ? { $case: "exitFlowCondition", value: ExitFlowCondition.fromJSON(object.exit_flow_condition) }
        : isSet(object.stepCondition)
        ? { $case: "stepCondition", value: AdvancedStepCondition.fromJSON(object.stepCondition) }
        : isSet(object.step_condition)
        ? { $case: "stepCondition", value: AdvancedStepCondition.fromJSON(object.step_condition) }
        : isSet(object.noCodeStepCondition)
        ? { $case: "noCodeStepCondition", value: NoCodeStepCondition.fromJSON(object.noCodeStepCondition) }
        : isSet(object.no_code_step_condition)
        ? { $case: "noCodeStepCondition", value: NoCodeStepCondition.fromJSON(object.no_code_step_condition) }
        : isSet(object.functionStepCondition)
        ? { $case: "functionStepCondition", value: FunctionStepCondition.fromJSON(object.functionStepCondition) }
        : isSet(object.function_step_condition)
        ? { $case: "functionStepCondition", value: FunctionStepCondition.fromJSON(object.function_step_condition) }
        : undefined,
    };
  },

  toJSON(message: CreateStepCondition): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.stepId !== "") {
      obj.stepId = message.stepId;
    }
    if (message.conditionId !== "") {
      obj.conditionId = message.conditionId;
    }
    if (message.config?.$case === "exitFlowCondition") {
      obj.exitFlowCondition = ExitFlowCondition.toJSON(message.config.value);
    } else if (message.config?.$case === "stepCondition") {
      obj.stepCondition = AdvancedStepCondition.toJSON(message.config.value);
    } else if (message.config?.$case === "noCodeStepCondition") {
      obj.noCodeStepCondition = NoCodeStepCondition.toJSON(message.config.value);
    } else if (message.config?.$case === "functionStepCondition") {
      obj.functionStepCondition = FunctionStepCondition.toJSON(message.config.value);
    }
    return obj;
  },

  create(base?: DeepPartial<CreateStepCondition>): CreateStepCondition {
    return CreateStepCondition.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateStepCondition>): CreateStepCondition {
    const message = createBaseCreateStepCondition();
    message.flowId = object.flowId ?? "";
    message.stepId = object.stepId ?? "";
    message.conditionId = object.conditionId ?? "";
    switch (object.config?.$case) {
      case "exitFlowCondition": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "exitFlowCondition", value: ExitFlowCondition.fromPartial(object.config.value) };
        }
        break;
      }
      case "stepCondition": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "stepCondition", value: AdvancedStepCondition.fromPartial(object.config.value) };
        }
        break;
      }
      case "noCodeStepCondition": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = {
            $case: "noCodeStepCondition",
            value: NoCodeStepCondition.fromPartial(object.config.value),
          };
        }
        break;
      }
      case "functionStepCondition": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = {
            $case: "functionStepCondition",
            value: FunctionStepCondition.fromPartial(object.config.value),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseUpdateStepCondition(): UpdateStepCondition {
  return { flowId: "", stepId: "", conditionId: "", config: undefined };
}

export const UpdateStepCondition: MessageFns<UpdateStepCondition> = {
  encode(message: UpdateStepCondition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    if (message.stepId !== "") {
      writer.uint32(18).string(message.stepId);
    }
    if (message.conditionId !== "") {
      writer.uint32(26).string(message.conditionId);
    }
    switch (message.config?.$case) {
      case "exitFlowCondition":
        ExitFlowCondition.encode(message.config.value, writer.uint32(34).fork()).join();
        break;
      case "stepCondition":
        AdvancedStepCondition.encode(message.config.value, writer.uint32(42).fork()).join();
        break;
      case "noCodeStepCondition":
        NoCodeStepCondition.encode(message.config.value, writer.uint32(50).fork()).join();
        break;
      case "functionStepCondition":
        FunctionStepCondition.encode(message.config.value, writer.uint32(58).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateStepCondition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateStepCondition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stepId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.conditionId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.config = { $case: "exitFlowCondition", value: ExitFlowCondition.decode(reader, reader.uint32()) };
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.config = { $case: "stepCondition", value: AdvancedStepCondition.decode(reader, reader.uint32()) };
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.config = { $case: "noCodeStepCondition", value: NoCodeStepCondition.decode(reader, reader.uint32()) };
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.config = {
            $case: "functionStepCondition",
            value: FunctionStepCondition.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateStepCondition {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      stepId: isSet(object.stepId)
        ? globalThis.String(object.stepId)
        : isSet(object.step_id)
        ? globalThis.String(object.step_id)
        : "",
      conditionId: isSet(object.conditionId)
        ? globalThis.String(object.conditionId)
        : isSet(object.condition_id)
        ? globalThis.String(object.condition_id)
        : "",
      config: isSet(object.exitFlowCondition)
        ? { $case: "exitFlowCondition", value: ExitFlowCondition.fromJSON(object.exitFlowCondition) }
        : isSet(object.exit_flow_condition)
        ? { $case: "exitFlowCondition", value: ExitFlowCondition.fromJSON(object.exit_flow_condition) }
        : isSet(object.stepCondition)
        ? { $case: "stepCondition", value: AdvancedStepCondition.fromJSON(object.stepCondition) }
        : isSet(object.step_condition)
        ? { $case: "stepCondition", value: AdvancedStepCondition.fromJSON(object.step_condition) }
        : isSet(object.noCodeStepCondition)
        ? { $case: "noCodeStepCondition", value: NoCodeStepCondition.fromJSON(object.noCodeStepCondition) }
        : isSet(object.no_code_step_condition)
        ? { $case: "noCodeStepCondition", value: NoCodeStepCondition.fromJSON(object.no_code_step_condition) }
        : isSet(object.functionStepCondition)
        ? { $case: "functionStepCondition", value: FunctionStepCondition.fromJSON(object.functionStepCondition) }
        : isSet(object.function_step_condition)
        ? { $case: "functionStepCondition", value: FunctionStepCondition.fromJSON(object.function_step_condition) }
        : undefined,
    };
  },

  toJSON(message: UpdateStepCondition): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.stepId !== "") {
      obj.stepId = message.stepId;
    }
    if (message.conditionId !== "") {
      obj.conditionId = message.conditionId;
    }
    if (message.config?.$case === "exitFlowCondition") {
      obj.exitFlowCondition = ExitFlowCondition.toJSON(message.config.value);
    } else if (message.config?.$case === "stepCondition") {
      obj.stepCondition = AdvancedStepCondition.toJSON(message.config.value);
    } else if (message.config?.$case === "noCodeStepCondition") {
      obj.noCodeStepCondition = NoCodeStepCondition.toJSON(message.config.value);
    } else if (message.config?.$case === "functionStepCondition") {
      obj.functionStepCondition = FunctionStepCondition.toJSON(message.config.value);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateStepCondition>): UpdateStepCondition {
    return UpdateStepCondition.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateStepCondition>): UpdateStepCondition {
    const message = createBaseUpdateStepCondition();
    message.flowId = object.flowId ?? "";
    message.stepId = object.stepId ?? "";
    message.conditionId = object.conditionId ?? "";
    switch (object.config?.$case) {
      case "exitFlowCondition": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "exitFlowCondition", value: ExitFlowCondition.fromPartial(object.config.value) };
        }
        break;
      }
      case "stepCondition": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = { $case: "stepCondition", value: AdvancedStepCondition.fromPartial(object.config.value) };
        }
        break;
      }
      case "noCodeStepCondition": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = {
            $case: "noCodeStepCondition",
            value: NoCodeStepCondition.fromPartial(object.config.value),
          };
        }
        break;
      }
      case "functionStepCondition": {
        if (object.config?.value !== undefined && object.config?.value !== null) {
          message.config = {
            $case: "functionStepCondition",
            value: FunctionStepCondition.fromPartial(object.config.value),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseDeleteStepCondition(): DeleteStepCondition {
  return { flowId: "", stepId: "", conditionId: "" };
}

export const DeleteStepCondition: MessageFns<DeleteStepCondition> = {
  encode(message: DeleteStepCondition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    if (message.stepId !== "") {
      writer.uint32(18).string(message.stepId);
    }
    if (message.conditionId !== "") {
      writer.uint32(26).string(message.conditionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteStepCondition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteStepCondition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stepId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.conditionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteStepCondition {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      stepId: isSet(object.stepId)
        ? globalThis.String(object.stepId)
        : isSet(object.step_id)
        ? globalThis.String(object.step_id)
        : "",
      conditionId: isSet(object.conditionId)
        ? globalThis.String(object.conditionId)
        : isSet(object.condition_id)
        ? globalThis.String(object.condition_id)
        : "",
    };
  },

  toJSON(message: DeleteStepCondition): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.stepId !== "") {
      obj.stepId = message.stepId;
    }
    if (message.conditionId !== "") {
      obj.conditionId = message.conditionId;
    }
    return obj;
  },

  create(base?: DeepPartial<DeleteStepCondition>): DeleteStepCondition {
    return DeleteStepCondition.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DeleteStepCondition>): DeleteStepCondition {
    const message = createBaseDeleteStepCondition();
    message.flowId = object.flowId ?? "";
    message.stepId = object.stepId ?? "";
    message.conditionId = object.conditionId ?? "";
    return message;
  },
};

function createBaseUpdateStepConditionPosition(): UpdateStepConditionPosition {
  return { flowId: "", stepId: "", conditionId: "", newPosition: undefined };
}

export const UpdateStepConditionPosition: MessageFns<UpdateStepConditionPosition> = {
  encode(message: UpdateStepConditionPosition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flowId !== "") {
      writer.uint32(10).string(message.flowId);
    }
    if (message.stepId !== "") {
      writer.uint32(18).string(message.stepId);
    }
    if (message.conditionId !== "") {
      writer.uint32(26).string(message.conditionId);
    }
    if (message.newPosition !== undefined) {
      StepPosition.encode(message.newPosition, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateStepConditionPosition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateStepConditionPosition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flowId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stepId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.conditionId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.newPosition = StepPosition.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateStepConditionPosition {
    return {
      flowId: isSet(object.flowId)
        ? globalThis.String(object.flowId)
        : isSet(object.flow_id)
        ? globalThis.String(object.flow_id)
        : "",
      stepId: isSet(object.stepId)
        ? globalThis.String(object.stepId)
        : isSet(object.step_id)
        ? globalThis.String(object.step_id)
        : "",
      conditionId: isSet(object.conditionId)
        ? globalThis.String(object.conditionId)
        : isSet(object.condition_id)
        ? globalThis.String(object.condition_id)
        : "",
      newPosition: isSet(object.newPosition)
        ? StepPosition.fromJSON(object.newPosition)
        : isSet(object.new_position)
        ? StepPosition.fromJSON(object.new_position)
        : undefined,
    };
  },

  toJSON(message: UpdateStepConditionPosition): unknown {
    const obj: any = {};
    if (message.flowId !== "") {
      obj.flowId = message.flowId;
    }
    if (message.stepId !== "") {
      obj.stepId = message.stepId;
    }
    if (message.conditionId !== "") {
      obj.conditionId = message.conditionId;
    }
    if (message.newPosition !== undefined) {
      obj.newPosition = StepPosition.toJSON(message.newPosition);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateStepConditionPosition>): UpdateStepConditionPosition {
    return UpdateStepConditionPosition.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateStepConditionPosition>): UpdateStepConditionPosition {
    const message = createBaseUpdateStepConditionPosition();
    message.flowId = object.flowId ?? "";
    message.stepId = object.stepId ?? "";
    message.conditionId = object.conditionId ?? "";
    message.newPosition = (object.newPosition !== undefined && object.newPosition !== null)
      ? StepPosition.fromPartial(object.newPosition)
      : undefined;
    return message;
  },
};

function createBaseFunctionStepDefinition(): FunctionStepDefinition {
  return {
    id: "",
    name: "",
    code: "",
    errors: [],
    latencyControl: undefined,
    createdAt: undefined,
    createdBy: "",
    updatedAt: undefined,
    updatedBy: "",
    archived: false,
  };
}

export const FunctionStepDefinition: MessageFns<FunctionStepDefinition> = {
  encode(message: FunctionStepDefinition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.code !== "") {
      writer.uint32(26).string(message.code);
    }
    for (const v of message.errors) {
      FunctionError.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.latencyControl !== undefined) {
      FunctionLatencyControl.encode(message.latencyControl, writer.uint32(42).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(50).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(58).string(message.createdBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(66).fork()).join();
    }
    if (message.updatedBy !== "") {
      writer.uint32(74).string(message.updatedBy);
    }
    if (message.archived !== false) {
      writer.uint32(80).bool(message.archived);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionStepDefinition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionStepDefinition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.errors.push(FunctionError.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.latencyControl = FunctionLatencyControl.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.archived = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionStepDefinition {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      errors: globalThis.Array.isArray(object?.errors) ? object.errors.map((e: any) => FunctionError.fromJSON(e)) : [],
      latencyControl: isSet(object.latencyControl)
        ? FunctionLatencyControl.fromJSON(object.latencyControl)
        : isSet(object.latency_control)
        ? FunctionLatencyControl.fromJSON(object.latency_control)
        : undefined,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
      archived: isSet(object.archived) ? globalThis.Boolean(object.archived) : false,
    };
  },

  toJSON(message: FunctionStepDefinition): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.errors?.length) {
      obj.errors = message.errors.map((e) => FunctionError.toJSON(e));
    }
    if (message.latencyControl !== undefined) {
      obj.latencyControl = FunctionLatencyControl.toJSON(message.latencyControl);
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    if (message.archived !== false) {
      obj.archived = message.archived;
    }
    return obj;
  },

  create(base?: DeepPartial<FunctionStepDefinition>): FunctionStepDefinition {
    return FunctionStepDefinition.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FunctionStepDefinition>): FunctionStepDefinition {
    const message = createBaseFunctionStepDefinition();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.code = object.code ?? "";
    message.errors = object.errors?.map((e) => FunctionError.fromPartial(e)) || [];
    message.latencyControl = (object.latencyControl !== undefined && object.latencyControl !== null)
      ? FunctionLatencyControl.fromPartial(object.latencyControl)
      : undefined;
    message.createdAt = object.createdAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? "";
    message.archived = object.archived ?? false;
    return message;
  },
};

function createBaseCreateFunctionStep(): CreateFunctionStep {
  return { id: "", name: "", position: undefined, function: undefined };
}

export const CreateFunctionStep: MessageFns<CreateFunctionStep> = {
  encode(message: CreateFunctionStep, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.position !== undefined) {
      StepPosition.encode(message.position, writer.uint32(42).fork()).join();
    }
    if (message.function !== undefined) {
      CreateFunctionStepDefinition.encode(message.function, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateFunctionStep {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateFunctionStep();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.position = StepPosition.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.function = CreateFunctionStepDefinition.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateFunctionStep {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      position: isSet(object.position) ? StepPosition.fromJSON(object.position) : undefined,
      function: isSet(object.function) ? CreateFunctionStepDefinition.fromJSON(object.function) : undefined,
    };
  },

  toJSON(message: CreateFunctionStep): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.position !== undefined) {
      obj.position = StepPosition.toJSON(message.position);
    }
    if (message.function !== undefined) {
      obj.function = CreateFunctionStepDefinition.toJSON(message.function);
    }
    return obj;
  },

  create(base?: DeepPartial<CreateFunctionStep>): CreateFunctionStep {
    return CreateFunctionStep.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateFunctionStep>): CreateFunctionStep {
    const message = createBaseCreateFunctionStep();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.position = (object.position !== undefined && object.position !== null)
      ? StepPosition.fromPartial(object.position)
      : undefined;
    message.function = (object.function !== undefined && object.function !== null)
      ? CreateFunctionStepDefinition.fromPartial(object.function)
      : undefined;
    return message;
  },
};

function createBaseUpdateFunctionStep(): UpdateFunctionStep {
  return { name: undefined, position: undefined, function: undefined };
}

export const UpdateFunctionStep: MessageFns<UpdateFunctionStep> = {
  encode(message: UpdateFunctionStep, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    if (message.position !== undefined) {
      StepPosition.encode(message.position, writer.uint32(18).fork()).join();
    }
    if (message.function !== undefined) {
      UpdateFunctionStepDefinition.encode(message.function, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateFunctionStep {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateFunctionStep();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.position = StepPosition.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.function = UpdateFunctionStepDefinition.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateFunctionStep {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      position: isSet(object.position) ? StepPosition.fromJSON(object.position) : undefined,
      function: isSet(object.function) ? UpdateFunctionStepDefinition.fromJSON(object.function) : undefined,
    };
  },

  toJSON(message: UpdateFunctionStep): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.position !== undefined) {
      obj.position = StepPosition.toJSON(message.position);
    }
    if (message.function !== undefined) {
      obj.function = UpdateFunctionStepDefinition.toJSON(message.function);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateFunctionStep>): UpdateFunctionStep {
    return UpdateFunctionStep.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateFunctionStep>): UpdateFunctionStep {
    const message = createBaseUpdateFunctionStep();
    message.name = object.name ?? undefined;
    message.position = (object.position !== undefined && object.position !== null)
      ? StepPosition.fromPartial(object.position)
      : undefined;
    message.function = (object.function !== undefined && object.function !== null)
      ? UpdateFunctionStepDefinition.fromPartial(object.function)
      : undefined;
    return message;
  },
};

function createBaseCreateFunctionStepDefinition(): CreateFunctionStepDefinition {
  return { id: "", name: "", code: "", errors: [], latencyControl: undefined };
}

export const CreateFunctionStepDefinition: MessageFns<CreateFunctionStepDefinition> = {
  encode(message: CreateFunctionStepDefinition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.code !== "") {
      writer.uint32(26).string(message.code);
    }
    for (const v of message.errors) {
      FunctionError.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.latencyControl !== undefined) {
      FunctionCreateLatencyControl.encode(message.latencyControl, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateFunctionStepDefinition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateFunctionStepDefinition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.errors.push(FunctionError.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.latencyControl = FunctionCreateLatencyControl.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateFunctionStepDefinition {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      errors: globalThis.Array.isArray(object?.errors) ? object.errors.map((e: any) => FunctionError.fromJSON(e)) : [],
      latencyControl: isSet(object.latencyControl)
        ? FunctionCreateLatencyControl.fromJSON(object.latencyControl)
        : isSet(object.latency_control)
        ? FunctionCreateLatencyControl.fromJSON(object.latency_control)
        : undefined,
    };
  },

  toJSON(message: CreateFunctionStepDefinition): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.errors?.length) {
      obj.errors = message.errors.map((e) => FunctionError.toJSON(e));
    }
    if (message.latencyControl !== undefined) {
      obj.latencyControl = FunctionCreateLatencyControl.toJSON(message.latencyControl);
    }
    return obj;
  },

  create(base?: DeepPartial<CreateFunctionStepDefinition>): CreateFunctionStepDefinition {
    return CreateFunctionStepDefinition.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateFunctionStepDefinition>): CreateFunctionStepDefinition {
    const message = createBaseCreateFunctionStepDefinition();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.code = object.code ?? "";
    message.errors = object.errors?.map((e) => FunctionError.fromPartial(e)) || [];
    message.latencyControl = (object.latencyControl !== undefined && object.latencyControl !== null)
      ? FunctionCreateLatencyControl.fromPartial(object.latencyControl)
      : undefined;
    return message;
  },
};

function createBaseUpdateFunctionStepDefinition(): UpdateFunctionStepDefinition {
  return { description: undefined, code: undefined, errors: undefined, archived: undefined, latencyControl: undefined };
}

export const UpdateFunctionStepDefinition: MessageFns<UpdateFunctionStepDefinition> = {
  encode(message: UpdateFunctionStepDefinition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.description !== undefined) {
      writer.uint32(26).string(message.description);
    }
    if (message.code !== undefined) {
      writer.uint32(42).string(message.code);
    }
    if (message.errors !== undefined) {
      ErrorsUpdate.encode(message.errors, writer.uint32(50).fork()).join();
    }
    if (message.archived !== undefined) {
      writer.uint32(32).bool(message.archived);
    }
    if (message.latencyControl !== undefined) {
      FunctionCreateLatencyControl.encode(message.latencyControl, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateFunctionStepDefinition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateFunctionStepDefinition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.errors = ErrorsUpdate.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.archived = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.latencyControl = FunctionCreateLatencyControl.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateFunctionStepDefinition {
    return {
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      code: isSet(object.code) ? globalThis.String(object.code) : undefined,
      errors: isSet(object.errors) ? ErrorsUpdate.fromJSON(object.errors) : undefined,
      archived: isSet(object.archived) ? globalThis.Boolean(object.archived) : undefined,
      latencyControl: isSet(object.latencyControl)
        ? FunctionCreateLatencyControl.fromJSON(object.latencyControl)
        : isSet(object.latency_control)
        ? FunctionCreateLatencyControl.fromJSON(object.latency_control)
        : undefined,
    };
  },

  toJSON(message: UpdateFunctionStepDefinition): unknown {
    const obj: any = {};
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.code !== undefined) {
      obj.code = message.code;
    }
    if (message.errors !== undefined) {
      obj.errors = ErrorsUpdate.toJSON(message.errors);
    }
    if (message.archived !== undefined) {
      obj.archived = message.archived;
    }
    if (message.latencyControl !== undefined) {
      obj.latencyControl = FunctionCreateLatencyControl.toJSON(message.latencyControl);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateFunctionStepDefinition>): UpdateFunctionStepDefinition {
    return UpdateFunctionStepDefinition.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateFunctionStepDefinition>): UpdateFunctionStepDefinition {
    const message = createBaseUpdateFunctionStepDefinition();
    message.description = object.description ?? undefined;
    message.code = object.code ?? undefined;
    message.errors = (object.errors !== undefined && object.errors !== null)
      ? ErrorsUpdate.fromPartial(object.errors)
      : undefined;
    message.archived = object.archived ?? undefined;
    message.latencyControl = (object.latencyControl !== undefined && object.latencyControl !== null)
      ? FunctionCreateLatencyControl.fromPartial(object.latencyControl)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
